import React, { Component } from "react";
import AWS from "aws-sdk";
import { branch } from "baobab-react/higher-order";
import autoBind from "react-autobind";
import { saveAs } from "file-saver";
import _ from "lodash";
import {
	Button,
	FormControl,
	FormGroup,
	Col,
	ControlLabel,
	Panel,
	ButtonGroup,
	MenuItem,
	DropdownButton,
	HelpBlock,
	InputGroup,
	Breadcrumb,
	Checkbox
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Modal from "react-responsive-modal";
import ReactPlayer from "react-player";
import ReactAudioPlayer from "react-audio-player";
import { copyToClipboard, readClipboardContents, readPasteEventContents } from "../../utils/clipboard";
import request from "superagent";

import {
	listDrive,
	listDriveMap,
	listDriveForSelectedFolderSilently,
	refreshSelectedDriveFolder,
	moveFile,
	getResourceReference,
	createFolder,
	uploadFile,
	uploadAndOptimizeMediaFile,
	deleteFile,
	deleteDriveObjectsBulk,
	deleteFolder,
	moveFolder,
	copyFile,
	copyFolder,
	filterHierarchy,
	setNodeActive,
	setNodeToggle,
	handleSwitchHierarchyMode,
	getUrlForResource,
	getContent,
	getContentRaw,
	getDriveObjectsAsMap,
	getDriveObject,
	getDriveTreeNodeByPath,
	uploadContent,
	processExistingDriveVideoFile,
	showSpinner,
	setDriveSpinnerProgress,
	hideSpinner,
	selectFolderAndListDrive,
	clearSelectionAndActiveTreeCursor,
	listDriveForSelectedFolder,
	setActiveTreeCursorForDriveGuid,
	getFullObjectPath,
	getUrlForExternalResource,
	toggleDriveSelectedItem,
	clearDriveSelectedItems,
	selectDriveItems
} from "../../actions/drive";
import { showError, showConfirm, showInfoToast, showSuccessToast } from "../../actions/alertActions";
import { getDriveRootPath } from "../../actions/activityActions";
import { AmbifiLoader } from "../shared/";
import ListView from "./views/listView";
import DriveMetadataEditorModal from "../shared/driveMetadataEditorModal";
import DriveMetadataReportModal from "../shared/driveMetadataReportModal";
import { getMediaType } from "../..//utils/mediaUtils";
import {
	getAudioTranscriptionsLambda,
	getAwsTranscribeLambda,
	getImageDescriptionsLambda,
	getPdfResponsesLambda,
	getRekognitionTagsLambda,
	getResponsesCreateLambda
} from "../../ai/aiAssistant";
import {
	getFileTypeIcon,
	validateUrl,
	generateUUID,
	generatePastedImageFileName
} from "../../utils/utils";
import DriveContext from "./driveContext";
import styles from "./drive.module.css";
import { showMediaPreviewModal } from "../../actions/actions";
import env from "../../constants/env";
import { getClient2 } from "../../search/algolia";
import { getSignedDriveResourceUrl } from "../../persistence/s3";

import { getOrgId } from "../../actions/orgsActions";
import { getJwtToken } from "../../actions/user";
import SearchInput from "./searchInput";
import SearchResultsView from "./searchResults";
import { refreshCredentials } from "../../utils/securityUtil";
import ImageEditorModal from "../shared/imageEditorModal";
import VideoProcessingOptionsModal from "../shared/videoProcessingOptionsModal";
import { isAdminToolsEnabled } from "../../utils/featureFlags";
import { isImageToolsEnabledForUrlParams, isMediaToolsEnabledForUrlParams } from "../../utils/mediaTools";
import { isTopLevelFolderFile } from "../../utils/assetFolderImportUtils";
import {
	getDefaultVideoOrientationSummary,
	buildEditedVideoOutputFileName,
	getVideoAudioProcessingLabel,
	getStoredVideoProcessingOptions,
	isVideoAdvancedOptionsEnabled,
	VIDEO_FRAMING_PRESET_OPTIONS,
	VIDEO_ROTATION_PRESET_OPTIONS,
	VIDEO_RESIZE_PRESET_OPTIONS,
	VIDEO_STYLE_FILTER_PRESET_OPTIONS,
	VIDEO_TONE_MAP_PRESET_OPTIONS,
	setStoredVideoProcessingOptions,
	setVideoAdvancedOptionsEnabled,
	summarizeVideoFileOrientations,
	shouldPromptForVideoProcessing,
	isVideoFileCandidate
} from "../../utils/videoProcessingOptions";

const RESERVED_FOLDER_NAMES = ["children", "parent", "path", "this"];
const MAX_METADATA_TITLE_CHARS = 120;
const MAX_METADATA_DESCRIPTION_CHARS = 600;
const MAX_METADATA_TRANSCRIPT_CHARS = 20000;
const MAX_METADATA_TRANSCRIPT_VTT_CHARS = 250000;
const TRANSCRIPT_PROVIDER_AWS_TRANSCRIBE = "aws-transcribe";
const TAGS_PROVIDER_OPENAI = "openai";
const TAGS_PROVIDER_REKOGNITION = "rekognition";
const DRIVE_REINDEX_LAMBDA_FUNCTION_PREFIX = "ambifi-drive-lambda-proxy";

function FieldGroup({ id, label, help, ...props }) {
	return (
		<FormGroup controlId={id}>
			<ControlLabel>{label}</ControlLabel>
			<FormControl {...props} />
			{help && <HelpBlock>{help}</HelpBlock>}
		</FormGroup>
	);
}

function normalizeEditorContentForSave(content) {
	if (_.isNil(content)) {
		return "";
	}

	if (_.isString(content)) {
		return content;
	}

	return JSON.stringify(content, null, 4);
}

function parseDriveReindexLambdaPayload(data) {
	if (!data || !data.Payload) {
		return null;
	}

	let payload = data.Payload;
	if (typeof payload !== "string") {
		const TextDecoderConstructor = typeof window !== "undefined" ? window.TextDecoder : null;
		if (TextDecoderConstructor && payload && payload.buffer) {
			payload = new TextDecoderConstructor("utf-8").decode(payload);
		} else {
			payload = payload.toString();
		}
	}

	if (_.isEmpty(payload)) {
		return null;
	}

	payload = JSON.parse(payload);
	if (typeof payload === "string") {
		payload = JSON.parse(payload);
	}

	return payload;
}

function formatDriveReindexLambdaError(value) {
	if (_.isNil(value)) {
		return "Drive search reindex failed in Lambda.";
	}

	if (_.isString(value)) {
		return value;
	}

	const message = _.get(value, "message") || _.get(value, "errorMessage") || _.get(value, "error");
	if (message && message !== value) {
		return formatDriveReindexLambdaError(message);
	}

	try {
		return JSON.stringify(value);
	} catch (_err) {
		return `${value}`;
	}
}

function getDriveReindexLambdaError(data) {
	try {
		const payload = parseDriveReindexLambdaPayload(data);
		return formatDriveReindexLambdaError(_.get(payload, "errorMessage") || _.get(payload, "errorType") || _.get(payload, "error") || payload);
	} catch (err) {
		return formatDriveReindexLambdaError(err);
	}
}

function getDriveImageEditorSource(resource = null) {
	if (!resource || resource.type !== "file" || getDriveResourceMediaType(resource) !== "image") {
		return null;
	}

	const resourceName = resource.name || "image";
	const resourceStem = `${resourceName}`.replace(/\.[^/.]+$/, "") || "image";

	return {
		url: getUrlForExternalResource(resource),
		label: resourceName,
		defaultBaseName: `${resourceStem}-edited`,
		driveObjectGuid: resource.guid || null,
		originalImageName: resource.name || `${resourceStem}.png`,
		overwriteTargetPath: resource.path || ""
	};
}

function getDriveResourceMediaType(resource = null) {
	if (!resource || resource.type !== "file") {
		return null;
	}

	const metaType = `${_.get(resource, "metaData.type", "")}`.trim().toLowerCase();
	if (["image", "video", "audio", "pdf"].includes(metaType)) {
		return metaType;
	}

	const contentType = `${resource.contentType || resource.mimeType || _.get(resource, "metaData.contentType", "") || _.get(resource, "metaData.mimeType", "")}`.trim().toLowerCase();
	if (contentType.startsWith("image/")) {
		return "image";
	}
	if (contentType.startsWith("video/")) {
		return "video";
	}
	if (contentType.startsWith("audio/")) {
		return "audio";
	}
	if (contentType === "application/pdf") {
		return "pdf";
	}

	const candidates = [
		resource.ext,
		resource.name,
		resource.fileName,
		Array.isArray(resource.path) ? resource.path.join("/") : resource.path
	];
	for (const candidate of candidates) {
		const value = `${candidate || ""}`.trim();
		if (!value) {
			continue;
		}
		const ext = value.includes(".") ? value.split(".").pop() : value;
		const mediaType = getMediaType(ext);
		if (mediaType) {
			return mediaType;
		}
	}

	return null;
}

function getDriveVideoEditorSource(resource = null) {
	if (!resource || resource.type !== "file" || getDriveResourceMediaType(resource) !== "video") {
		return null;
	}

	const resourceName = resource.name || "video.mp4";
	const resourceStem = `${resourceName}`.replace(/\.[^/.]+$/, "") || "video";
	const resourcePath = Array.isArray(resource.path) ? resource.path.join("/") : (resource.path || "");

	return {
		url: getUrlForExternalResource(resource),
		label: resourceName,
		defaultOutputFileName: buildEditedVideoOutputFileName(resourceName),
		driveObjectGuid: resource.guid || null,
		videoFileName: resource.name || `${resourceStem}.mp4`,
		overwriteTargetPath: resourcePath,
		resource
	};
}

class Drive extends Component {
	constructor(props) {
		super(props);
		this.currentEditor = React.createRef();
		this.pasteClipboardTarget = React.createRef();
		this.driveComponentId = generateUUID();
		this.videoProcessingPollTimeout = null;
		this.videoProcessingPollInFlight = false;
		this.pasteClipboardDocumentListening = false;
		this.state = {
			cursor: null,
			data: null,
			showCreateFolderModal: false,
			showPasteClipboardModal: false,
			pasteClipboardFileName: "",
			pasteClipboardText: "",
			pasteClipboardContentType: "text/plain",
			pasteClipboardFile: null,
			pasteClipboardPreviewUrl: "",
			pasteClipboardWaitingForPaste: false,
			pasteClipboardPasteError: "",
			pasteClipboardSaving: false,
			showUploadFileModal: false,
			rename: {},
			editorState: {
				content: "",
				validity: { valid: true, error: null }
			},
			filter: props.filter ? props.filter : "",
			driveInitialized: false,

				// new features
				showAllLabels: false,
				showDriveMultiselect: false,
				isSearchMode: false,
				searchResetToken: 0,
				searchImageFiles: [],
				searchVisibleItems: [],
				showGallery: false,
				galleryIndex: 0,
				galleryImages: [],
				selectedNode: null,
				showTagsModal: false,
				metadataEditorTarget: null,
				metadataGalleryItems: [],
				showMetadataReportModal: false,
				metadataReportRows: [],
				metadataReportLoading: false,
				metadataReportResourceOverrides: {},
				metadataReportScope: "current",
				metadataReportIncludeSubfolders: false,
				metadataReportIncludeFilesWithoutMetadata: false,
				tagsEditorInput: "",
				tagsEditorPrimary: [],
				tagsEditorSecondary: [],
				tagsEditorSaving: false,
				tagsEditorLoadingSuggestions: false,
				metadataEditorTitle: "",
				metadataEditorDescription: "",
				metadataEditorTranscript: "",
				metadataEditorTranscriptVtt: "",
				showImageEditorModal: false,
				imageEditorTarget: null,
				showVideoEditorModal: false,
				videoEditorTarget: null,
				metadataGeneratingField: "",
				metadataTranscriptProvider: TRANSCRIPT_PROVIDER_AWS_TRANSCRIBE,
				metadataTagsProvider: TAGS_PROVIDER_OPENAI,
				showAdvancedVideoOptions: isVideoAdvancedOptionsEnabled(),
				showVideoProcessingOptionsModal: false,
				pendingUploadFiles: [],
				pendingUploadOrientationSummary: getDefaultVideoOrientationSummary(),
				showUploadFolderOptionsModal: false,
				uploadFolderRecursive: true,
				processingUploads: {},
				showDeleteOptionsModal: false,
				deleteDialogTarget: null,
				deleteDialogSelectionPlan: null,
				deleteDialogRelatedItems: [],
				deleteDialogDeleteRelated: true,
				showShareFallbackModal: false,
				shareFallbackUrl: "",
				shareFallbackDownloadUrl: "",
				shareFallbackFileName: "",
				shareFallbackMimeType: "",
				driveReindexing: false
			};
		autoBind(this);
	}

	toggleShowAllLabels() {
		this.setState((prev) => ({ showAllLabels: !prev.showAllLabels }));
	}

	handleToggleDriveMultiselect() {
		this.setState((prev) => {
			const showDriveMultiselect = !prev.showDriveMultiselect;
			if (!showDriveMultiselect) {
				clearDriveSelectedItems();
			}
			return { showDriveMultiselect };
		});
	}

	openGallery(startIndex = 0) {
		const allImages = this.getVisibleMediaFiles();
		this.setState({
			showGallery: true,
			galleryIndex: Math.max(0, Math.min(startIndex, Math.max(0, allImages.length - 1))),
			galleryImages: allImages
		});
	}

	getVisibleMediaFiles() {
		const { hierarchy } = this.props;
		const { isSearchMode, searchImageFiles } = this.state;

		const allowed = new Set(["image", "video", "audio", "pdf"]);
		const source = isSearchMode ? (searchImageFiles ?? []) : ((hierarchy && hierarchy.children) || []);

		return source.filter((node) => {
			if (!node || node.type !== "file") { return false; }
			try {
				const t = node?.ext ? getMediaType(node.ext) : null;
				return allowed.has(t);
			} catch {
				return false;
			}
		});
	}

	handleNextImage = () => {
		this.setState((prev) => {
			const len = prev.galleryImages.length || 0;
			if (!len) { return null; }
			return { galleryIndex: (prev.galleryIndex + 1) % len };
		});
	};

	handlePrevImage = () => {
		this.setState((prev) => {
			const len = prev.galleryImages.length || 0;
			if (!len) { return null; }
			return { galleryIndex: (prev.galleryIndex - 1 + len) % len };
		});
	};

	onToggle(node, toggled) {
		const { cursor } = this.state;
		const { okCancel } = this.props;

		if (node.children) {
			const _toggled = (!node.hasOwnProperty("allowCollapse") || node.allowCollapse) ? toggled : true;
			setNodeToggle(node.guid, _toggled);
		}
		if (cursor && cursor !== node) {
			setNodeActive(cursor.guid, false);
		}
		setNodeActive(node.guid, true);

		if (!okCancel) {
			if (node.type === "file" && this.props.onFileSelected) {
				this.props.onFileSelected(node);
			} else if (node.type === "folder" && this.props.onFolderSelected) {
				this.props.onFolderSelected(node);
			} else if (this.props.onItemSelected) {
				this.props.onItemSelected(getResourceReference(node));
			}
		}
		this.setState({ cursor: node });
	}

	onSelect(node) {
		const { cursor } = this.state;
		const { okCancel } = this.props;

		clearSelectionAndActiveTreeCursor();

		if (cursor && cursor !== node) {
			setNodeActive(cursor.guid, false, null);
		}
		setNodeActive(node.guid, true, node);

		if (!okCancel) {
			if (node.type === "file" && this.props.onFileSelected) {
				this.props.onFileSelected(node);
			} else if (node.type === "folder" && this.props.onFolderSelected) {
				this.props.onFolderSelected(node);
			} else if (this.props.onItemSelected) {
				this.props.onItemSelected(getResourceReference(node));
			}
		}

		this.setState({ cursor: node, selectedNode: node });
	}

	getSelectedDriveItems() {
		const selectedItems = _.get(this.props.driveSelection, "items", []);
		return Array.isArray(selectedItems) ? selectedItems : [];
	}

	getSelectedDriveKeyMap(selectedItems = this.getSelectedDriveItems()) {
		return selectedItems.reduce((selectedKeys, item) => {
			if (item && item.key) {
				selectedKeys[item.key] = true;
			}
			return selectedKeys;
		}, {});
	}

	isDriveItemSelectionAvailable(node = null) {
		if (!node || (node.type !== "file" && node.type !== "folder")) {
			return false;
		}
		if (node.allowDelete === false) {
			return false;
		}
		if (node.type === "file") {
			return !!node.guid;
		}
		return !!(node.fullPath || node.path);
	}

	handleToggleDriveItemSelected(node) {
		if (!this.isDriveItemSelectionAvailable(node)) {
			return;
		}
		toggleDriveSelectedItem(node);
	}

	handleClearDriveSelection() {
		clearDriveSelectedItems();
	}

	getVisibleDriveSelectionItems() {
		const sourceItems = this.state.isSearchMode
			? (this.state.searchVisibleItems || [])
			: _.get(this.props.hierarchy, "children", []);
		return (sourceItems || []).filter(this.isDriveItemSelectionAvailable);
	}

	handleSelectVisibleDriveItems() {
		selectDriveItems(this.getVisibleDriveSelectionItems());
	}

	async onDblClick(node) {
		if (node.type === "folder") {
			this.handleSelectFolderAndListDrive(node.fullPath);
		}
	}

	onFilterChange(e) {
		const filter = e.target.value.trim();
		this.setState({ filter });
		filterHierarchy(filter);
	}

	handleStartMove() {
		const { cursor } = this.state;
		const { hierarchy } = this.props;
		this.setState({
			moving: true,
			moveInfo: {
				origin: _.cloneDeep(cursor),
				originParentFolderPath: hierarchy.fullPath
			}
		});
	}

	handleStartCopy() {
		const { cursor } = this.state;
		const { hierarchy } = this.props;
		this.setState({
			copying: true,
			copyInfo: {
				origin: _.cloneDeep(cursor),
				originParentFolderPath: hierarchy.fullPath
			}
		});
	}

	handleCancelMove() {
		this.setState({ moving: false, moveInfo: null });
	}

	handleCancelCopy() {
		this.setState({ copying: false, copyInfo: null });
	}

	handleMove() {
		const { moveInfo } = this.state;
		const { hierarchy } = this.props;
		if (hierarchy.type === "folder") {
			if (moveInfo.origin.type === "file") {
				const destinationPath = _.concat(hierarchy.path, moveInfo.origin.fileName).join("/");
				moveFile(moveInfo.origin.guid, destinationPath)
					.then(this.handleCancelMove)
					.catch((err) => showError("Move File", `Failed to move file ${moveInfo.origin.guid} to ${destinationPath}, reason: ${err}`));
			} else {
				const destinationPath = _.concat(hierarchy.path, moveInfo.origin.name).join("/");
				moveFolder(moveInfo.origin, destinationPath)
					.then(this.handleCancelMove)
					.catch((err) => showError("Move Folder", `Failed to move folder ${moveInfo.origin.guid} to ${destinationPath}, reason: ${err}`));
			}
		} else {
			showError("Move File", "Must be within a folder as a destination");
		}
	}

	handleCopy() {
		const { copyInfo } = this.state;
		const { hierarchy } = this.props;
		if (hierarchy.type === "folder") {
			if (copyInfo.origin.type === "file") {
				const destinationPath = _.concat(hierarchy.path, copyInfo.origin.fileName).join("/");
				copyFile(copyInfo.origin.guid, destinationPath)
					.then(this.handleCancelCopy)
					.catch((err) => showError("Copy File", `Failed to copy file ${copyInfo.origin.guid} to ${destinationPath}, reason: ${err}`));
			} else {
				const destinationPath = _.concat(hierarchy.path, copyInfo.origin.name).join("/");
				copyFolder(copyInfo.origin, destinationPath)
					.then(this.handleCancelCopy)
					.catch((err) => showError("Copy Folder", `Failed to copy folder ${copyInfo.origin.guid} to ${destinationPath}, reason: ${err}`));
			}
		} else {
			showError("Copy File", "Must be within a folder as a destination");
		}
	}

	handleShowCreateFolderModal() {
		this.setState({ showCreateFolderModal: true });
	}
	handleHideCreateFolderModal() {
		this.setState({ showCreateFolderModal: false });
	}
	handleCancelAddFolder() {
		this.handleHideCreateFolderModal();
		this.setState({ createFolder: null });
	}

	handleChangeCreateFolderName(e) {
		let name = e.target.value;
		let validationError = null;
		let validationState = "success";
		if (name && _.indexOf(RESERVED_FOLDER_NAMES, _.toLower(name)) !== -1) {
			validationState = "error";
			validationError = `This is a reserved name, unable to name folder '${name}'`;
			name = null;
		}
		this.setState({
			createFolder: _.assign({}, this.state.createFolder, {
				name,
				validationState,
				validationError
			})
		});
	}

	handleAddFolder() {
		const { createFolder: createFolderInfo } = this.state;
		const { hierarchy } = this.props;

		if (hierarchy.type === "folder") {
			createFolder(`${hierarchy && hierarchy.path ? hierarchy.path.join("/") + "/" : ""}${createFolderInfo.name}/`)
				.then(this.handleCancelAddFolder)
				.catch((err) => showError("Create Folder", "An error occurred while attempting to create the folder. Error: " + err));
		} else {
			showError("Create Folder", "Must select a folder to create a new folder in.");
		}
	}

	getDriveReindexLambdaFunctionName() {
		const stage = `${_.get(env, "stage", "dev")}`.trim().toLowerCase();
		return `${DRIVE_REINDEX_LAMBDA_FUNCTION_PREFIX}-${stage === "prod" ? "prod" : "dev"}`;
	}

	handleReindexDriveSearch() {
		if (this.state.driveReindexing) {
			return;
		}

		const orgId = getOrgId();
		if (_.isEmpty(orgId)) {
			showError("Reindex Drive", "Unable to reindex Drive search without a selected organization.");
			return;
		}

		showConfirm(`Rebuild the Drive search index for org ${orgId} using ${this.getDriveReindexLambdaFunctionName()}?`, "Reindex Drive", this.invokeDriveSearchReindex);
	}

	async invokeDriveSearchReindex() {
		if (this.state.driveReindexing) {
			return;
		}

		const orgId = getOrgId();
		if (_.isEmpty(orgId)) {
			showError("Reindex Drive", "Unable to reindex Drive search without a selected organization.");
			return;
		}

		this.setState({ driveReindexing: true });
		try {
			showInfoToast("Reindexing Drive search. This can take a few minutes.", { autoClose: 5000 });
			await refreshCredentials();

			const lambda = new AWS.Lambda({
				region: _.get(env, "aws.defaultRegion", "us-east-1"),
				apiVersion: "2015-03-31",
				httpOptions: {
					timeout: 900000
				}
			});
			const data = await lambda.invoke({
				FunctionName: this.getDriveReindexLambdaFunctionName(),
				InvocationType: "RequestResponse",
				LogType: "None",
				Payload: JSON.stringify({
					method: "indexForSearch",
					orgId
				})
			}).promise();

			if (data && data.FunctionError) {
				throw new Error(getDriveReindexLambdaError(data));
			}

			const payload = parseDriveReindexLambdaPayload(data);
			if (payload && (payload.error || payload.errorMessage)) {
				throw new Error(formatDriveReindexLambdaError(payload.error || payload.errorMessage));
			}

			const objectCount = _.get(payload, "objectCount");
			const objectCountMessage = _.isNumber(objectCount) ? ` Indexed ${objectCount.toLocaleString()} Drive record${objectCount === 1 ? "" : "s"}.` : "";
			showSuccessToast(`Drive search reindex completed.${objectCountMessage}`);
		} catch (err) {
			showError("Reindex Drive", formatDriveReindexLambdaError(err));
		} finally {
			this.setState({ driveReindexing: false });
		}
	}

	getPastedClipboardDefaults(text = "") {
		const trimmedText = text.trim();
		if (trimmedText) {
			try {
				const parsedJson = JSON.parse(trimmedText);
				return {
					fileName: "clipboard.json",
					content: JSON.stringify(parsedJson, null, 2),
					contentType: "application/json"
				};
			} catch (_err) {
				// Plain text clipboard content is still useful as a Drive file.
			}
		}

		return {
			fileName: "clipboard.txt",
			content: text,
			contentType: "text/plain"
		};
	}

	isPasteClipboardImageContentType(contentType = "") {
		return `${contentType || ""}`.toLowerCase().indexOf("image/") === 0;
	}

	getPasteClipboardExtensionForContentType(contentType = "") {
		const normalizedContentType = `${contentType || ""}`.toLowerCase();
		if (normalizedContentType === "application/json") {
			return "json";
		}
		if (normalizedContentType === "image/jpeg" || normalizedContentType === "image/jpg") {
			return "jpg";
		}
		if (normalizedContentType === "image/gif") {
			return "gif";
		}
		if (normalizedContentType === "image/webp") {
			return "webp";
		}
		if (normalizedContentType === "image/bmp") {
			return "bmp";
		}
		if (normalizedContentType === "image/svg+xml") {
			return "svg";
		}
		if (this.isPasteClipboardImageContentType(normalizedContentType)) {
			return "png";
		}
		return "txt";
	}

	getDefaultPastedClipboardImageFileName(file = null) {
		const contentType = `${file && file.type ? file.type : "image/png"}`.trim() || "image/png";
		const extension = this.getPasteClipboardExtensionForContentType(contentType);
		const fileName = `${file && file.name ? file.name : ""}`.trim();
		if (
			fileName &&
			!/^(image|clipboard-image)\.(png|jpe?g|gif|webp|bmp|svg)$/i.test(fileName)
		) {
			return fileName;
		}
		return generatePastedImageFileName(extension);
	}

	normalizePastedClipboardFileName(fileName, contentType) {
		const name = `${fileName || ""}`.trim();
		if (_.isEmpty(name)) {
			return "";
		}

		const hasExtension = /\.[^/.\\]+$/.test(name);
		if (hasExtension) {
			return name;
		}

		return `${name}.${this.getPasteClipboardExtensionForContentType(contentType)}`;
	}

	validatePastedClipboardFileName(fileName) {
		const normalizedName = this.normalizePastedClipboardFileName(fileName, this.state.pasteClipboardContentType);
		if (_.isEmpty(normalizedName)) {
			return "Enter a file name.";
		}
		if (/[\\/]/.test(normalizedName)) {
			return "File name cannot contain slashes.";
		}
		return null;
	}

	hasPastedClipboardPayload() {
		return !!this.state.pasteClipboardFile || !_.isEmpty(`${this.state.pasteClipboardText || ""}`);
	}

	revokePasteClipboardPreviewUrl() {
		if (this.state.pasteClipboardPreviewUrl && typeof URL !== "undefined" && URL.revokeObjectURL) {
			URL.revokeObjectURL(this.state.pasteClipboardPreviewUrl);
		}
	}

	focusPasteClipboardTarget() {
		setTimeout(() => {
			const target = this.pasteClipboardTarget && this.pasteClipboardTarget.current;
			if (target && typeof target.focus === "function") {
				target.focus();
			}
		});
	}

	openPastedClipboardFile(file) {
		if (!file || !this.isPasteClipboardImageContentType(file.type)) {
			return false;
		}

		this.revokePasteClipboardPreviewUrl();
		const contentType = `${file.type || "image/png"}`.trim() || "image/png";
		const fileName = this.normalizePastedClipboardFileName(this.getDefaultPastedClipboardImageFileName(file), contentType);
		const previewUrl = typeof URL !== "undefined" && URL.createObjectURL ? URL.createObjectURL(file) : "";
		this.setState({
			showPasteClipboardModal: true,
			pasteClipboardFileName: fileName,
			pasteClipboardText: "",
			pasteClipboardContentType: contentType,
			pasteClipboardFile: file,
			pasteClipboardPreviewUrl: previewUrl,
			pasteClipboardWaitingForPaste: false,
			pasteClipboardPasteError: "",
			pasteClipboardSaving: false
		});
		return true;
	}

	openPastedClipboardText(text = "") {
		this.revokePasteClipboardPreviewUrl();
		const defaults = this.getPastedClipboardDefaults(text);
		this.setState({
			showPasteClipboardModal: true,
			pasteClipboardFileName: defaults.fileName,
			pasteClipboardText: defaults.content,
			pasteClipboardContentType: defaults.contentType,
			pasteClipboardFile: null,
			pasteClipboardPreviewUrl: "",
			pasteClipboardWaitingForPaste: false,
			pasteClipboardPasteError: "",
			pasteClipboardSaving: false
		});
	}

	openPasteClipboardWaitingModal() {
		this.revokePasteClipboardPreviewUrl();
		this.setState({
			showPasteClipboardModal: true,
			pasteClipboardFileName: "",
			pasteClipboardText: "",
			pasteClipboardContentType: "text/plain",
			pasteClipboardFile: null,
			pasteClipboardPreviewUrl: "",
			pasteClipboardWaitingForPaste: true,
			pasteClipboardPasteError: "",
			pasteClipboardSaving: false
		}, this.focusPasteClipboardTarget);
	}

	handlePasteClipboardEvent(event) {
		if (!this.state.showPasteClipboardModal || this.state.pasteClipboardSaving) {
			return;
		}

		const targetId = `${event && event.target && event.target.id ? event.target.id : ""}`;
		if (targetId === "drive-paste-clipboard-file-name") {
			return;
		}

		const clipboard = readPasteEventContents(event);
		const imageFile = Array.isArray(clipboard.files)
			? clipboard.files.find((file) => file && this.isPasteClipboardImageContentType(file.type))
			: null;
		if (imageFile) {
			event.preventDefault();
			this.openPastedClipboardFile(imageFile);
			return;
		}

		if (!_.isEmpty(`${clipboard.text || ""}`)) {
			event.preventDefault();
			this.openPastedClipboardText(clipboard.text);
			return;
		}

		this.setState({
			pasteClipboardPasteError: "No image or text data was found in the pasted clipboard content."
		});
	}

	addPasteClipboardDocumentListener() {
		if (this.pasteClipboardDocumentListening || typeof document === "undefined") {
			return;
		}
		document.addEventListener("paste", this.handlePasteClipboardEvent);
		this.pasteClipboardDocumentListening = true;
	}

	removePasteClipboardDocumentListener() {
		if (!this.pasteClipboardDocumentListening || typeof document === "undefined") {
			return;
		}
		document.removeEventListener("paste", this.handlePasteClipboardEvent);
		this.pasteClipboardDocumentListening = false;
	}

	async handleShowPasteClipboardModal() {
		const { hierarchy } = this.props;
		if (!hierarchy || hierarchy.type !== "folder" || (hierarchy.hasOwnProperty("allowCreate") && !hierarchy.allowCreate)) {
			showError("Paste Clipboard", "Select a folder that allows new files before pasting clipboard content.");
			return;
		}

		const clipboard = await readClipboardContents();
		const imageFile = Array.isArray(clipboard.files)
			? clipboard.files.find((file) => file && this.isPasteClipboardImageContentType(file.type))
			: null;
		if (imageFile) {
			this.openPastedClipboardFile(imageFile);
			return;
		}

		if (!_.isEmpty(`${clipboard.text || ""}`)) {
			this.openPastedClipboardText(clipboard.text);
			return;
		}

		this.openPasteClipboardWaitingModal();
	}

	handleHidePasteClipboardModal() {
		if (this.state.pasteClipboardSaving) {
			return;
		}

		this.removePasteClipboardDocumentListener();
		this.revokePasteClipboardPreviewUrl();
		this.setState({
			showPasteClipboardModal: false,
			pasteClipboardFileName: "",
			pasteClipboardText: "",
			pasteClipboardContentType: "text/plain",
			pasteClipboardFile: null,
			pasteClipboardPreviewUrl: "",
			pasteClipboardWaitingForPaste: false,
			pasteClipboardPasteError: "",
			pasteClipboardSaving: false
		});
	}

	handleChangePasteClipboardFileName(event) {
		this.setState({ pasteClipboardFileName: event.target.value });
	}

	handleCreatePastedClipboardFile() {
		const { hierarchy } = this.props;
		const { pasteClipboardFileName, pasteClipboardText, pasteClipboardContentType, pasteClipboardFile, pasteClipboardSaving } = this.state;
		if (pasteClipboardSaving) {
			return;
		}

		const validationError = this.validatePastedClipboardFileName(pasteClipboardFileName);
		if (validationError) {
			showError("Paste Clipboard", validationError);
			return;
		}
		if (!hierarchy || hierarchy.type !== "folder") {
			showError("Paste Clipboard", "Select a folder before creating the pasted file.");
			return;
		}
		if (!pasteClipboardFile && _.isEmpty(`${pasteClipboardText || ""}`)) {
			showError("Paste Clipboard", "Paste image or text content before creating the file.");
			return;
		}

		const fileName = this.normalizePastedClipboardFileName(pasteClipboardFileName, pasteClipboardContentType);
		const folderPath = hierarchy.path ? hierarchy.path.join("/") : "";
		const path = folderPath ? `${folderPath}/${fileName}` : fileName;
		const uploadPromise = pasteClipboardFile
			? uploadFile(folderPath, pasteClipboardFile, null, false, {
				fileName,
				metaData: {
					type: this.isPasteClipboardImageContentType(pasteClipboardContentType) ? "image" : "file",
					contentType: pasteClipboardContentType
				}
			})
			: uploadContent(path, pasteClipboardText, pasteClipboardContentType);

		this.setState({ pasteClipboardSaving: true });
		uploadPromise
			.then(() => {
				this.removePasteClipboardDocumentListener();
				this.revokePasteClipboardPreviewUrl();
				this.setState({
					showPasteClipboardModal: false,
					pasteClipboardFileName: "",
					pasteClipboardText: "",
					pasteClipboardContentType: "text/plain",
					pasteClipboardFile: null,
					pasteClipboardPreviewUrl: "",
					pasteClipboardWaitingForPaste: false,
					pasteClipboardPasteError: "",
					pasteClipboardSaving: false
				});
				showSuccessToast(`Created ${fileName}`);
			})
			.catch((err) => {
				this.setState({ pasteClipboardSaving: false });
				showError("Paste Clipboard", `Failed to create ${fileName}. ${err}`);
			});
	}

	clearUploadInputs() {
		["drive-upload", "drive-folder-upload"].forEach((id) => {
			const input = document.getElementById(id);
			if (input) {
				input.value = "";
			}
		});
	}

	handleSelectUploadFile(event) {
		const inputEl = event?.target;
		const files = inputEl?.files;

		if (!files || files.length === 0) {
			showError("Upload File", "No files selected.");
			return;
		}

		const { hierarchy } = this.props;

		if (hierarchy.type !== "folder") {
			document.getElementById("drive-upload").value = "";
			showError("Upload File", "Need to select a folder and specify a file to upload");
			return;
		}

		const fileArray = Array.from(files);
			const hasVideoUploadPrompt = isMediaToolsEnabledForUrlParams(this.props.urlParams) && fileArray.some((file) => shouldPromptForVideoProcessing({
				file,
				showAdvanced: this.state.showAdvancedVideoOptions,
				skipOptimization: false
			}));

			if (hasVideoUploadPrompt) {
				this.queueVideoProcessingOptions(fileArray);
				return;
			}

		this.uploadSelectedFiles(fileArray);
	}

	handleShowUploadFolder() {
		const { hierarchy } = this.props;
		if (hierarchy.type !== "folder") {
			showError("Upload Folder", "Need to select a folder before uploading a folder.");
			return;
		}

		this.setState({
			showUploadFolderOptionsModal: true
		});
	}

	handleCloseUploadFolderOptionsModal() {
		this.clearUploadInputs();
		this.setState({
			showUploadFolderOptionsModal: false
		});
	}

	handleToggleUploadFolderRecursive(event) {
		this.setState({
			uploadFolderRecursive: !!_.get(event, "target.checked", false)
		});
	}

	handleBrowseUploadFolder() {
		const input = document.getElementById("drive-folder-upload");
		if (input) {
			input.click();
		}
	}

	handleSelectUploadFolder(event) {
		const files = _.get(event, "target.files", null);
		if (!files || files.length === 0) {
			showError("Upload Folder", "No folder files selected.");
			return;
		}

		const { hierarchy } = this.props;
		if (hierarchy.type !== "folder") {
			this.clearUploadInputs();
			showError("Upload Folder", "Need to select a folder before uploading a folder.");
			return;
		}

		const fileArray = Array.from(files);
		const filteredFiles = this.state.uploadFolderRecursive ? fileArray : fileArray.filter(isTopLevelFolderFile);
		if (filteredFiles.length === 0) {
			this.clearUploadInputs();
			showError("Upload Folder", "No files matched the selected folder options.");
			return;
		}

		const hasVideoUploadPrompt = isMediaToolsEnabledForUrlParams(this.props.urlParams) && filteredFiles.some((file) => shouldPromptForVideoProcessing({
			file,
			showAdvanced: this.state.showAdvancedVideoOptions,
			skipOptimization: false
		}));

		this.setState({
			showUploadFolderOptionsModal: false
		});

		if (hasVideoUploadPrompt) {
			this.queueVideoProcessingOptions(filteredFiles);
			return;
		}

		this.uploadSelectedFiles(filteredFiles);
	}

	handleToggleVideoAdvancedOptions(event) {
		const enabled = _.isBoolean(event) ? event : !!_.get(event, "target.checked", false);
		setVideoAdvancedOptionsEnabled(enabled);
		this.setState({
			showAdvancedVideoOptions: enabled
		});
	}

	handleToggleAdvancedVideoUploadOptions() {
		this.handleToggleVideoAdvancedOptions(!this.state.showAdvancedVideoOptions);
	}

	async queueVideoProcessingOptions(fileArray = []) {
		let orientationSummary = getDefaultVideoOrientationSummary(Array.isArray(fileArray) ? fileArray.length : 0);
		try {
			orientationSummary = await summarizeVideoFileOrientations(fileArray);
		} catch (err) {
			console.warn("Unable to detect video orientation for upload options", err);
		}

		this.setState({
			showVideoProcessingOptionsModal: true,
			pendingUploadFiles: Array.from(fileArray || []),
			pendingUploadOrientationSummary: orientationSummary
		});
	}

	handleCloseVideoProcessingOptionsModal() {
		this.clearUploadInputs();
		this.setState({
			showVideoProcessingOptionsModal: false,
			pendingUploadFiles: [],
			pendingUploadOrientationSummary: getDefaultVideoOrientationSummary()
		});
	}

	handleContinueVideoProcessingOptionsModal(options) {
		const pendingUploadFiles = Array.isArray(this.state.pendingUploadFiles) ? this.state.pendingUploadFiles : [];
		setStoredVideoProcessingOptions(options);
		this.setState({
			showVideoProcessingOptionsModal: false,
			pendingUploadFiles: [],
			pendingUploadOrientationSummary: getDefaultVideoOrientationSummary()
		}, () => {
			if (pendingUploadFiles.length > 0) {
				this.uploadSelectedFiles(pendingUploadFiles, options);
			}
		});
	}

	getVideoProcessingOptionLabel(options = [], value = "", fallbackLabel = "") {
		const normalizedValue = `${value || ""}`.trim();
		const match = options.find((option) => option && option.value === normalizedValue);
		return match && match.label ? match.label : fallbackLabel;
	}

	describeVideoProcessingOptions(options = null) {
		if (!options || typeof options !== "object") {
			return "";
		}

		const details = [];
		const framingLabel = this.getVideoProcessingOptionLabel(VIDEO_FRAMING_PRESET_OPTIONS, options.framingPreset, "");
		if (framingLabel && options.framingPreset && options.framingPreset !== "source") {
			details.push(framingLabel);
		}

		const resizeLabel = this.getVideoProcessingOptionLabel(VIDEO_RESIZE_PRESET_OPTIONS, options.resizePreset, "");
		if (resizeLabel && options.resizePreset && options.resizePreset !== "source") {
			details.push(resizeLabel);
		}

		const styleFilterLabel = this.getVideoProcessingOptionLabel(VIDEO_STYLE_FILTER_PRESET_OPTIONS, options.styleFilterPreset, "");
		if (styleFilterLabel && options.styleFilterPreset && options.styleFilterPreset !== "none") {
			details.push(styleFilterLabel);
		}

		const rotationLabel = this.getVideoProcessingOptionLabel(VIDEO_ROTATION_PRESET_OPTIONS, options.rotationPreset, "");
		if (rotationLabel && options.rotationPreset && options.rotationPreset !== "source") {
			details.push(rotationLabel);
		}

		if (options.autoCropBlackBars === true) {
			details.push("Auto crop black bars");
		}

		const audioLabel = getVideoAudioProcessingLabel(options);
		if (audioLabel) {
			details.push(audioLabel);
		}

		const toneMapLabel = this.getVideoProcessingOptionLabel(VIDEO_TONE_MAP_PRESET_OPTIONS, options.hdrToneMapPreset, "");
		if (toneMapLabel) {
			details.push(toneMapLabel);
		}

		if (Number(options.trimStartSeconds) > 0 || Number(options.trimDurationSeconds) > 0) {
			details.push(`Trim ${Number(options.trimStartSeconds || 0).toFixed(1)}s${Number(options.trimDurationSeconds) > 0 ? ` + ${Number(options.trimDurationSeconds).toFixed(1)}s` : " to end"}`);
		}

		if (options.createThumbnailArtifact === true) {
			details.push("Create JPEG thumbnail artifact");
			if (Number(options.thumbnailFrameSeconds) > 0) {
				details.push(`Thumbnail at ${Number(options.thumbnailFrameSeconds).toFixed(1)}s`);
			}
		}

		return details.join(" | ");
	}

	registerPendingVideoProcessingUpload(uploadResponse, file, videoProcessingOptions = null) {
		if (!uploadResponse || !uploadResponse.guid || !isVideoFileCandidate(file)) {
			return;
		}

		const pendingEntry = {
			guid: uploadResponse.guid,
			path: uploadResponse.path || "",
			name: uploadResponse.fileName || file.name || "video",
			startRevision: Number(uploadResponse.revision) || 0,
			masterPath: `${uploadResponse.masterPath || ""}`.trim(),
			sourceFileName: `${file && file.name ? file.name : ""}`.trim(),
			description: this.describeVideoProcessingOptions(videoProcessingOptions),
			startedAt: Date.now()
		};

		this.setState((prevState) => ({
			processingUploads: {
				...(prevState.processingUploads || {}),
				[pendingEntry.guid]: pendingEntry
			}
		}), this.scheduleVideoProcessingPoll);
	}

	stopVideoProcessingPoll() {
		if (this.videoProcessingPollTimeout) {
			clearTimeout(this.videoProcessingPollTimeout);
			this.videoProcessingPollTimeout = null;
		}
		this.videoProcessingPollInFlight = false;
	}

	scheduleVideoProcessingPoll(delay = 4000) {
		const processingUploads = this.state.processingUploads && typeof this.state.processingUploads === "object"
			? this.state.processingUploads
			: {};
		if (_.isEmpty(processingUploads) || this.videoProcessingPollTimeout) {
			return;
		}

		this.videoProcessingPollTimeout = setTimeout(() => {
			this.videoProcessingPollTimeout = null;
			this.pollVideoProcessingUploads();
		}, delay);
	}

	async pollVideoProcessingUploads() {
		const processingUploads = this.state.processingUploads && typeof this.state.processingUploads === "object"
			? this.state.processingUploads
			: {};
		if (_.isEmpty(processingUploads) || this.videoProcessingPollInFlight) {
			return;
		}

		this.videoProcessingPollInFlight = true;
		try {
			await listDriveMap();
			const latestDriveObjects = getDriveObjectsAsMap();
			const nextProcessingUploads = { ...processingUploads };
			let completedCount = 0;

			_.forEach(processingUploads, (entry, guid) => {
				const latest = latestDriveObjects[guid];
				if (!latest) {
					return;
				}

				const latestRevision = Number(latest.revision) || 0;
				if (latestRevision > (Number(entry.startRevision) || 0)) {
					delete nextProcessingUploads[guid];
					completedCount++;
				}
			});

			if (completedCount > 0) {
				await listDriveForSelectedFolderSilently();
				const activeGuid = _.get(this.state, "cursor.guid") || this.props.lastActiveGuid || _.get(this.props, "activeCursor.guid");
				if (activeGuid) {
					setActiveTreeCursorForDriveGuid(activeGuid);
				}
			}

			this.setState({
				processingUploads: nextProcessingUploads
			}, () => {
				if (!_.isEmpty(this.state.processingUploads)) {
					this.scheduleVideoProcessingPoll();
				}
			});
		} catch (error) {
			console.warn("Unable to refresh Drive video processing status", error);
			this.scheduleVideoProcessingPoll(6000);
		} finally {
			this.videoProcessingPollInFlight = false;
		}
	}

	getPendingVideoProcessingForNode(node = null) {
		const guid = `${node && node.guid ? node.guid : ""}`.trim();
		if (!guid) {
			return null;
		}

		const processingUploads = this.state.processingUploads && typeof this.state.processingUploads === "object"
			? this.state.processingUploads
			: {};
		return processingUploads[guid] || null;
	}

	uploadSelectedFiles(fileArray = [], videoProcessingOptions = null) {
		const files = Array.isArray(fileArray) ? fileArray : [];

		if (files.length === 0) {
			showError("Upload File", "No files selected.");
			return;
		}

		const errors = [];
		const { hierarchy } = this.props;

		if (hierarchy.type !== "folder") {
			document.getElementById("drive-upload").value = "";
			showError("Upload File", "Need to select a folder and specify a file to upload");
			return;
		}

		showSpinner();
		const totalFiles = files.length;
		const totalBytes = files.reduce((total, file) => total + (Number(file && file.size) || 0), 0);
		const loadedByIndex = {};
		const formatCount = (value) => Number(value || 0).toLocaleString();
		let completedFiles = 0;
		let failedFiles = 0;
		let lastProgressRenderAt = 0;
		const renderUploadProgress = (status = "uploading", force = false) => {
			const now = Date.now();
			if (!force && now - lastProgressRenderAt < 250) {
				return;
			}
			lastProgressRenderAt = now;

			const loadedBytes = _.values(loadedByIndex).reduce((total, loaded) => total + (Number(loaded) || 0), 0);
			let progressPercent = totalBytes > 0
				? Math.round((loadedBytes * 100) / totalBytes)
				: Math.round(((completedFiles + failedFiles) * 100) / totalFiles);
			progressPercent = Math.max(0, Math.min(status === "uploading" ? 99 : 100, progressPercent));

			let progressMessage;
			if (status === "preparing") {
				progressMessage = `Preparing to upload ${formatCount(totalFiles)} ${totalFiles === 1 ? "file" : "files"}...`;
			} else if (status === "refreshing") {
				progressMessage = "Refreshing Drive folder...";
				progressPercent = 100;
			} else {
				progressMessage = `Uploading Drive folder: ${formatCount(completedFiles)} of ${formatCount(totalFiles)} ${totalFiles === 1 ? "file" : "files"} complete`;
				if (failedFiles > 0) {
					progressMessage += `, ${formatCount(failedFiles)} failed`;
				}
			}

			setDriveSpinnerProgress({
				progressMessage,
				progressPercent
			});
		};
		renderUploadProgress("preparing", true);

		refreshCredentials()
			.then(async () => {
				const MAX_CONCURRENT = 5;
				const path = hierarchy.path.join("/");

				const retryUpload = async (uploadFn, file, retries = 3, delay = 500) => {
					for (let i = 0; i < retries; i++) {
						try {
							return await uploadFn(file);
						} catch (err) {
							if (i === retries - 1) {
								throw err;
							}
							await new Promise((res) => setTimeout(res, delay));
						}
					}
				};

				const uploadFn = async (file, currentIndex) => {
					const uploadOverrides = {
						deferDriveRefresh: true,
						suppressDriveSpinner: true,
						suppressDriveUploadProgress: true,
						onUploadProgress: ({ loaded, total }) => {
							const fileSize = Number(file && file.size) || Number(total) || 0;
							const loadedBytes = Math.max(0, Number(loaded) || 0);
							loadedByIndex[currentIndex] = fileSize > 0
								? Math.min(loadedBytes, fileSize)
								: loadedBytes;
							renderUploadProgress();
						}
					};
					if (videoProcessingOptions && isVideoFileCandidate(file)) {
						uploadOverrides.videoProcessingOptions = videoProcessingOptions;
						const outputFileName = `${videoProcessingOptions.outputFileName || ""}`.trim();
						if (files.length === 1 && outputFileName) {
							uploadOverrides.fileName = outputFileName;
						}
					}
					return uploadAndOptimizeMediaFile(path, file, null, false, uploadOverrides);
				};

				let index = 0;
				const workers = Array(MAX_CONCURRENT)
					.fill(null)
					.map(async () => {
						while (index < files.length) {
							const currentIndex = index++;
							const file = files[currentIndex];

							if (!file?.name) {
								failedFiles++;
								loadedByIndex[currentIndex] = 0;
								renderUploadProgress("uploading", true);
								errors.push("Upload File: there was an issue with a file.");
								continue;
							}

							try {
								loadedByIndex[currentIndex] = 0;
								renderUploadProgress("uploading", currentIndex === 0);
								const uploadResponse = await retryUpload((uploadFile) => uploadFn(uploadFile, currentIndex), file);
								completedFiles++;
								loadedByIndex[currentIndex] = Number(file && file.size) || loadedByIndex[currentIndex] || 0;
								renderUploadProgress("uploading", true);
								if (uploadResponse && isVideoFileCandidate(file)) {
									this.registerPendingVideoProcessingUpload(uploadResponse, file, videoProcessingOptions);
								}
							} catch (err) {
								failedFiles++;
								loadedByIndex[currentIndex] = Number(file && file.size) || loadedByIndex[currentIndex] || 0;
								renderUploadProgress("uploading", true);
								errors.push(`Error uploading "${file.name}": ${err?.message || err}`);
							}
						}
					});

				await Promise.all(workers);

				this.clearUploadInputs();
				this.handleCancelUploadFile();
				renderUploadProgress("refreshing", true);
				await listDriveForSelectedFolderSilently();
			})
			.catch((err) => {
				showError("Upload File", "Failed to refresh credentials: " + err);
			})
			.finally(() => {
				hideSpinner();
				if (errors.length > 0) {
					showError("Upload File", errors.join("\n"));
				}
			});
	}

	handleShowUploadFile() {
		this.setState({ showUploadFileModal: true });
		document.getElementById("drive-upload").click();
	}
	handleHideUploadFile() {
		this.setState({ showUploadFileModal: false });
	}
	handleCancelUploadFile() {
		this.handleHideUploadFile();
		this.setState({ uploadFile: null });
	}

	handleCancel() {
		const { onCancel } = this.props;
		if (onCancel) { onCancel(); }
	}
	handleOk() {
		const { onOk } = this.props;
		const { cursor } = this.state;
		if (onOk) { onOk(cursor); }
	}

	handleRefresh() {
		this.setState({ refreshDisabled: true });
		refreshSelectedDriveFolder()
			.then(() => {
				const activeGuid = _.get(this.state, "cursor.guid") || this.props.lastActiveGuid || _.get(this.props, "activeCursor.guid");
				if (activeGuid) {
					setActiveTreeCursorForDriveGuid(activeGuid);
				}
				this.setState({ refreshDisabled: false });
			})
			.catch((err) =>
				showError("Refresh Drive", "An error occurred while attempting to refersh drive content:" + err, () =>
					this.setState({ refreshDisabled: false })
				)
			);
	}

	handleRefreshAll() {
		this.setState({ refreshDisabled: true });
		listDrive()
			.then(() => {
				const activeGuid = _.get(this.state, "cursor.guid") || this.props.lastActiveGuid || _.get(this.props, "activeCursor.guid");
				if (activeGuid) {
					setActiveTreeCursorForDriveGuid(activeGuid);
				}
				this.setState({ refreshDisabled: false });
			})
			.catch((err) =>
				showError("Refresh Drive", "An error occurred while attempting to refresh the entire drive:" + err, () =>
					this.setState({ refreshDisabled: false })
				)
			);
	}

	handleSwitchMode(targetMode) {
		handleSwitchHierarchyMode(targetMode);
	}

	handleDelete() {
		const { cursor } = this.state;
		const backupCursor = Object.assign({}, cursor);
		if (backupCursor.type === "folder") {
			showConfirm("Are you sure you want to delete the selected " + backupCursor.type + "?", "Delete", () => {
				this.setState({ cursor: null });
				deleteFolder(cursor)
					.then(() => {
						this.handleDeletedCursorSelection(backupCursor);
					})
					.catch((err) => showError("Delete", "Failed to delete " + cursor.type + ", reason:" + err));
			});
			return;
		}

		const relatedItems = this.shouldCheckForGeneratedDeleteChildren(backupCursor)
			? this.collectRelatedGeneratedDriveObjects(backupCursor)
			: [];
		if (_.isEmpty(relatedItems)) {
			showConfirm("Are you sure you want to delete the selected " + backupCursor.type + "?", "Delete", () => {
				this.setState({ cursor: null });
				deleteFile(backupCursor.guid)
					.then(() => {
						this.handleDeletedCursorSelection(backupCursor);
					})
					.catch((err) => {
						console.error(err);
						showError("Delete", "Failed to delete " + backupCursor.type + ", reason:" + err);
					});
			});
			return;
		}

		this.setState({
			showDeleteOptionsModal: true,
			deleteDialogTarget: backupCursor,
			deleteDialogRelatedItems: relatedItems,
			deleteDialogDeleteRelated: true
		});
	}

	handleDeletedCursorSelection(backupCursor = null) {
		if (backupCursor?.type === "file" && this.props.onFileSelected) {
			this.props.onFileSelected(null);
		} else if (backupCursor?.type === "folder" && this.props.onFolderSelected) {
			this.props.onFolderSelected(null);
		} else if (this.props.onItemSelected) {
			this.props.onItemSelected(null);
		}
	}

	handleCloseDeleteOptionsModal() {
		this.setState({
			showDeleteOptionsModal: false,
			deleteDialogTarget: null,
			deleteDialogSelectionPlan: null,
			deleteDialogRelatedItems: [],
			deleteDialogDeleteRelated: true
		});
	}

	handleToggleDeleteRelated(event) {
		this.setState({
			deleteDialogDeleteRelated: !!_.get(event, "target.checked", false)
		});
	}

	handleConfirmDeleteOptions() {
		const { deleteDialogTarget, deleteDialogSelectionPlan, deleteDialogRelatedItems, deleteDialogDeleteRelated } = this.state;
		if (deleteDialogSelectionPlan) {
			this.setState({
				showDeleteOptionsModal: false,
				deleteDialogTarget: null,
				deleteDialogSelectionPlan: null,
				deleteDialogRelatedItems: [],
				deleteDialogDeleteRelated: true
			});
			this.executeSelectedDriveDeletePlan(deleteDialogSelectionPlan, deleteDialogDeleteRelated);
			return;
		}

		if (!deleteDialogTarget || !deleteDialogTarget.guid) {
			this.handleCloseDeleteOptionsModal();
			return;
		}

		const relatedGuids = deleteDialogDeleteRelated
			? deleteDialogRelatedItems.map((item) => item && item.guid).filter(Boolean)
			: [];
		const objectGuids = _.uniq([deleteDialogTarget.guid, ...relatedGuids]);
		this.setState({
			cursor: null,
			showDeleteOptionsModal: false,
			deleteDialogTarget: null,
			deleteDialogSelectionPlan: null,
			deleteDialogRelatedItems: [],
			deleteDialogDeleteRelated: true
		});

		const deletePromise = objectGuids.length > 1
			? deleteDriveObjectsBulk(objectGuids)
			: deleteFile(deleteDialogTarget.guid);
		deletePromise.then(() => {
			this.handleDeletedCursorSelection(deleteDialogTarget);
		}).catch((err) => {
			console.error(err);
			showError("Delete", "Failed to delete file, reason:" + err);
		});
	}

	getFolderDeletePath(item = {}) {
		if (!item || item.type !== "folder") {
			return "";
		}
		const rawPath = item.fullPath || item.path || "";
		try {
			const fullPath = getFullObjectPath(rawPath).replace(/\/+$/, "");
			return fullPath ? `${fullPath}/` : "";
		} catch (_err) {
			const fallbackPath = this.getCursorS3Key(item).replace(/\/+$/, "");
			return fallbackPath ? `${fallbackPath}/` : "";
		}
	}

	getFileDeletePath(item = {}) {
		if (!item || item.type !== "file") {
			return "";
		}
		return this.getCursorS3Key(item).replace(/^\/+/, "");
	}

	isDrivePathInsideFolder(path = "", folderPath = "") {
		const normalizedPath = `${path || ""}`.trim().replace(/^\/+/, "");
		const normalizedFolderPath = `${folderPath || ""}`.trim().replace(/^\/+/, "").replace(/\/+$/, "");
		if (!normalizedPath || !normalizedFolderPath) {
			return false;
		}
		return normalizedPath.startsWith(`${normalizedFolderPath}/`);
	}

	isDriveItemCoveredByFolderSelection(item = {}, folderPaths = []) {
		const itemPath = item.type === "folder" ? this.getFolderDeletePath(item) : this.getFileDeletePath(item);
		return folderPaths.some(folderPath => this.isDrivePathInsideFolder(itemPath, folderPath));
	}

	buildSelectedDriveDeletePlan(selectedItems = []) {
		const folderItems = [];
		const folderPaths = [];
		const fileItems = [];
		const fileGuids = [];
		const selectedFileGuids = new Set();
		const addFolderPath = (folderPath, folderItem) => {
			if (!folderPath || folderPaths.some(existingFolderPath => this.isDrivePathInsideFolder(folderPath, existingFolderPath))) {
				return;
			}
			for (let i = folderPaths.length - 1; i >= 0; i--) {
				if (this.isDrivePathInsideFolder(folderPaths[i], folderPath)) {
					folderPaths.splice(i, 1);
					folderItems.splice(i, 1);
				}
			}
			folderPaths.push(folderPath);
			folderItems.push(folderItem);
		};

		selectedItems.forEach(item => {
			if (!this.isDriveItemSelectionAvailable(item)) {
				return;
			}
			if (item.type === "folder") {
				const folderPath = this.getFolderDeletePath(item);
				addFolderPath(folderPath, item);
				return;
			}
			if (item.type === "file" && item.guid) {
				selectedFileGuids.add(item.guid);
			}
		});

		selectedItems.forEach(item => {
			if (!this.isDriveItemSelectionAvailable(item) || item.type !== "file" || !item.guid) {
				return;
			}
			if (this.isDriveItemCoveredByFolderSelection(item, folderPaths)) {
				return;
			}
			if (!fileGuids.includes(item.guid)) {
				fileGuids.push(item.guid);
				fileItems.push(item);
			}
		});

		const relatedItems = [];
		const relatedGuids = new Set(fileGuids);
		fileItems.forEach(item => {
			if (!this.shouldCheckForGeneratedDeleteChildren(item)) {
				return;
			}
			this.collectRelatedGeneratedDriveObjects(item).forEach(relatedItem => {
				if (!relatedItem || !relatedItem.guid || selectedFileGuids.has(relatedItem.guid) || relatedGuids.has(relatedItem.guid)) {
					return;
				}
				if (this.isDriveItemCoveredByFolderSelection(relatedItem, folderPaths)) {
					return;
				}
				relatedGuids.add(relatedItem.guid);
				relatedItems.push(relatedItem);
			});
		});

		return {
			selectedItems,
			folderItems,
			folderPaths,
			fileItems,
			fileGuids,
			relatedItems,
			primaryCount: folderPaths.length + fileGuids.length
		};
	}

	async executeSelectedDriveDeletePlan(plan = {}, deleteRelated = false) {
		const objectGuids = _.uniq([
			...(plan.fileGuids || []),
			...(deleteRelated ? (plan.relatedItems || []).map(item => item && item.guid).filter(Boolean) : [])
		]);
		const folderPaths = _.uniq(plan.folderPaths || []);

		if (_.isEmpty(objectGuids) && _.isEmpty(folderPaths)) {
			return;
		}

		try {
			this.setState({ cursor: null });
			if (_.isEmpty(folderPaths)) {
				await deleteDriveObjectsBulk(objectGuids);
			} else {
				let remainingObjectGuids = objectGuids;
				for (let i = 0; i < folderPaths.length; i++) {
					await deleteDriveObjectsBulk(remainingObjectGuids, folderPaths[i]);
					remainingObjectGuids = [];
				}
			}
			clearDriveSelectedItems();
			this.handleDeletedCursorSelection(null);
		} catch (err) {
			console.error(err);
			showError("Delete", "Failed to delete selected Drive items, reason:" + err);
		}
	}

	handleDeleteSelectedDriveItems() {
		const selectedItems = this.getSelectedDriveItems();
		const deletePlan = this.buildSelectedDriveDeletePlan(selectedItems);
		if (!deletePlan.primaryCount) {
			showError("Delete", "No selected Drive items can be deleted.");
			return;
		}

		if (!_.isEmpty(deletePlan.relatedItems)) {
			this.setState({
				showDeleteOptionsModal: true,
				deleteDialogTarget: null,
				deleteDialogSelectionPlan: deletePlan,
				deleteDialogRelatedItems: deletePlan.relatedItems,
				deleteDialogDeleteRelated: true
			});
			return;
		}

		const itemLabel = deletePlan.primaryCount === 1 ? "item" : "items";
		showConfirm(`Are you sure you want to delete ${deletePlan.primaryCount} selected ${itemLabel}?`, "Delete", () => {
			this.executeSelectedDriveDeletePlan(deletePlan, false);
		});
	}

	handleChangeNameRename(e) {
		this.setState({
			rename: _.assign({}, this.state.rename, { fileName: e.target.value })
		});
	}

	handleStartRename() {
		const { cursor } = this.state;
		this.setState({
			renaming: true,
			rename: _.assign({}, cursor, {
				fileName: cursor.name,
				fileNameNoExt: cursor.type === "folder" ? cursor.name : _.dropRight(cursor.name.split(".")).join("."),
				ext: cursor.type === "folder" ? null : _.last(cursor.name.split("."))
			})
		});
	}

	handleRename() {
		const { rename } = this.state;
		const { fileName } = rename;
		let destinationPath = null;
		if (rename.type === "folder") {
			destinationPath = _.dropRight(rename._path);
			destinationPath.push(fileName);
			moveFolder(rename, destinationPath.join("/"))
				.then((cursor) => {
					this.setState({ cursor });
					this.renderPreview();
					this.handleCancelRename();
				})
				.catch((err) => showError("Rename Folder", `Failed to rename folder ${rename.name} to ${fileName}, reason: ${err}`));
		} else if (rename.type === "file") {
			destinationPath = _.dropRight(rename._path);
			destinationPath.push(fileName);
			moveFile(rename.guid, destinationPath.join("/"))
				.then((cursor) => {
					this.setState({ cursor });
					this.renderPreview(cursor);
					this.handleCancelRename();
				})
				.catch((err) => showError("Rename File", `Failed to rename file ${rename.name} to ${fileName}, reason: ${err}`));
		} else {
			throw new Error("Must be a file or folder that is getting renamed");
		}
	}

	getDownloadFileName(cursor = null) {
		const target = cursor || this.state.cursor;
		if (!target) {
			return "download";
		}
		return target.name || target.fileName || _.last(this.getCursorPath(target).split("/")) || "download";
	}

	getDownloadMimeType(cursor = null) {
		const target = cursor || this.state.cursor || {};
		const explicitType = _.toString(
			_.get(target, "metaData.contentType")
			|| _.get(target, "metadata.contentType")
			|| _.get(target, "contentType")
			|| _.get(target, "mimeType")
			|| _.get(target, "fileType")
			|| ""
		).trim();
		if (explicitType && explicitType.indexOf("/") !== -1) {
			return explicitType;
		}

		const extension = _.toString(this.getDownloadFileName(cursor).split(".").pop() || "").toLowerCase();
		const mimeTypesByExtension = {
			csv: "text/csv",
			doc: "application/msword",
			docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
			gif: "image/gif",
			htm: "text/html",
			html: "text/html",
			jpeg: "image/jpeg",
			jpg: "image/jpeg",
			json: "application/json",
			mov: "video/quicktime",
			mp3: "audio/mpeg",
			mp4: "video/mp4",
			pdf: "application/pdf",
			png: "image/png",
			ppt: "application/vnd.ms-powerpoint",
			pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
			txt: "text/plain",
			webm: "video/webm",
			webp: "image/webp",
			xls: "application/vnd.ms-excel",
			xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
			zip: "application/zip"
		};
		return mimeTypesByExtension[extension] || "application/octet-stream";
	}

	getAttachmentContentDisposition(fileName = "download") {
		const sanitizedFileName = _.toString(fileName || "download")
			.replace(/[\r\n/\\"]/g, "_")
			.trim() || "download";
		const asciiFileName = sanitizedFileName.replace(/[^\x20-\x7E]/g, "_");
		const encodedFileName = encodeURIComponent(sanitizedFileName)
			.replace(/['()]/g, (char) => `%${char.charCodeAt(0).toString(16).toUpperCase()}`);
		return `attachment; filename="${asciiFileName}"; filename*=UTF-8''${encodedFileName}`;
	}

	async fetchDownloadBlob(url) {
		const response = await request.get(url).responseType("blob");
		if (response.status >= 400) {
			throw new Error(`HTTP ${response.status}`);
		}
		return response.body;
	}

	isConstrainedMobileDownloadContext() {
		if (typeof navigator === "undefined") {
			return false;
		}
		const userAgent = navigator.userAgent || "";
		const platform = navigator.platform || "";
		return /iPhone|iPad|iPod/i.test(userAgent)
			|| (platform === "MacIntel" && navigator.maxTouchPoints > 1)
			|| !!(typeof window !== "undefined" && window.ReactNativeWebView);
	}

	isMobileFileShareContext() {
		if (typeof navigator === "undefined") {
			return false;
		}
		const userAgent = navigator.userAgent || "";
		const platform = navigator.platform || "";
		return /Android|iPhone|iPad|iPod|Mobile/i.test(userAgent)
			|| (platform === "MacIntel" && navigator.maxTouchPoints > 1)
			|| !!(typeof window !== "undefined" && window.ReactNativeWebView);
	}

	canShareSelectedFile(cursor = null) {
		const target = cursor || this.state.cursor;
		return !!target && target.type === "file";
	}

	canUseNativeFileShare(fileName = "", mimeType = "") {
		if (
			typeof navigator === "undefined" ||
			typeof navigator.share !== "function" ||
			typeof File !== "function"
		) {
			return false;
		}

		if (typeof navigator.canShare !== "function") {
			return true;
		}

		try {
			const testFile = new File([""], fileName, { type: mimeType });
			return navigator.canShare({ files: [testFile] });
		} catch (_err) {
			return false;
		}
	}

	getDownloadDriveResource(cursor = null) {
		const target = cursor || this.state.cursor;
		if (!target) {
			return null;
		}

		const resource = getDriveObject(target.guid) || target;
		if (Array.isArray(resource.path)) {
			return {
				...resource,
				path: resource.path.join("/")
			};
		}
		return resource;
	}

	async getSignedDownloadUrl(cursor = null, fallbackUrl = "", options = {}) {
		const resource = this.getDownloadDriveResource(cursor);
		if (!resource || !resource.path) {
			return fallbackUrl;
		}

		try {
			await refreshCredentials();
			const signOptions = {};
			if (options.attachment) {
				signOptions.responseContentDisposition = this.getAttachmentContentDisposition(
					options.fileName || this.getDownloadFileName(cursor)
				);
			}
			return getSignedDriveResourceUrl(resource, 3600, signOptions) || fallbackUrl;
		} catch (err) {
			console.warn("Unable to resolve signed Drive download URL; falling back to default URL.", err);
			return fallbackUrl;
		}
	}

	getNativeDownloadOpenBridge() {
		if (typeof window === "undefined") {
			return null;
		}
		if (window.ReactNativeWebView && typeof window.ReactNativeWebView.postMessage === "function") {
			return window.ReactNativeWebView;
		}
		if (window.webView && typeof window.webView.postMessage === "function") {
			return window.webView;
		}
		return null;
	}

	openBlankDownloadContext() {
		if (typeof window === "undefined" || this.getNativeDownloadOpenBridge()) {
			return null;
		}

		try {
			const openedWindow = window.open("about:blank", "_blank");
			if (openedWindow) {
				try {
					openedWindow.opener = null;
				} catch (_err) {
					// Some browsers disallow touching the opener for cross-origin windows.
				}
				return openedWindow;
			}
		} catch (err) {
			console.warn("Unable to open placeholder Drive download window", err);
		}

		return null;
	}

	openDownloadUrlInNewContext(url, openedWindow = null, options = {}) {
		if (!url || typeof window === "undefined") {
			return false;
		}

		if (openedWindow) {
			try {
				openedWindow.location.href = url;
				if (typeof openedWindow.focus === "function") {
					openedWindow.focus();
				}
				return true;
			} catch (err) {
				console.warn("Unable to set placeholder Drive download window URL", err);
			}
		}

		const bridgeMessage = JSON.stringify({
			method: "downloadFile",
			url,
			fileName: options.fileName || "download",
			mimeType: options.mimeType || "application/octet-stream",
			source: "drive",
			external_url_open: url
		});
		const bridgeTarget = this.getNativeDownloadOpenBridge();
		if (bridgeTarget) {
			try {
				bridgeTarget.postMessage(bridgeMessage);
				return true;
			} catch (err) {
				console.warn("Unable to request native URL open", err);
			}
		}

		try {
			const openedWindow = window.open(url, "_blank", "noopener,noreferrer");
			if (openedWindow) {
				try {
					openedWindow.opener = null;
				} catch (_err) {
					// Some browsers disallow touching the opener for cross-origin windows.
				}
				return true;
			}
		} catch (err) {
			console.warn("window.open failed for Drive download URL", err);
		}

		if (typeof document !== "undefined" && document.body) {
			try {
				const link = document.createElement("a");
				link.href = url;
				link.target = "_blank";
				link.rel = "noopener noreferrer";
				link.style.display = "none";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				return true;
			} catch (err) {
				console.warn("Anchor fallback failed for Drive download URL", err);
			}
		}

		if (openedWindow && typeof openedWindow.close === "function") {
			try {
				openedWindow.close();
			} catch (_err) {
				// Ignore cleanup failure.
			}
		}

		return false;
	}

	async saveDownloadedBlob(blob, fileName) {
		if (
			this.isMobileFileShareContext() &&
			typeof navigator !== "undefined" &&
			typeof navigator.share === "function" &&
			typeof navigator.canShare === "function" &&
			typeof File === "function"
		) {
			const file = new File([blob], fileName, { type: blob.type || "application/octet-stream" });
			try {
				if (navigator.canShare({ files: [file] })) {
					await navigator.share({ files: [file], title: fileName });
					return;
				}
			} catch (err) {
				if (err && err.name === "AbortError") {
					return;
				}
			}
		}

		if (this.isConstrainedMobileDownloadContext()) {
			throw new Error("This mobile browser cannot save the file directly from Drive.");
		}

		saveAs(blob, fileName);
	}

	async shareDownloadedBlob(blob, fileName, mimeType) {
		if (
			typeof navigator === "undefined" ||
			typeof navigator.share !== "function" ||
			typeof File !== "function"
		) {
			throw new Error("This browser does not support sharing files.");
		}

		const file = new File([blob], fileName, { type: mimeType || blob.type || "application/octet-stream" });
		if (typeof navigator.canShare === "function" && !navigator.canShare({ files: [file] })) {
			throw new Error("This browser cannot share this file type.");
		}

		await navigator.share({ files: [file], title: fileName });
	}

	openShareFallbackModal({ url = "", downloadUrl = "", fileName = "", mimeType = "" } = {}) {
		this.setState({
			showShareFallbackModal: true,
			shareFallbackUrl: url,
			shareFallbackDownloadUrl: downloadUrl || url,
			shareFallbackFileName: fileName,
			shareFallbackMimeType: mimeType
		});
	}

	handleCloseShareFallbackModal() {
		this.setState({
			showShareFallbackModal: false,
			shareFallbackUrl: "",
			shareFallbackDownloadUrl: "",
			shareFallbackFileName: "",
			shareFallbackMimeType: ""
		});
	}

	async handleCopyShareFallbackLink() {
		const { shareFallbackUrl } = this.state;
		if (!shareFallbackUrl) {
			showError("Share File", "No share link is available.");
			return;
		}

		const copied = await copyToClipboard(shareFallbackUrl);
		if (copied) {
			showSuccessToast("Share link copied to clipboard.");
		} else {
			showError("Share File", "Unable to copy the share link to the clipboard.");
		}
	}

	handleEmailShareFallbackLink() {
		const { shareFallbackUrl, shareFallbackFileName } = this.state;
		if (!shareFallbackUrl || typeof window === "undefined") {
			showError("Share File", "No share link is available.");
			return;
		}

		const fileName = shareFallbackFileName || "Drive file";
		const subject = encodeURIComponent(fileName);
		const body = encodeURIComponent(`${fileName}\n\n${shareFallbackUrl}\n\nThis private AmbiFi Drive link may expire.`);
		window.location.href = `mailto:?subject=${subject}&body=${body}`;
	}

	handleOpenShareFallbackLink() {
		const { shareFallbackUrl, shareFallbackFileName, shareFallbackMimeType } = this.state;
		if (!this.openDownloadUrlInNewContext(shareFallbackUrl, null, { fileName: shareFallbackFileName, mimeType: shareFallbackMimeType })) {
			showError("Share File", "Unable to open the share link.");
		}
	}

	handleDownloadShareFallbackFile() {
		const { shareFallbackDownloadUrl, shareFallbackFileName, shareFallbackMimeType } = this.state;
		if (!this.openDownloadUrlInNewContext(shareFallbackDownloadUrl, null, { fileName: shareFallbackFileName, mimeType: shareFallbackMimeType })) {
			showError("Share File", "Unable to open the download link.");
		}
	}

	async handleDownloadFile() {
		const { cursor } = this.state;
		if (cursor) {
			const fallbackUrl = getUrlForResource(cursor);
			const fileName = this.getDownloadFileName(cursor);
			const mimeType = this.getDownloadMimeType(cursor);
			if (this.isConstrainedMobileDownloadContext()) {
				const pendingWindow = this.openBlankDownloadContext();
				const url = await this.getSignedDownloadUrl(cursor, fallbackUrl, { attachment: true, fileName });
				if (this.openDownloadUrlInNewContext(url, pendingWindow, { fileName, mimeType })) {
					return;
				}
				showError(
					"Download File",
					`Unable to open ${fileName} in a separate browser view from this mobile browser.`
				);
				return;
			}

			try {
				const url = await this.getSignedDownloadUrl(cursor, fallbackUrl, { attachment: true, fileName });
				const blob = await this.fetchDownloadBlob(url);
				await this.saveDownloadedBlob(blob, fileName);
			} catch (err) {
				saveAs(fallbackUrl, fileName);
			}
		}
	}

	async handleShareFile() {
		const { cursor } = this.state;
		if (!cursor || cursor.type !== "file") {
			return;
		}

		const fallbackUrl = getUrlForResource(cursor);
		const fileName = this.getDownloadFileName(cursor);
		const mimeType = this.getDownloadMimeType(cursor);

		try {
			const url = await this.getSignedDownloadUrl(cursor, fallbackUrl);
			const downloadUrl = await this.getSignedDownloadUrl(cursor, url, { attachment: true, fileName });
			const bridgeTarget = this.getNativeDownloadOpenBridge();
			if (bridgeTarget) {
				bridgeTarget.postMessage(JSON.stringify({
					method: "shareFile",
					url: downloadUrl,
					fileName,
					mimeType,
					source: "drive",
					external_url_open: downloadUrl
				}));
				return;
			}

			if (this.canUseNativeFileShare(fileName, mimeType)) {
				try {
					const blob = await this.fetchDownloadBlob(downloadUrl);
					await this.shareDownloadedBlob(blob, fileName, mimeType);
					return;
				} catch (err) {
					if (err && err.name === "AbortError") {
						return;
					}
					console.warn("Native Drive file share failed; showing fallback share options.", err);
				}
			}

			this.openShareFallbackModal({ url, downloadUrl, fileName, mimeType });
		} catch (err) {
			if (err && err.name === "AbortError") {
				return;
			}
			showError("Share File", err && err.message ? err.message : `Unable to share ${fileName}.`);
		}
	}

	handleCancelRename() {
		this.setState({ renaming: false, rename: {} });
	}

	normalizeTags(source) {
		if (!source) {
			return [];
		}

		if (Array.isArray(source)) {
			return source
				.map((entry) => {
					if (typeof entry === "string") {
						return entry.trim();
					}
					if (entry && typeof entry === "object") {
						const value = entry.label || entry.name || entry.Name || entry.tag || entry.Tag;
						return typeof value === "string" ? value.trim() : "";
					}
					return "";
				})
				.filter(Boolean);
		}

		if (typeof source === "string") {
			return source
				.split(/[,|\n]/)
				.map((entry) => entry.trim())
				.filter(Boolean);
		}

		if (source && typeof source === "object") {
			return Object.keys(source)
				.map((entry) => entry.trim())
				.filter(Boolean);
		}

		return [];
	}

	mergeUniqueTags(tags = []) {
		const seen = new Set();
		const result = [];

		tags.forEach((tag) => {
			const normalized = typeof tag === "string" ? tag.trim() : "";
			if (!normalized) {
				return;
			}
			const key = normalized.toLowerCase();
			if (seen.has(key)) {
				return;
			}
			seen.add(key);
			result.push(normalized);
		});

		return result;
	}

	cleanMetadataTitle(value) {
		if (typeof value !== "string") {
			return "";
		}
		let cleaned = value
			.replace(/\r\n/g, "\n")
			.replace(/\n/g, " ")
			.trim();
		if (cleaned.length > MAX_METADATA_TITLE_CHARS) {
			cleaned = cleaned.slice(0, MAX_METADATA_TITLE_CHARS).trim();
		}
		return cleaned;
	}

	cleanMetadataDescription(value) {
		if (typeof value !== "string") {
			return "";
		}
		let cleaned = value
			.replace(/\r\n/g, "\n")
			.trim();
		if (cleaned.length > MAX_METADATA_DESCRIPTION_CHARS) {
			cleaned = cleaned.slice(0, MAX_METADATA_DESCRIPTION_CHARS).trim();
		}
		return cleaned;
	}

	cleanMetadataTranscript(value) {
		if (typeof value !== "string") {
			return "";
		}
		let cleaned = value
			.replace(/\r\n/g, "\n")
			.trim();
		if (cleaned.length > MAX_METADATA_TRANSCRIPT_CHARS) {
			cleaned = cleaned.slice(0, MAX_METADATA_TRANSCRIPT_CHARS).trim();
		}
		return cleaned;
	}

	cleanMetadataTranscriptVtt(value) {
		if (typeof value !== "string") {
			return "";
		}
		let cleaned = value
			.replace(/\r\n/g, "\n")
			.trim();
		if (!cleaned) {
			return "";
		}
		const hasTimestamps = /-->/m.test(cleaned);
		if (hasTimestamps && !/^WEBVTT/i.test(cleaned)) {
			cleaned = `WEBVTT\n\n${cleaned}`;
		}
		if (cleaned.length > MAX_METADATA_TRANSCRIPT_VTT_CHARS) {
			cleaned = cleaned.slice(0, MAX_METADATA_TRANSCRIPT_VTT_CHARS).trim();
		}
		return cleaned;
	}

	isMetadataGenerationInProgress(field = "") {
		const current = `${this.state.metadataGeneratingField || ""}`;
		if (!field) {
			return current !== "";
		}
		return current === field;
	}

	getCursorPath(cursor = null) {
		const target = cursor || this.state.cursor;
		if (!target) {
			return "";
		}
		if (Array.isArray(target.path)) {
			return target.path.join("/");
		}
		if (typeof target.path === "string" && target.path.trim() !== "") {
			return target.path.trim();
		}
		if (typeof target.fullPath === "string" && target.fullPath.trim() !== "") {
			return target.fullPath.trim();
		}
		if (Array.isArray(target._path)) {
			return target._path.join("/");
		}
		return "";
	}

	getCursorFullObjectPath(cursor = null) {
		const path = this.getCursorPath(cursor).replace(/\/+$/, "");
		if (!path) {
			return "";
		}
		return getFullObjectPath(path);
	}

	getCursorParentFolderPath(cursor = null) {
		const fullObjectPath = this.getCursorFullObjectPath(cursor);
		if (!fullObjectPath) {
			return "";
		}
		const parentFolderPath = fullObjectPath.split("/").slice(0, -1).join("/");
		return parentFolderPath ? `${parentFolderPath}/` : "";
	}

	getCursorMediaType(cursor = null) {
		const target = cursor || this.state.cursor;
		if (!target) {
			return "file";
		}
		let extension = target.ext;
		if (!extension) {
			const path = `${target.path || target.fullPath || target.name || target.fileName || ""}`;
			extension = path.indexOf(".") >= 0 ? _.last(path.split(".")) : "";
		}
		if (!extension) {
			return "file";
		}
		try {
			return getMediaType(extension) || "file";
		} catch (_err) {
			return "file";
		}
	}

	getDriveObjectInfo(cursor = null) {
		const target = cursor || this.state.cursor;
		if (!target) {
			return null;
		}
		if (target.guid) {
			const driveObject = getDriveObjectsAsMap()?.[target.guid];
			if (driveObject) {
				return driveObject;
			}
		}
		return target;
	}

	buildGeneratedCompanionPathCandidates(cursor = null) {
		const s3Key = this.getCursorS3Key(cursor);
		if (!s3Key || s3Key.lastIndexOf(".") < 0) {
			return { transcriptionPaths: [], vttPaths: [], srtPaths: [] };
		}

		const basePathWithoutExt = s3Key.slice(0, s3Key.lastIndexOf("."));
		const transcriptionPath = `${basePathWithoutExt}-transcription.json`;
		const vttPath = `${basePathWithoutExt}-subtitles.vtt`;
		const srtPath = `${basePathWithoutExt}-subtitles.srt`;

		return {
			transcriptionPaths: this.createPathCandidateVariants(transcriptionPath),
			vttPaths: this.createPathCandidateVariants(vttPath),
			srtPaths: this.createPathCandidateVariants(srtPath)
		};
	}

	shouldCheckForGeneratedDeleteChildren(cursor = null) {
		const target = this.getDriveObjectInfo(cursor);
		if (!target || target.type !== "file") {
			return false;
		}

		const mediaType = this.getCursorMediaType(target);
		const metaData = _.isPlainObject(target.metaData) ? target.metaData : {};
		const generatedLinkFields = [
			"videoAssetRole",
			"derivedArtifact",
			"masterVideoDrivePath",
			"sourceVideoDriveObjectGuid",
			"sourceVideoDrivePath",
			"videoProcessing"
		];

		return mediaType === "video"
			|| mediaType === "audio"
			|| generatedLinkFields.some(field => !_.isEmpty(metaData[field]));
	}

	getDirectGeneratedDriveObjects(cursor = null, allDriveObjects = null) {
		const target = this.getDriveObjectInfo(cursor);
		if (!target || target.type !== "file") {
			return [];
		}

		const objects = Array.isArray(allDriveObjects) ? allDriveObjects : Object.values(getDriveObjectsAsMap() || {});
		const targetGuid = `${target.guid || ""}`.trim();
		const targetPath = this.normalizePathForLookup(this.getCursorPath(target));
		const targetMetaData = _.isPlainObject(target.metaData) ? target.metaData : {};
		const targetVideoRole = `${targetMetaData.videoAssetRole || ""}`.trim().toLowerCase();
		const derivedObjects = [];
		const seenGuids = new Set();
		const addCandidate = (candidate) => {
			if (!candidate || candidate.type !== "file" || !candidate.guid || candidate.guid === targetGuid || seenGuids.has(candidate.guid)) {
				return;
			}
			seenGuids.add(candidate.guid);
			derivedObjects.push(candidate);
		};

		objects.forEach((item) => {
			if (!item || item.type !== "file") {
				return;
			}
			const metaData = _.isPlainObject(item.metaData) ? item.metaData : {};
			const sourceVideoGuid = `${metaData.sourceVideoDriveObjectGuid || ""}`.trim();
			const sourceVideoPath = this.normalizePathForLookup(`${metaData.sourceVideoDrivePath || ""}`.trim());
			const masterVideoPath = this.normalizePathForLookup(`${metaData.masterVideoDrivePath || ""}`.trim());

			if (targetGuid && sourceVideoGuid && sourceVideoGuid === targetGuid) {
				addCandidate(item);
				return;
			}
			if (targetPath && sourceVideoPath && sourceVideoPath === targetPath) {
				addCandidate(item);
				return;
			}
			if (targetVideoRole === "master" && targetPath && masterVideoPath && masterVideoPath === targetPath) {
				addCandidate(item);
			}
		});

		const linkedMasterPath = `${targetMetaData.masterVideoDrivePath || ""}`.trim();
		if (linkedMasterPath) {
			addCandidate(this.resolveDriveObjectForPathCandidates(this.createPathCandidateVariants(linkedMasterPath)));
		}

		const { transcriptionPaths, vttPaths, srtPaths } = this.buildGeneratedCompanionPathCandidates(target);
		[
			this.resolveDriveObjectForPathCandidates(transcriptionPaths),
			this.resolveDriveObjectForPathCandidates(vttPaths),
			this.resolveDriveObjectForPathCandidates(srtPaths)
		].forEach(addCandidate);

		return derivedObjects;
	}

	collectRelatedGeneratedDriveObjects(cursor = null) {
		const root = this.getDriveObjectInfo(cursor);
		if (!root || root.type !== "file") {
			return [];
		}

		const allDriveObjects = Object.values(getDriveObjectsAsMap() || {});
		const queue = [root];
		const visitedGuids = new Set([`${root.guid || ""}`.trim()]);
		const related = [];

		while (queue.length > 0) {
			const current = queue.shift();
			const directChildren = this.getDirectGeneratedDriveObjects(current, allDriveObjects);
			directChildren.forEach((child) => {
				const childGuid = `${child && child.guid ? child.guid : ""}`.trim();
				if (!childGuid || visitedGuids.has(childGuid)) {
					return;
				}
				visitedGuids.add(childGuid);
				related.push(child);
				queue.push(child);
			});
		}

		return _.sortBy(related, [
			(item) => `${_.get(item, "metaData.derivedArtifact", "")}`.trim(),
			(item) => `${item.name || ""}`.toLowerCase()
		]);
	}

	getDeleteRelatedItemLabel(item = null) {
		if (!item) {
			return "";
		}
		const derivedArtifact = `${_.get(item, "metaData.derivedArtifact", "")}`.trim();
		const itemType = `${_.get(item, "metaData.type", "")}`.trim().toLowerCase();
		if (derivedArtifact === "video-master") {
			return "Master video";
		}
		if (derivedArtifact === "video-thumbnail") {
			return "Generated thumbnail";
		}
		if (derivedArtifact === "video-chunk") {
			return "Derived video chunk";
		}
		if (itemType === "ambifi/transcription") {
			return "Transcription JSON";
		}
		if (itemType === "ambifi/subtitles-vtt") {
			return "Subtitles VTT";
		}
		if (itemType === "ambifi/subtitles") {
			return "Subtitles SRT";
		}
		return "Generated companion";
	}

	getCursorS3Key(cursor = null) {
		const path = this.getCursorPath(cursor);
		if (!path) {
			return "";
		}

		const pathParts = path
			.trim()
			.replace(/^\/+/, "")
			.split("/")
			.filter(Boolean);
		if (pathParts.length < 2) {
			return path;
		}

		const rootSegment = pathParts[0];
		if (rootSegment !== "private" && rootSegment !== "public") {
			return path;
		}

		const hasOrgSegment = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(pathParts[1] || "");
		if (!hasOrgSegment) {
			const orgId = getOrgId();
			if (orgId) {
				pathParts.splice(1, 0, orgId);
			}
		}

		return pathParts.join("/");
	}

	createPathCandidateVariants(pathValue = "") {
		const variants = [];
		const pushVariant = (candidate) => {
			if (!candidate) {
				return;
			}
			const normalized = `${candidate}`.trim().replace(/^\/+/, "");
			if (!normalized || variants.includes(normalized)) {
				return;
			}
			variants.push(normalized);
		};

		const base = `${pathValue || ""}`.trim().replace(/^\/+/, "");
		if (!base) {
			return variants;
		}

		pushVariant(base);
		pushVariant(base.replace(/\s/g, "_"));

		const withoutOrg = base.replace(/^(public|private)\/[^/]+\//, "$1/");
		pushVariant(withoutOrg);
		pushVariant(withoutOrg.replace(/\s/g, "_"));

		return variants;
	}

	buildAwsTranscribeCompanionPathCandidates(cursor = null) {
		const s3Key = this.getCursorS3Key(cursor);
		if (!s3Key || s3Key.lastIndexOf(".") < 0) {
			return { transcriptionPaths: [], vttPaths: [] };
		}

		const basePathWithoutExt = s3Key.slice(0, s3Key.lastIndexOf("."));
		const transcriptionPath = `${basePathWithoutExt}-transcription.json`;
		const vttPath = `${basePathWithoutExt}-subtitles.vtt`;

		return {
			transcriptionPaths: this.createPathCandidateVariants(transcriptionPath),
			vttPaths: this.createPathCandidateVariants(vttPath)
		};
	}

	resolveDriveObjectForPathCandidates(pathCandidates = []) {
		const normalizedCandidates = pathCandidates
			.map((candidate) => `${candidate || ""}`.trim().replace(/^\/+/, ""))
			.filter(Boolean);
		if (!normalizedCandidates.length) {
			return null;
		}

		const normalizedLookup = new Set([
			...normalizedCandidates,
			...normalizedCandidates.map((candidate) => this.normalizePathForLookup(candidate))
		]);

		const driveObjectsAsMap = getDriveObjectsAsMap() || {};
		const driveObjects = Object.values(driveObjectsAsMap);
		for (let i = 0; i < driveObjects.length; i++) {
			const info = driveObjects[i];
			const rawInfoPath = Array.isArray(info?.path) ? info.path.join("/") : `${info?.path || ""}`;
			if (!rawInfoPath) {
				continue;
			}
			const normalizedInfoPath = rawInfoPath.trim().replace(/^\/+/, "");
			const lookupInfoPath = this.normalizePathForLookup(normalizedInfoPath);
			if (normalizedLookup.has(normalizedInfoPath) || normalizedLookup.has(lookupInfoPath)) {
				return info;
			}
		}

		const candidateNames = pathCandidates
			.map((candidate) => `${candidate}`.split("/").pop())
			.filter(Boolean);
		if (!candidateNames.length) {
			return null;
		}

		const children = Array.isArray(this.props?.hierarchy?.children) ? this.props.hierarchy.children : [];
		const byName = children.find((child) => child?.type === "file" && candidateNames.includes(child?.name));
		return byName || null;
	}

	extractTranscriptFromAwsTranscribeJson(jsonPayload) {
		if (!jsonPayload || typeof jsonPayload !== "object") {
			return "";
		}
		const direct = jsonPayload?.results?.transcripts?.[0]?.transcript;
		if (typeof direct === "string" && direct.trim() !== "") {
			return direct.trim();
		}
		return "";
	}

	extractTagsFromRekognitionPayload(payload) {
		if (!payload) {
			return [];
		}
		if (typeof payload === "string") {
			return this.mergeUniqueTags(this.normalizeTags(payload));
		}

		const tags = [];
		const addTag = (value) => {
			const normalized = this.cleanGeneratedTagCandidate(`${value || ""}`);
			if (normalized) {
				tags.push(normalized);
			}
		};

		(this.normalizeTags(payload.tags || []) || []).forEach(addTag);
		(this.normalizeTags(payload.rekognitionTags || []) || []).forEach(addTag);
		(this.normalizeTags(payload.openAiTags || []) || []).forEach(addTag);

		if (Array.isArray(payload.labels)) {
			payload.labels.forEach((labelEntry) => {
				if (typeof labelEntry === "string") {
					addTag(labelEntry);
					return;
				}
				if (labelEntry && typeof labelEntry === "object") {
					addTag(labelEntry.Name || labelEntry.name);
				}
			});
		}

		if (Array.isArray(payload.Labels)) {
			payload.Labels.forEach((labelEntry) => {
				if (labelEntry && typeof labelEntry === "object") {
					addTag(labelEntry.Name || labelEntry.name);
				}
			});
		}

		return this.mergeUniqueTags(tags).slice(0, 25);
	}

	extractAwsTranscribeVtt(payload) {
		if (!payload) {
			return "";
		}
		if (typeof payload === "string") {
			return /-->/m.test(payload) ? payload : "";
		}

		const candidates = [
			payload.vtt,
			payload.transcriptVtt,
			payload.transcript_vtt,
			payload.output_vtt,
			payload.outputVtt,
			payload.text
		];
		for (let i = 0; i < candidates.length; i++) {
			const candidate = candidates[i];
			if (typeof candidate === "string" && /-->/m.test(candidate)) {
				return candidate;
			}
		}

		return "";
	}

	extractAwsTranscribeText(payload) {
		if (!payload) {
			return "";
		}
		if (typeof payload === "string") {
			return payload;
		}

		const directText =
			payload.text ||
			payload.transcript ||
			payload.output_text ||
			payload.content ||
			payload?.results?.transcripts?.[0]?.transcript ||
			"";

		if (typeof directText === "string" && directText.trim() !== "") {
			return directText.trim();
		}

		return this.extractResponsesText(payload);
	}

	extractTranscriptFromVtt(vttValue = "") {
		const normalized = `${vttValue || ""}`.replace(/\r\n/g, "\n");
		if (!normalized.trim()) {
			return "";
		}

		const lines = normalized
			.split("\n")
			.map((line) => line.trim())
			.filter((line) => line !== "")
			.filter((line) => !/^WEBVTT$/i.test(line))
			.filter((line) => !/^NOTE\b/i.test(line))
			.filter((line) => !/^\d+$/.test(line))
			.filter((line) => !/^\d{1,2}:\d{2}(?::\d{2})?[.,]\d{3}\s+-->\s+\d{1,2}:\d{2}(?::\d{2})?[.,]\d{3}/.test(line));

		return lines.join(" ").replace(/\s+/g, " ").trim();
	}

	async fetchAwsTranscribeCompanionContent(cursor = null) {
		const { transcriptionPaths, vttPaths } = this.buildAwsTranscribeCompanionPathCandidates(cursor);
		const transcriptionObject = this.resolveDriveObjectForPathCandidates(transcriptionPaths);
		const vttObject = this.resolveDriveObjectForPathCandidates(vttPaths);

		let transcriptText = "";
		let transcriptVtt = "";

		if (transcriptionObject?.guid) {
			try {
				const transcriptionJson = await getContent(transcriptionObject.guid);
				transcriptText = this.cleanMetadataTranscript(this.extractTranscriptFromAwsTranscribeJson(transcriptionJson));
			} catch (err) {
				console.warn("Unable to load AWS transcription JSON sidecar:", err?.message || err);
			}
		}

		if (vttObject?.guid) {
			try {
				const rawVtt = await getContentRaw(vttObject.guid);
				transcriptVtt = this.cleanMetadataTranscriptVtt(rawVtt);
				if (!transcriptText && transcriptVtt) {
					transcriptText = this.cleanMetadataTranscript(this.extractTranscriptFromVtt(transcriptVtt));
				}
			} catch (err) {
				console.warn("Unable to load AWS subtitles VTT sidecar:", err?.message || err);
			}
		}

		return {
			transcriptText,
			transcriptVtt,
			transcriptionObject,
			vttObject,
			transcriptionPaths,
			vttPaths
		};
	}

	extractResponsesText(payload) {
		if (!payload) {
			return "";
		}
		if (typeof payload === "string") {
			return payload;
		}
		if (typeof payload.output_text === "string" && payload.output_text.trim() !== "") {
			return payload.output_text;
		}
		if (payload.response && typeof payload.response.output_text === "string" && payload.response.output_text.trim() !== "") {
			return payload.response.output_text;
		}
		if (typeof payload.text === "string" && payload.text.trim() !== "") {
			return payload.text;
		}

		const readOutputArray = (arr) => {
			if (!Array.isArray(arr)) {
				return "";
			}
			const parts = [];
			arr.forEach((entry) => {
				if (!entry) {
					return;
				}
				if (entry.type === "message" && Array.isArray(entry.content)) {
					entry.content.forEach((contentPart) => {
						if (!contentPart) {
							return;
						}
						if (typeof contentPart.text === "string" && contentPart.text.trim() !== "") {
							parts.push(contentPart.text);
							return;
						}
						if (typeof contentPart.value === "string" && contentPart.value.trim() !== "") {
							parts.push(contentPart.value);
						}
					});
					return;
				}
				if (typeof entry.text === "string" && entry.text.trim() !== "") {
					parts.push(entry.text);
				}
			});
			return parts.join("").trim();
		};

		const responseArrayText = readOutputArray(payload.output || payload.response?.output);
		if (responseArrayText) {
			return responseArrayText;
		}

		return "";
	}

	cleanGeneratedTagCandidate(value) {
		if (typeof value !== "string") {
			return "";
		}

		let cleaned = value
			.replace(/^[-*•]\s+/, "")
			.replace(/^\d+\.\s+/, "")
			.replace(/^tags?\s*:\s*/i, "")
			.replace(/^["'`]+|["'`]+$/g, "")
			.replace(/\s+/g, " ")
			.trim();

		cleaned = cleaned.replace(/[;,.\-:]+$/g, "").trim();
		if (!cleaned) {
			return "";
		}
		if (cleaned.length > 80) {
			return "";
		}
		return cleaned;
	}

	parseGeneratedTags(responseText = "") {
		if (typeof responseText !== "string" || responseText.trim() === "") {
			return [];
		}

		const tags = [];
		const addTags = (entries = []) => {
			entries.forEach((entry) => {
				const cleaned = this.cleanGeneratedTagCandidate(entry);
				if (cleaned) {
					tags.push(cleaned);
				}
			});
		};

		const normalizedText = responseText
			.replace(/\r\n/g, "\n")
			.replace(/```[a-zA-Z0-9_-]*\n?/g, "")
			.replace(/```/g, "")
			.trim();
		const lines = normalizedText
			.split("\n")
			.map((line) => line.trim())
			.filter(Boolean);

		for (let i = 0; i < Math.min(lines.length, 12); i++) {
			const line = lines[i]
				.replace(/^assistant:\s*/i, "")
				.replace(/^tags?\s*:\s*/i, "");
			if (line.indexOf(",") > -1) {
				addTags(line.split(","));
				if (tags.length >= 3) {
					break;
				}
			}
		}

		if (tags.length === 0) {
			const bulletLines = lines.filter((line) => /^([-*•]|\d+\.)\s+/.test(line));
			if (bulletLines.length > 0) {
				addTags(bulletLines);
			}
		}

		if (tags.length === 0 && lines.length > 0) {
			addTags(lines[0].split(","));
		}

		return this.mergeUniqueTags(tags).slice(0, 25);
	}

	getMetadataEditorTarget() {
		return this.state.metadataEditorTarget || this.state.cursor;
	}

	buildMetadataGenerationContext(targetResource = this.getMetadataEditorTarget()) {
		const {
			metadataEditorTitle,
			metadataEditorDescription,
			metadataEditorTranscript,
			metadataEditorTranscriptVtt,
			tagsEditorPrimary
		} = this.state;
		const target = targetResource;
		const mediaType = this.getCursorMediaType(target);
		const path = this.getCursorPath(target);
		const title = this.cleanMetadataTitle(metadataEditorTitle || "");
		const description = this.cleanMetadataDescription(metadataEditorDescription || "");
		const transcript = this.cleanMetadataTranscript(metadataEditorTranscript || "");
		const transcriptVtt = this.cleanMetadataTranscriptVtt(metadataEditorTranscriptVtt || "");
		const tags = this.mergeUniqueTags(tagsEditorPrimary || []);

		const contextParts = [
			`File name: ${target?.name || "(unknown)"}`,
			`Media type: ${mediaType}`,
			`Path: ${path || "(unknown)"}`,
			`Current title: ${title || "(none)"}`,
			`Current description: ${description || "(none)"}`,
			`Current transcript available: ${transcript ? "yes" : "no"}`,
			`Current timed transcript (VTT) available: ${transcriptVtt ? "yes" : "no"}`,
			`Current tags: ${tags.length ? tags.join(", ") : "(none)"}`
		];

		if (transcript) {
			const transcriptSnippet = transcript.length > 3000 ? `${transcript.slice(0, 3000)}\n\n[Transcript truncated.]` : transcript;
			contextParts.push(`Transcript snippet:\n${transcriptSnippet}`);
		}

		return contextParts.join("\n");
	}

	buildMetadataImageContextHints(targetResource = this.getMetadataEditorTarget()) {
		const target = targetResource;
		const fileName = `${target?.name || ""}`.trim();
		const rawPath = `${this.getCursorPath(target) || ""}`.trim();
		const pathParts = rawPath
			.split("/")
			.map((part) => part.trim())
			.filter(Boolean)
			.filter((part, index) => {
				if ((part === "public" || part === "private") && index === 0) {
					return false;
				}
				return !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(part);
			});
		const folderParts = fileName
			? pathParts.filter((part) => part.toLowerCase() !== fileName.toLowerCase())
			: pathParts;
		const contextualFolderHints = folderParts.slice(-4);
		const contextParts = [];

		if (fileName) {
			contextParts.push(`File name hint: ${fileName}`);
		}
		if (rawPath) {
			contextParts.push(`Drive path hint: ${rawPath}`);
		}
		if (contextualFolderHints.length > 0) {
			contextParts.push(`Useful folder context: ${contextualFolderHints.join(" | ")}`);
		}

		return contextParts.join("\n");
	}

	async runMetadataResponsesPrompt(promptText) {
		const requestBody = {
			model: "gpt-5.4",
			input: [
				{
					role: "user",
					content: [{ type: "input_text", text: promptText }]
				}
			]
		};
		const payload = await getResponsesCreateLambda(JSON.stringify(requestBody), { showAlert: false });
		return this.extractResponsesText(payload);
	}

	handleMetadataTranscriptProviderChange(event) {
		this.setState({ metadataTranscriptProvider: event?.target?.value || TRANSCRIPT_PROVIDER_AWS_TRANSCRIBE });
	}

	handleMetadataTagsProviderChange(event) {
		this.setState({ metadataTagsProvider: event?.target?.value || TAGS_PROVIDER_OPENAI });
	}

	async handleGenerateMetadataTitle() {
		const target = this.getMetadataEditorTarget();
		if (!target || target.type !== "file") {
			showError("Metadata", "Select a file before generating a title.");
			return;
		}

		this.setState({ metadataGeneratingField: "title" });
		try {
			const prompt = [
				"You are generating metadata for a Drive asset.",
				"Return only a concise title (no label, no quotes, no markdown), max 120 characters.",
				"",
				this.buildMetadataGenerationContext(target)
			].join("\n");
			const responseText = await this.runMetadataResponsesPrompt(prompt);
			const title = this.cleanMetadataTitle(responseText);
			if (!title) {
				throw new Error("Generation returned an empty title.");
			}
			this.setState({ metadataEditorTitle: title });
		} catch (err) {
			showError("Generate Title", err?.message || `${err}`);
		} finally {
			this.setState({ metadataGeneratingField: "" });
		}
	}

	async handleGenerateMetadataDescription() {
		const target = this.getMetadataEditorTarget();
		if (!target || target.type !== "file") {
			showError("Metadata", "Select a file before generating a description.");
			return;
		}

		this.setState({ metadataGeneratingField: "description" });
		try {
			const mediaType = this.getCursorMediaType(target);
			let responseText = "";

			if (mediaType === "image") {
				const s3Key = this.getCursorS3Key(target);
				if (!s3Key) {
					throw new Error("Missing S3 key for selected image.");
				}
				const imageContextHints = this.buildMetadataImageContextHints(target);
				responseText = await getImageDescriptionsLambda(JSON.stringify({
					bucket: env.s3.assetsBucket,
					key: s3Key,
					fileName: target.name || "",
					mediaType,
					prompt: [
						"Describe this specific image in one concise searchable description for asset metadata.",
						"Use the image itself as the primary evidence.",
						"Use file name and Drive path only as secondary context when they provide useful identifiers such as community, model, room, or lot ID.",
						"Do not invent details that are not visible in the image or clearly supported by the path context.",
						"Return only the description, max 600 characters.",
						"",
						imageContextHints
					].filter(Boolean).join("\n")
				}));
			} else {
				const prompt = [
					"You are generating metadata for a Drive asset.",
					"Return only one concise description for search/discovery, max 600 characters.",
					"No markdown, no headings, no source citations.",
					"",
					this.buildMetadataGenerationContext(target)
				].join("\n");
				responseText = await this.runMetadataResponsesPrompt(prompt);
			}

			const description = this.cleanMetadataDescription(responseText);
			if (!description) {
				throw new Error("Generation returned an empty description.");
			}
			this.setState({ metadataEditorDescription: description });
		} catch (err) {
			showError("Generate Description", err?.message || `${err}`);
		} finally {
			this.setState({ metadataGeneratingField: "" });
		}
	}

	async handleGenerateMetadataTranscript() {
		const { metadataTranscriptProvider } = this.state;
		const target = this.getMetadataEditorTarget();
		if (!target || target.type !== "file") {
			showError("Metadata", "Select a file before generating transcript/content text.");
			return;
		}

		this.setState({ metadataGeneratingField: "transcript" });
		try {
			const mediaType = this.getCursorMediaType(target);
			if (metadataTranscriptProvider === TRANSCRIPT_PROVIDER_AWS_TRANSCRIBE) {
				if (mediaType !== "audio" && mediaType !== "video") {
					throw new Error("AWS Transcribe generation is only supported for audio/video files.");
				}

				const s3Key = this.getCursorS3Key(target);
				if (!s3Key) {
					throw new Error("Missing S3 key for selected file.");
				}

				let transcriptText = "";
				let transcriptVtt = "";
				let generationError = null;

				try {
					const awsResponse = await getAwsTranscribeLambda(JSON.stringify({
						bucket: env.s3.assetsBucket,
						key: s3Key,
						fileName: target.name || "",
						mediaType,
						response_format: "text"
					}), { showAlert: false });

					transcriptText = this.cleanMetadataTranscript(this.extractAwsTranscribeText(awsResponse));
					transcriptVtt = this.cleanMetadataTranscriptVtt(this.extractAwsTranscribeVtt(awsResponse));
					if (!transcriptText && transcriptVtt) {
						transcriptText = this.cleanMetadataTranscript(this.extractTranscriptFromVtt(transcriptVtt));
					}
				} catch (err) {
					generationError = err;
				}

				if (!transcriptText) {
					const awsArtifacts = await this.fetchAwsTranscribeCompanionContent(target);
					transcriptText = awsArtifacts.transcriptText;
					transcriptVtt = transcriptVtt || awsArtifacts.transcriptVtt;
					if (!transcriptText && transcriptVtt) {
						transcriptText = this.cleanMetadataTranscript(this.extractTranscriptFromVtt(transcriptVtt));
					}
				}

				if (!transcriptText) {
					if (generationError) {
						throw new Error(`AWS Transcribe generation failed: ${generationError?.message || generationError}`);
					}
					throw new Error(
						"No AWS transcription generated and no sidecar found. Expected transcription output or companion '-transcription.json' near this asset."
					);
				}

				const updates = { metadataEditorTranscript: transcriptText };
				if (transcriptVtt) {
					updates.metadataEditorTranscriptVtt = transcriptVtt;
				}
				this.setState(updates);
				return;
			}

			const s3Key = this.getCursorS3Key(target);
			if (!s3Key) {
				throw new Error("Missing S3 key for selected file.");
			}

			let transcriptText = "";
			if (mediaType === "audio" || mediaType === "video") {
				const response = await getAudioTranscriptionsLambda(JSON.stringify({
					bucket: env.s3.assetsBucket,
					key: s3Key,
					fileName: target.name || "",
					mediaType,
					prompt: `Transcribe this ${mediaType} into plain text with useful section breaks.`
				}));
				transcriptText = this.extractResponsesText(response);
			} else if (mediaType === "image") {
				const response = await getImageDescriptionsLambda(JSON.stringify({
					bucket: env.s3.assetsBucket,
					key: s3Key,
					fileName: target.name || "",
					mediaType,
					prompt: "Describe this image in plain text for accessibility and search."
				}));
				transcriptText = this.extractResponsesText(response);
			} else if (mediaType === "pdf") {
				const response = await getPdfResponsesLambda(JSON.stringify({
					bucket: env.s3.assetsBucket,
					key: s3Key,
					fileName: target.name || "",
					model: "gpt-5.4",
					prompt: "Summarize this selected PDF into clean, practical sections for searchable content metadata."
				}), { showAlert: false });
				transcriptText = this.extractResponsesText(response);
			} else {
				const prompt = [
					"You are generating a long-form content text field for a Drive asset.",
					"For non-audio/video files, produce a concise content representation based on available metadata.",
					"No markdown tables. No source citations.",
					"",
					this.buildMetadataGenerationContext(target)
				].join("\n");
				transcriptText = await this.runMetadataResponsesPrompt(prompt);
			}

			const cleanedTranscript = this.cleanMetadataTranscript(transcriptText);
			if (!cleanedTranscript) {
				throw new Error("Generation returned empty transcript/content text.");
			}
			this.setState({ metadataEditorTranscript: cleanedTranscript });
		} catch (err) {
			showError("Generate Transcript", err?.message || `${err}`);
		} finally {
			this.setState({ metadataGeneratingField: "" });
		}
	}

	async handleGenerateMetadataTranscriptVtt() {
		const { metadataTranscriptProvider } = this.state;
		const target = this.getMetadataEditorTarget();
		if (!target || target.type !== "file") {
			showError("Generate VTT", "Select a file before generating timed transcript.");
			return;
		}

		this.setState({ metadataGeneratingField: "transcriptVtt" });
		try {
			const mediaType = this.getCursorMediaType(target);
			if (mediaType !== "audio" && mediaType !== "video") {
				throw new Error("Timed transcript (VTT) is currently only supported for audio/video files.");
			}

			if (metadataTranscriptProvider === TRANSCRIPT_PROVIDER_AWS_TRANSCRIBE) {
				const s3Key = this.getCursorS3Key(target);
				if (!s3Key) {
					throw new Error("Missing S3 key for selected file.");
				}

				let vttText = "";
				let generationError = null;
				try {
					const awsResponse = await getAwsTranscribeLambda(JSON.stringify({
						bucket: env.s3.assetsBucket,
						key: s3Key,
						fileName: target.name || "",
						mediaType,
						response_format: "vtt"
					}), { showAlert: false });

					vttText = this.cleanMetadataTranscriptVtt(this.extractAwsTranscribeVtt(awsResponse));
					if (!vttText) {
						const maybeText = this.extractAwsTranscribeText(awsResponse);
						vttText = this.cleanMetadataTranscriptVtt(maybeText);
					}
				} catch (err) {
					generationError = err;
				}

				if (!vttText) {
					const awsArtifacts = await this.fetchAwsTranscribeCompanionContent(target);
					vttText = awsArtifacts.transcriptVtt;
				}

				if (!vttText) {
					if (generationError) {
						throw new Error(`AWS Transcribe VTT generation failed: ${generationError?.message || generationError}`);
					}
					throw new Error("No AWS VTT generated and no sidecar found. Expected '-subtitles.vtt' companion output.");
				}

				if (!/-->/m.test(vttText)) {
					throw new Error("Returned AWS VTT did not include timestamp cues.");
				}

				this.setState({ metadataEditorTranscriptVtt: vttText });
				return;
			}

			const s3Key = this.getCursorS3Key(target);
			if (!s3Key) {
				throw new Error("Missing S3 key for selected file.");
			}

			const response = await getAudioTranscriptionsLambda(JSON.stringify({
				bucket: env.s3.assetsBucket,
				key: s3Key,
				fileName: target.name || "",
				mediaType,
				model: "whisper-1",
				response_format: "vtt"
			}));

			const rawVtt = this.extractResponsesText(response);
			if (!/-->/m.test(`${rawVtt || ""}`)) {
				throw new Error(
					"VTT output did not include timestamp cues. Verify inline aiAssistant lambda forwards response_format='vtt'."
				);
			}
			const cleanedVtt = this.cleanMetadataTranscriptVtt(rawVtt);
			if (!cleanedVtt) {
				throw new Error("Generation returned empty VTT content.");
			}
			this.setState({ metadataEditorTranscriptVtt: cleanedVtt });
		} catch (err) {
			showError("Generate VTT", err?.message || `${err}`);
		} finally {
			this.setState({ metadataGeneratingField: "" });
		}
	}

	async handleGenerateMetadataTags() {
		const { metadataTagsProvider } = this.state;
		const target = this.getMetadataEditorTarget();
		if (!target || target.type !== "file") {
			showError("Metadata", "Select a file before generating tags.");
			return;
		}

		this.setState({ metadataGeneratingField: "tags" });
		try {
			if (metadataTagsProvider === TAGS_PROVIDER_REKOGNITION) {
				const s3Key = this.getCursorS3Key(target);
				if (!s3Key) {
					throw new Error("Missing S3 key for selected file.");
				}

				let generatedTags = [];
				let generationError = null;
				try {
					const rekognitionResponse = await getRekognitionTagsLambda(JSON.stringify({
						bucket: env.s3.assetsBucket,
						key: s3Key,
						fileName: target.name || "",
						maxLabels: 25,
						minConfidence: 70
					}), { showAlert: false });

					generatedTags = this.extractTagsFromRekognitionPayload(rekognitionResponse);
				} catch (err) {
					generationError = err;
				}

				if (!generatedTags.length) {
					generatedTags = this.mergeUniqueTags(this.normalizeTags(target?.metaData?.rekognitionTags || []));
				}
				if (!generatedTags.length) {
					if (generationError) {
						throw new Error(`Rekognition tag generation failed: ${generationError?.message || generationError}`);
					}
					throw new Error("No Rekognition tags generated and no existing Rekognition tags available.");
				}

				this.setState((prev) => ({
					tagsEditorPrimary: this.mergeUniqueTags([...(prev.tagsEditorPrimary || []), ...generatedTags])
				}));
				return;
			}

			const prompt = [
				"You are generating searchable tags for a Drive asset.",
				"Return only one comma-separated line of tags (no bullets, no explanations).",
				"Use short phrases. Max 15 tags.",
				"",
				this.buildMetadataGenerationContext(target)
			].join("\n");
			const responseText = await this.runMetadataResponsesPrompt(prompt);
			const generatedTags = this.parseGeneratedTags(responseText);
			if (!generatedTags.length) {
				throw new Error("Generation returned no tags.");
			}
			this.setState((prev) => ({
				tagsEditorPrimary: this.mergeUniqueTags([...(prev.tagsEditorPrimary || []), ...generatedTags])
			}));
		} catch (err) {
			showError("Generate Tags", err?.message || `${err}`);
		} finally {
			this.setState({ metadataGeneratingField: "" });
		}
	}

	normalizePathForLookup(pathValue) {
		if (!pathValue) {
			return "";
		}
		let path = Array.isArray(pathValue) ? pathValue.join("/") : `${pathValue}`;
		path = path.trim().replace(/^\/+|\/+$/g, "");

		// Compare both with and without orgId in root prefix.
		path = path.replace(/^(public|private)\/[^/]+\//, "$1/");
		return path;
	}

	extractTagsFromAlgoliaHit(hit) {
		if (!hit || typeof hit !== "object") {
			return [];
		}

		return this.mergeUniqueTags([
			...this.normalizeTags(hit.labels),
			...this.normalizeTags(hit.tags),
			...this.normalizeTags(hit?.metaData?.tags),
			...this.normalizeTags(hit?.metaData?.rekognitionTags),
			...this.normalizeTags(hit?.metaData?.openAiTags)
		]);
	}

	extractMetadataFromAlgoliaHit(hit) {
		if (!hit || typeof hit !== "object") {
			return { tags: [], title: "", description: "", transcript: "", transcriptVtt: "" };
		}

		const tags = this.extractTagsFromAlgoliaHit(hit);
		const title = this.cleanMetadataTitle(
			hit?.metaData?.title ||
			hit?.title ||
			""
		);
		const description = this.cleanMetadataDescription(
			hit?.metaData?.description ||
			hit?.description ||
			""
		);
		const transcript = this.cleanMetadataTranscript(
			hit?.metaData?.transcript ||
			hit?.transcript ||
			""
		);
		const transcriptVtt = this.cleanMetadataTranscriptVtt(
			hit?.metaData?.transcriptVtt ||
			hit?.transcriptVtt ||
			""
		);

		return { tags, title, description, transcript, transcriptVtt };
	}

	async fetchAlgoliaTagSuggestions(node) {
		const orgId = getOrgId();
		const indexName = `prod_DRIVE_org_${orgId}`;
		const index = getClient2().initIndex(indexName);
		const attributesToRetrieve = ["objectID", "guid", "path", "labels", "tags", "metaData"];
		const normalizedNodePath = this.normalizePathForLookup(node.path || node.fullPath);

		// Fast-path: try getObject by guid (works when objectID == guid).
		if (node.guid) {
			try {
				const byObjectId = await index.getObject(node.guid, { attributesToRetrieve });
				const meta = this.extractMetadataFromAlgoliaHit(byObjectId);
				if (meta.tags.length > 0 || meta.title || meta.description) {
					return meta;
				}
			} catch (_err) {
				// expected for indexes where objectID is not guid.
			}
		}

		// Fallback: text search then exact-match by guid/path.
		const searchTerm = (node.name || "").trim();
		const result = await index.search(searchTerm || "", {
			hitsPerPage: 75,
			attributesToRetrieve
		});
		const hits = Array.isArray(result?.hits) ? result.hits : [];
		if (!hits.length) {
			return { tags: [], title: "", description: "", transcript: "", transcriptVtt: "" };
		}

		const matchedHit = hits.find((hit) => {
			const sameGuid = !!node.guid && (hit.guid === node.guid || hit.objectID === node.guid);
			const hitPath = this.normalizePathForLookup(hit.path);
			const samePath = !!normalizedNodePath && !!hitPath && hitPath === normalizedNodePath;
			return sameGuid || samePath;
		}) || hits[0];

		return this.extractMetadataFromAlgoliaHit(matchedHit);
	}

	async loadAlgoliaSuggestionsForTags(node) {
		try {
			const algoliaMeta = await this.fetchAlgoliaTagSuggestions(node);
			const algoliaTags = algoliaMeta?.tags || [];
			this.setState((prev) => {
				// User may have closed modal before async result.
				if (!prev.showTagsModal) {
					return null;
				}
				const currentKey = prev.cursor?.guid || prev.cursor?.path || prev.cursor?.fullPath || prev.cursor?.name;
				const currentTargetKey = prev.metadataEditorTarget?.guid || prev.metadataEditorTarget?.path || prev.metadataEditorTarget?.fullPath || prev.metadataEditorTarget?.name;
				const nodeKey = node?.guid || node?.path || node?.fullPath || node?.name;
				if (nodeKey && currentTargetKey && currentTargetKey !== nodeKey) {
					return null;
				}
				if (nodeKey && !currentTargetKey && currentKey && currentKey !== nodeKey) {
					return null;
				}
				const primarySet = new Set((prev.tagsEditorPrimary || []).map((tag) => `${tag}`.toLowerCase()));
				const mergedSecondary = this.mergeUniqueTags([
					...(prev.tagsEditorSecondary || []),
					...(algoliaTags || [])
				]).filter((tag) => !primarySet.has(`${tag}`.toLowerCase()));

				const updates = {
					tagsEditorSecondary: mergedSecondary,
					tagsEditorLoadingSuggestions: false
				};
				if (!prev.metadataEditorTitle && algoliaMeta?.title) {
					updates.metadataEditorTitle = algoliaMeta.title;
				}
				if (!prev.metadataEditorDescription && algoliaMeta?.description) {
					updates.metadataEditorDescription = algoliaMeta.description;
				}
				if (!prev.metadataEditorTranscript && algoliaMeta?.transcript) {
					updates.metadataEditorTranscript = algoliaMeta.transcript;
				}
				if (!prev.metadataEditorTranscriptVtt && algoliaMeta?.transcriptVtt) {
					updates.metadataEditorTranscriptVtt = algoliaMeta.transcriptVtt;
				}
				return updates;
			});
		} catch (err) {
			console.warn("Unable to load Algolia tag suggestions for selected Drive item:", err?.message || err);
			this.setState({ tagsEditorLoadingSuggestions: false });
		}
	}

	buildMetadataEditorStateForResource(resource, options = {}) {
		const metaData = resource && resource.metaData && typeof resource.metaData === "object" ? resource.metaData : {};
		const primary = this.mergeUniqueTags(this.normalizeTags(metaData.tags));
		const secondaryCandidates = this.mergeUniqueTags([
			...this.normalizeTags(metaData.rekognitionTags),
			...this.normalizeTags(metaData.openAiTags),
			...this.normalizeTags(metaData.labels),
			...this.normalizeTags(resource?.labels)
		]);
		const primaryKeySet = new Set(primary.map((tag) => tag.toLowerCase()));
		const secondary = secondaryCandidates.filter((tag) => !primaryKeySet.has(tag.toLowerCase()));

		return {
			tagsEditorInput: "",
			tagsEditorPrimary: primary,
			tagsEditorSecondary: secondary,
			tagsEditorLoadingSuggestions: options.loadSuggestions !== false,
			metadataEditorTitle: this.cleanMetadataTitle(metaData.title || ""),
			metadataEditorDescription: this.cleanMetadataDescription(metaData.description || ""),
			metadataEditorTranscript: this.cleanMetadataTranscript(metaData.transcript || ""),
			metadataEditorTranscriptVtt: this.cleanMetadataTranscriptVtt(metaData.transcriptVtt || ""),
			metadataGeneratingField: ""
		};
	}

	resolveMetadataEditorResource(resource = null) {
		const selectedResource = resource && resource.type === "file" ? resource : this.state.cursor;
		if (!selectedResource) {
			return null;
		}

		const latestResource = selectedResource.guid ? getDriveObject(selectedResource.guid) : null;
		const selectedMetaData = selectedResource.metaData && typeof selectedResource.metaData === "object" ? selectedResource.metaData : {};
		const latestMetaData = latestResource && latestResource.metaData && typeof latestResource.metaData === "object" ? latestResource.metaData : {};
		const mergedResource = latestResource
			? {
				...selectedResource,
				...latestResource,
				metaData: {
					...selectedMetaData,
					...latestMetaData
				}
			}
			: selectedResource;

		return this.normalizeMetadataReportResource(mergedResource) || (mergedResource.type === "file" ? mergedResource : null);
	}

	handleShowTagsEditor(resource = null) {
		const cursor = this.resolveMetadataEditorResource(resource);
		if (!cursor || cursor.type !== "file") {
			showError("Metadata", "Select a file to manage metadata.");
			return;
		}

		if (cursor.guid) {
			setActiveTreeCursorForDriveGuid(cursor.guid);
		}

		this.setState({
			cursor,
			selectedNode: cursor,
			showTagsModal: true,
			metadataEditorTarget: cursor,
			metadataGalleryItems: this.buildMetadataGalleryItemsForResource(cursor),
			tagsEditorSaving: false,
			...this.buildMetadataEditorStateForResource(cursor)
		});

		this.loadAlgoliaSuggestionsForTags(cursor);
	}

	handleShowMetadataReportModal() {
		this.setState({
			showMetadataReportModal: true,
			metadataReportRows: []
		}, () => {
			this.handleRefreshMetadataReport();
		});
	}

	handleHideMetadataReportModal() {
		this.setState({ showMetadataReportModal: false });
	}

	updateMetadataReportRows() {
		if (!this.state.showMetadataReportModal) {
			return;
		}
		this.setState({ metadataReportRows: this.getMetadataReportRows() });
	}

	async handleRefreshMetadataReport() {
		this.setState({ metadataReportLoading: true, refreshDisabled: true });
		try {
			await refreshCredentials();
			await listDriveMap();
			this.setState({
				metadataReportRows: this.getMetadataReportRows(),
				metadataReportLoading: false,
				refreshDisabled: false
			});
		} catch (err) {
			console.error(err);
			showError("Metadata Report", `Unable to refresh metadata report: ${err?.message || err}`);
			this.setState({
				metadataReportRows: this.getMetadataReportRows(),
				metadataReportLoading: false,
				refreshDisabled: false
			});
		}
	}

	handleMetadataReportScopeChange(scope) {
		const metadataReportScope = scope === "all" ? "all" : "current";
		this.setState({ metadataReportScope }, this.updateMetadataReportRows);
	}

	handleMetadataReportIncludeSubfoldersChange(includeSubfolders) {
		this.setState({ metadataReportIncludeSubfolders: includeSubfolders === true }, this.updateMetadataReportRows);
	}

	handleMetadataReportIncludeFilesWithoutMetadataChange(includeFilesWithoutMetadata) {
		this.setState({ metadataReportIncludeFilesWithoutMetadata: includeFilesWithoutMetadata === true }, this.updateMetadataReportRows);
	}

	handleEditMetadataReportResource(resource) {
		if (!resource || resource.type !== "file") {
			return;
		}
		this.handleShowTagsEditor(resource);
	}

	getMetadataReportResourceKey(resource = null) {
		if (!resource) {
			return "";
		}
		return resource.guid || this.getMetadataReportResourcePath(resource) || resource.fullPath || resource.name || resource.fileName || "";
	}

	getMetadataReportResourcePath(resource = null) {
		if (!resource) {
			return "";
		}

		const pathCandidates = [
			typeof resource.path === "string" ? resource.path : "",
			resource.fullPath,
			resource.Key,
			resource.key,
			resource.s3Key,
			Array.isArray(resource.path) ? resource.path : null,
			Array.isArray(resource._path) ? resource._path : null,
			this.getCursorPath(resource)
		];

		for (const pathCandidate of pathCandidates) {
			if (Array.isArray(pathCandidate)) {
				const joinedPath = pathCandidate.filter(Boolean).join("/").trim();
				if (joinedPath) {
					return joinedPath;
				}
			} else if (typeof pathCandidate === "string" && pathCandidate.trim() !== "") {
				return pathCandidate.trim();
			}
		}

		return "";
	}

	getMetadataReportResourceName(resource = null, path = "") {
		const nameCandidates = [
			resource?.name,
			resource?.fileName,
			path
		];

		for (const nameCandidate of nameCandidates) {
			if (typeof nameCandidate !== "string" || nameCandidate.trim() === "") {
				continue;
			}
			const normalizedName = nameCandidate.trim().replace(/\/+$/, "").split("/").filter(Boolean).pop();
			if (normalizedName) {
				return normalizedName;
			}
		}

		return "";
	}

	getMetadataReportResourceExtension(resource = null, name = "", path = "") {
		const explicitExt = `${resource?.ext || resource?.extension || ""}`.trim().replace(/^\./, "");
		if (explicitExt && explicitExt.indexOf("/") === -1) {
			return explicitExt;
		}

		const fileName = this.getMetadataReportResourceName(resource, name || path);
		if (/\.[^/.\\]+$/.test(fileName)) {
			return fileName.split(".").pop();
		}

		return "";
	}

	isMetadataReportFileResource(resource = null) {
		if (!resource) {
			return false;
		}
		if (resource.type === "folder" || resource.root) {
			return false;
		}
		if (resource.type === "file" || resource.isFile === true) {
			return true;
		}

		const path = this.getMetadataReportResourcePath(resource);
		if (!path || path.endsWith("/")) {
			return false;
		}

		return !!resource.guid || /\.[^/.\\]+$/.test(this.getMetadataReportResourceName(resource, path));
	}

	normalizeMetadataReportResource(resource = null) {
		if (!this.isMetadataReportFileResource(resource)) {
			return null;
		}

		const path = this.getMetadataReportResourcePath(resource);
		const name = this.getMetadataReportResourceName(resource, path) || "file";
		const ext = this.getMetadataReportResourceExtension(resource, name, path);
		const isPrivate = typeof resource.private === "boolean"
			? resource.private
			: path.indexOf("private/") === 0;

		return {
			...resource,
			type: "file",
			isFile: true,
			name,
			fileName: resource.fileName || name,
			path: path || resource.path || resource.fullPath || "",
			fullPath: resource.fullPath || path || "",
			ext: ext || resource.ext || "",
			private: isPrivate
		};
	}

	normalizeMetadataReportScopePath(path = "") {
		let normalizedPath = "";
		if (Array.isArray(path)) {
			normalizedPath = path.filter(Boolean).join("/");
		} else if (typeof path === "string") {
			normalizedPath = path;
		}

		normalizedPath = normalizedPath.trim().replace(/^\/+/, "").replace(/\/+$/, "");
		const orgId = getOrgId();
		if (orgId) {
			normalizedPath = normalizedPath.replace(new RegExp(`^(public|private)/${_.escapeRegExp(orgId)}(?=/|$)`), "$1");
		}
		return normalizedPath;
	}

	getMetadataReportCurrentFolderPath() {
		const selectedFolder = `${this.props.selectedFolder || ""}`.trim();
		if (selectedFolder) {
			return selectedFolder;
		}

		if (this.props.hierarchy && !this.props.hierarchy.root && this.props.hierarchy.type === "folder") {
			return this.getMetadataReportResourcePath(this.props.hierarchy);
		}

		return "";
	}

	getMetadataReportScopeLabel() {
		return this.normalizeMetadataReportScopePath(this.getMetadataReportCurrentFolderPath()) || "Drive";
	}

	isMetadataReportResourceInScope(resource = null) {
		if (this.state.metadataReportScope === "all") {
			return true;
		}

		const resourcePath = this.normalizeMetadataReportScopePath(this.getMetadataReportResourcePath(resource));
		if (!resourcePath) {
			return false;
		}

		const folderPath = this.normalizeMetadataReportScopePath(this.getMetadataReportCurrentFolderPath());
		const includeSubfolders = this.state.metadataReportIncludeSubfolders === true;

		if (!folderPath) {
			if (includeSubfolders) {
				return true;
			}
			const pathParts = resourcePath.split("/").filter(Boolean);
			return pathParts.length === 2 && (pathParts[0] === "public" || pathParts[0] === "private");
		}

		const folderPrefix = `${folderPath}/`;
		if (!resourcePath.startsWith(folderPrefix)) {
			return false;
		}

		const relativePath = resourcePath.slice(folderPrefix.length);
		return !!relativePath && (includeSubfolders || relativePath.indexOf("/") === -1);
	}

	getMetadataReportMetadataScore(resource = null) {
		if (!resource || !resource.metaData || typeof resource.metaData !== "object") {
			return 0;
		}
		const metaData = resource.metaData;
		return (
			this.normalizeTags(metaData.tags).length * 10 +
			(this.cleanMetadataTitle(metaData.title || "") ? 3 : 0) +
			(this.cleanMetadataDescription(metaData.description || "") ? 3 : 0) +
			(this.cleanMetadataTranscript(metaData.transcript || "") ? 1 : 0) +
			(this.cleanMetadataTranscriptVtt(metaData.transcriptVtt || "") ? 1 : 0)
		);
	}

	parseMetadataReportTimestampValue(value) {
		if (_.isNil(value) || value === "") {
			return 0;
		}
		if (value instanceof Date) {
			const time = value.getTime();
			return Number.isFinite(time) ? time : 0;
		}
		if (_.isNumber(value)) {
			return value > 0 && value < 1000000000000 ? value * 1000 : value;
		}
		if (_.isString(value)) {
			const trimmedValue = value.trim();
			if (!trimmedValue) {
				return 0;
			}
			const numericValue = Number(trimmedValue);
			if (Number.isFinite(numericValue) && numericValue > 0) {
				return numericValue < 1000000000000 ? numericValue * 1000 : numericValue;
			}
			const parsedValue = Date.parse(trimmedValue);
			return Number.isFinite(parsedValue) ? parsedValue : 0;
		}
		return 0;
	}

	getMetadataReportTimestamp(resource = null) {
		const metaData = resource && resource.metaData && typeof resource.metaData === "object" ? resource.metaData : {};
		const candidates = [
			resource?.updatedAt,
			resource?.modifiedAt,
			resource?.lastModified,
			resource?.LastModified,
			resource?.timestamp,
			metaData.updatedAt,
			metaData.modifiedAt,
			metaData.lastModified,
			metaData.timestamp,
			resource?.createdAt,
			resource?.createdDateTime,
			metaData.createdAt
		];

		for (const candidate of candidates) {
			const timestampValue = this.parseMetadataReportTimestampValue(candidate);
			if (timestampValue > 0) {
				return {
					value: timestampValue,
					label: new Date(timestampValue).toLocaleString()
				};
			}
		}

		return { value: 0, label: "" };
	}

	mergeMetadataReportResource(existing = null, incoming = null) {
		if (!existing) {
			return incoming;
		}
		if (!incoming) {
			return existing;
		}

		const existingScore = this.getMetadataReportMetadataScore(existing);
		const incomingScore = this.getMetadataReportMetadataScore(incoming);
		const preferIncoming = incomingScore >= existingScore;
		const base = preferIncoming ? { ...existing, ...incoming } : { ...incoming, ...existing };
		const firstMetaData = preferIncoming ? existing.metaData : incoming.metaData;
		const secondMetaData = preferIncoming ? incoming.metaData : existing.metaData;
		base.metaData = {
			...(firstMetaData && typeof firstMetaData === "object" ? firstMetaData : {}),
			...(secondMetaData && typeof secondMetaData === "object" ? secondMetaData : {})
		};
		return base;
	}

	collectMetadataReportFilesFromHierarchy(node, files = []) {
		if (Array.isArray(node)) {
			node.forEach((child) => this.collectMetadataReportFilesFromHierarchy(child, files));
			return files;
		}
		if (!node) {
			return files;
		}
		if (this.isMetadataReportFileResource(node)) {
			files.push(node);
		}
		if (Array.isArray(node.children)) {
			node.children.forEach((child) => this.collectMetadataReportFilesFromHierarchy(child, files));
		}
		return files;
	}

	getMetadataReportFiles() {
		const filesByKey = {};
		const addFile = (resource, forceIncomingMetadata = false) => {
			const normalizedResource = this.normalizeMetadataReportResource(resource);
			if (!normalizedResource) {
				return;
			}
			const key = this.getMetadataReportResourceKey(normalizedResource);
			if (!key) {
				return;
			}
			if (forceIncomingMetadata && filesByKey[key]) {
				filesByKey[key] = {
					...filesByKey[key],
					...normalizedResource,
					metaData: {
						...(filesByKey[key].metaData && typeof filesByKey[key].metaData === "object" ? filesByKey[key].metaData : {}),
						...(normalizedResource.metaData && typeof normalizedResource.metaData === "object" ? normalizedResource.metaData : {})
					}
				};
			} else {
				filesByKey[key] = this.mergeMetadataReportResource(filesByKey[key], normalizedResource);
			}
		};

		Object.values(getDriveObjectsAsMap() || {}).forEach(addFile);
		this.collectMetadataReportFilesFromHierarchy(this.props.hierarchy).forEach(addFile);
		(this.state.metadataGalleryItems || []).forEach((item) => addFile(item && (item.resource || item)));
		addFile(this.state.cursor);
		addFile(this.state.metadataEditorTarget);
		addFile(this.props.activeCursor);
		Object.values(this.state.metadataReportResourceOverrides || {}).forEach((resource) => addFile(resource, true));

		return Object.values(filesByKey);
	}

	getMetadataReportRows() {
		return this.getMetadataReportFiles()
			.filter((resource) => this.state.metadataReportIncludeFilesWithoutMetadata || this.getMetadataReportMetadataScore(resource) > 0)
			.filter((resource) => this.isMetadataReportResourceInScope(resource))
			.map((resource, index) => {
				const metaData = resource && resource.metaData && typeof resource.metaData === "object" ? resource.metaData : {};
				const primaryTags = this.mergeUniqueTags(this.normalizeTags(metaData.tags));
				const primaryTagSet = new Set(primaryTags.map((tag) => tag.toLowerCase()));
				const suggestedTags = this.mergeUniqueTags([
					...this.normalizeTags(metaData.openAiTags),
					...this.normalizeTags(metaData.rekognitionTags),
					...this.normalizeTags(metaData.labels),
					...this.normalizeTags(resource?.labels),
					...this.normalizeTags(resource?.tags)
				]).filter((tag) => !primaryTagSet.has(tag.toLowerCase()));
				const title = this.cleanMetadataTitle(metaData.title || "");
				const description = this.cleanMetadataDescription(metaData.description || "");
				const path = this.getCursorPath(resource);
				const mediaType = getDriveResourceMediaType(resource) || this.getCursorMediaType(resource) || "file";
				const extension = resource.ext || `${resource.name || path || ""}`.split(".").pop();
				const tagged = primaryTags.length > 0;
				const hasTitle = !!title;
				const hasDescription = !!description;
				const completeness = (tagged ? 1 : 0) + (hasTitle ? 1 : 0) + (hasDescription ? 1 : 0);
				const hasPrimaryMetadata = completeness > 0;
				const timestamp = this.getMetadataReportTimestamp(resource);

				return {
					key: resource.guid || path || resource.name || `metadata-report-${index}`,
					resource,
					name: resource.name || resource.fileName || path || "file",
					path,
					mediaType,
					icon: getFileTypeIcon(extension),
					thumbnailUrl: mediaType === "image" ? getUrlForExternalResource(resource) : "",
					title,
					description,
					timestamp: timestamp.label,
					timestampValue: timestamp.value,
					primaryTags,
					suggestedTags,
					tagged,
					hasTitle,
					hasDescription,
					hasPrimaryMetadata,
					isComplete: tagged && hasTitle && hasDescription,
					suggestedOnly: !hasPrimaryMetadata && suggestedTags.length > 0,
					completeness
				};
			});
	}

	buildMetadataGalleryItemsForResource(resource = this.state.cursor) {
		if (!resource) {
			return [];
		}

		const currentType = getDriveResourceMediaType(resource) || this.getCursorMediaType(resource);
		if (currentType !== "image") {
			return [];
		}

		const imageResources = this.getVisibleMediaFiles()
			.filter((node) => (getDriveResourceMediaType(node) || this.getCursorMediaType(node)) === "image");
		const resourceKey = resource?.guid || resource?.path || resource?.fullPath || resource?.name;
		const hasResource = !!resourceKey && imageResources.some((node) => (node.guid || node.path || node.fullPath || node.name) === resourceKey);
		const galleryResources = hasResource ? imageResources : [...imageResources, resource];

		return galleryResources
			.map((node) => ({
				key: node.guid || node.path || node.fullPath || node.name,
				name: node.name || node.path || node.fullPath || "image",
				url: getUrlForExternalResource(node),
				type: "image",
				resource: node
			}));
	}

	getMetadataGalleryItems() {
		if (this.state.showTagsModal && Array.isArray(this.state.metadataGalleryItems) && this.state.metadataGalleryItems.length > 0) {
			return this.state.metadataGalleryItems;
		}

		return this.buildMetadataGalleryItemsForResource(this.getMetadataEditorTarget());
	}

	getMetadataGalleryIndex(galleryItems = this.getMetadataGalleryItems()) {
		const target = this.getMetadataEditorTarget();
		if (!target || !Array.isArray(galleryItems) || galleryItems.length === 0) {
			return -1;
		}
		const cursorKey = target.guid || target.path || target.fullPath || target.name;
		return galleryItems.findIndex((item) => {
			const resource = item.resource || item;
			return (resource.guid || resource.path || resource.fullPath || resource.name) === cursorKey;
		});
	}

	handleMetadataGallerySelect(item) {
		const itemResource = item && (item.resource || item);
		if (!itemResource || itemResource.type !== "file") {
			return;
		}
		const resource = this.resolveMetadataEditorResource(itemResource);
		if (!resource || resource.type !== "file") {
			return;
		}
		if (resource.guid) {
			setActiveTreeCursorForDriveGuid(resource.guid);
		}
		this.setState({
			cursor: resource,
			selectedNode: resource,
			showTagsModal: true,
			metadataEditorTarget: resource,
			tagsEditorSaving: false,
			...this.buildMetadataEditorStateForResource(resource)
		}, () => {
			this.loadAlgoliaSuggestionsForTags(resource);
		});
	}

	async handleSaveTagsAndNavigate(offset = 1) {
		const galleryItems = this.getMetadataGalleryItems();
		const currentIndex = this.getMetadataGalleryIndex(galleryItems);
		if (galleryItems.length === 0 || currentIndex < 0) {
			await this.handleSaveTags();
			return;
		}
		const nextIndex = (currentIndex + offset + galleryItems.length) % galleryItems.length;
		const savedResource = await this.handleSaveTags({ closeModal: false });
		if (savedResource) {
			this.handleMetadataGallerySelect(galleryItems[nextIndex]);
		}
	}

	handleHideTagsEditor() {
		this.setState({
			showTagsModal: false,
			metadataEditorTarget: null,
			metadataGalleryItems: [],
			tagsEditorInput: "",
			tagsEditorPrimary: [],
			tagsEditorSecondary: [],
			tagsEditorSaving: false,
			tagsEditorLoadingSuggestions: false,
			metadataEditorTitle: "",
			metadataEditorDescription: "",
			metadataEditorTranscript: "",
			metadataEditorTranscriptVtt: "",
			metadataGeneratingField: ""
		});
	}

	handleTagsInputChange(event) {
		this.setState({ tagsEditorInput: event.target.value });
	}

	handleAddInputTags() {
		const { tagsEditorInput, tagsEditorPrimary } = this.state;
		const inputTags = this.normalizeTags(tagsEditorInput);
		if (!inputTags.length) {
			return;
		}

		this.setState({
			tagsEditorPrimary: this.mergeUniqueTags([...tagsEditorPrimary, ...inputTags]),
			tagsEditorInput: ""
		});
	}

	handleRemovePrimaryTag(tagToRemove) {
		this.setState((prev) => ({
			tagsEditorPrimary: prev.tagsEditorPrimary.filter((tag) => tag.toLowerCase() !== tagToRemove.toLowerCase())
		}));
	}

	handlePromoteSecondaryTag(tagToPromote) {
		this.setState((prev) => ({
			tagsEditorPrimary: this.mergeUniqueTags([...prev.tagsEditorPrimary, tagToPromote]),
			tagsEditorSecondary: prev.tagsEditorSecondary.filter((tag) => tag.toLowerCase() !== tagToPromote.toLowerCase())
		}));
	}

	handlePromoteAllSecondaryTags() {
		this.setState((prev) => ({
			tagsEditorPrimary: this.mergeUniqueTags([...prev.tagsEditorPrimary, ...prev.tagsEditorSecondary]),
			tagsEditorSecondary: []
		}));
	}

	handleMetadataTitleChange(event) {
		const rawValue = `${event?.target?.value || ""}`;
		this.setState({
			metadataEditorTitle: rawValue.slice(0, MAX_METADATA_TITLE_CHARS)
		});
	}

	handleMetadataDescriptionChange(event) {
		const rawValue = `${event?.target?.value || ""}`;
		this.setState({
			metadataEditorDescription: rawValue.slice(0, MAX_METADATA_DESCRIPTION_CHARS)
		});
	}

	handleMetadataTranscriptChange(event) {
		const rawValue = `${event?.target?.value || ""}`;
		this.setState({
			metadataEditorTranscript: rawValue.slice(0, MAX_METADATA_TRANSCRIPT_CHARS)
		});
	}

	handleMetadataTranscriptVttChange(event) {
		const rawValue = `${event?.target?.value || ""}`;
		this.setState({
			metadataEditorTranscriptVtt: rawValue.slice(0, MAX_METADATA_TRANSCRIPT_VTT_CHARS)
		});
	}

	async handleSaveTags(options = {}) {
		const closeModal = options.closeModal !== false;
		const {
			metadataEditorTarget,
			tagsEditorPrimary,
			metadataEditorTitle,
			metadataEditorDescription,
			metadataEditorTranscript,
			metadataEditorTranscriptVtt
		} = this.state;
		const target = metadataEditorTarget || this.state.cursor;
		if (!target || target.type !== "file") {
			showError("Metadata", "Select a file to save metadata.");
			return null;
		}

		const path = this.getCursorPath(target);
		if (!path) {
			showError("Metadata", "Unable to save metadata because file path is missing.");
			return null;
		}

		const metaData = target.metaData && typeof target.metaData === "object" ? _.cloneDeep(target.metaData) : {};
		metaData.tags = this.mergeUniqueTags(tagsEditorPrimary);
		const title = this.cleanMetadataTitle(metadataEditorTitle);
		const description = this.cleanMetadataDescription(metadataEditorDescription);
		const transcript = this.cleanMetadataTranscript(metadataEditorTranscript);
		const transcriptVtt = this.cleanMetadataTranscriptVtt(metadataEditorTranscriptVtt);
		if (title) {
			metaData.title = title;
		} else {
			delete metaData.title;
		}
		if (description) {
			metaData.description = description;
		} else {
			delete metaData.description;
		}
		if (transcript) {
			metaData.transcript = transcript;
		} else {
			delete metaData.transcript;
		}
		if (transcriptVtt) {
			metaData.transcriptVtt = transcriptVtt;
		} else {
			delete metaData.transcriptVtt;
		}

		this.setState({ tagsEditorSaving: true });

		try {
			await refreshCredentials();

			await request
				.put(`${env.apiGateway.baseUrl}${env.apiGateway.endpoints.drive.createObject}`)
				.set({ Authorization: getJwtToken(), "Content-Type": "application/json" })
				.send(JSON.stringify({
					orgId: getOrgId(),
					path: getFullObjectPath(path),
					metaData
				}));

			await listDriveForSelectedFolderSilently();
			if (target.guid) {
				setActiveTreeCursorForDriveGuid(target.guid);
			}

			const savedCursor = {
				...target,
				metaData
			};
			const savedCursorKey = this.getMetadataReportResourceKey(savedCursor);
			const nextState = {
				cursor: savedCursor,
				metadataEditorTarget: savedCursor,
				tagsEditorSaving: false,
				metadataGeneratingField: ""
			};
			if (savedCursorKey) {
				nextState.metadataReportResourceOverrides = {
					...(this.state.metadataReportResourceOverrides || {}),
					[savedCursorKey]: savedCursor
				};
			}
			if (closeModal) {
				Object.assign(nextState, {
					showTagsModal: false,
					metadataEditorTarget: null,
					metadataGalleryItems: [],
					tagsEditorInput: "",
					tagsEditorSecondary: [],
					tagsEditorPrimary: [],
					metadataEditorTitle: "",
					metadataEditorDescription: "",
					metadataEditorTranscript: "",
					metadataEditorTranscriptVtt: ""
				});
			}

			this.setState(nextState, this.updateMetadataReportRows);
			return savedCursor;
		} catch (err) {
			console.error(err);
			showError("Metadata", `Failed to save metadata: ${err?.message || err}`);
			this.setState({ tagsEditorSaving: false });
			return null;
		}
	}

	renderPreview(node = this.state.cursor) {
		let preview = null;
		let addPreviewLarge = false;
		let url = null;
		let type = null;
		const processingInfo = this.getPendingVideoProcessingForNode(node);

		if (node && node.type === "file") {
			addPreviewLarge = true;
			url = getUrlForExternalResource(node);
			try {
				type = node?.ext ? getMediaType(node.ext) : null;
			} catch {
				type = null;
			}

			switch (type) {
				case "video":
					preview = url ? (
						<ReactPlayer url={url} width="100%" height="100%" playing={false} playsInline muted={false} loop={false} controls />
					) : null;
					break;
				case "audio":
					preview = url ? <ReactAudioPlayer src={url} controls /> : null;
					break;
				case "pdf":
					preview = url ? (
						<object className="pdf" data={url} type="application/pdf" title="">
							<p>
								Your browser isn't supporting embedded pdf files. You can download the file{" "}
								<a href={url} target="_blank" rel="noreferrer">
									here
								</a>
								.
							</p>
						</object>
					) : null;
					break;
				case "threeD":
					preview = url && validateUrl(url) ? <div>3D preview will go here</div> : null;
					break;
				case "image":
					preview = url && validateUrl(url)
						? (
							<img
								alt="Preview"
								src={url}
								style={{
									width: "100%",
									height: "100%",
									objectFit: "contain",
									background: "#ffffff"
								}}
							/>
						)
						: null;
					break;
				default:
					addPreviewLarge = false;
					preview = <FontAwesomeIcon style={{ fontSize: "10vw" }} icon={getFileTypeIcon(node.ext, node)} />;
			}
		}

		let result = preview;
		if (addPreviewLarge) {
			result = (
				<div style={{ position: "relative", width: "100%", height: "100%" }}>
					{preview}
					<div
						key="open-large"
						className="open-large"
						onClick={() => {
							this.props.dispatch(showMediaPreviewModal, url);
						}}
					>
						<FontAwesomeIcon icon="expand-wide" />
					</div>
					{processingInfo && type === "video" && (
						<div
							style={{
								position: "absolute",
								inset: 0,
								background: "rgba(14, 27, 42, 0.68)",
								color: "#fff",
								display: "flex",
								flexDirection: "column",
								justifyContent: "center",
								alignItems: "center",
								textAlign: "center",
								padding: "24px",
								gap: "10px",
								zIndex: 2
							}}
						>
							<FontAwesomeIcon icon="spinner" spin style={{ fontSize: "24px" }} />
							<div style={{ fontWeight: 700, fontSize: "18px" }}>Processing video</div>
							<div style={{ maxWidth: "520px", lineHeight: 1.5 }}>
								The current preview may still be the original upload. When processing finishes, this playback file will be replaced with the converted output and the preview will refresh automatically.
							</div>
							{processingInfo.description && (
								<div style={{ maxWidth: "520px", fontSize: "12px", opacity: 0.92 }}>
									Target processing: {processingInfo.description}
								</div>
							)}
							{processingInfo.masterPath && (
								<div style={{ maxWidth: "520px", fontSize: "12px", opacity: 0.92 }}>
									Original source preserved in Drive as: <b>{processingInfo.masterPath.split("/").pop()}</b>
								</div>
							)}
						</div>
					)}
				</div>
			);
		}

		return result;
	}

	handleEditDocument() {
		const { cursor } = this.state;
		if (!cursor) {
			showError("Invalid Selection", "Please make sure to select a file for editing.");
			return;
		}
		showSpinner();
		setTimeout(() => {
			getContent(cursor.guid)
				.then((editingContent) => {
					const normalizedEditingContent = normalizeEditorContentForSave(editingContent);
					this.setState({
						editing: true,
						editingContent,
						editingInfo: {
							newDoc: false,
							type: cursor.type
						},
						captureNewDocumentInfo: false,
						editorState: {
							content: normalizedEditingContent,
							validity: { valid: true, error: null }
						}
					});
					hideSpinner();
				})
				.catch((err) => {
					showError("Edit Document", "An error occurred while attempting to open the document for editing: " + err);
					hideSpinner();
				});
		});
	}

	handleCancelEditDocument() {
		this.setState({
			editingContent: null,
			editing: false,
			captureNewDocumentInfo: false
		});
	}

	handleStartCreateNewDocument() {
		this.setState({
			editing: true,
			editingInfo: { newDoc: true, name: null, type: null },
			captureNewDocumentInfo: true
		});
	}

	handleSetStartCreateNewDocumentName(e) {
		const _state = _.cloneDeep(this.state);
		_.set(_state, "editingInfo.name", e.target.value);
		this.setState(_state);
	}

	handleSetStartCreateNewDocumentType(type) {
		const _state = _.cloneDeep(this.state);
		_.set(_state, "editingInfo.type", type);
		const initialContent = normalizeEditorContentForSave(_.get(type, "initialContent", ""));
		_.set(_state, "editingContent", initialContent);
		_.set(_state, "editorState", {
			content: initialContent,
			validity: { valid: true, error: null }
		});
		this.setState(_state);
	}

	handleCancelAddNewDocument() {
		this.setState({
			editContent: null,
			editingInfo: null,
			captureNewDocumentInfo: false
		});
	}

	handleEditNewDocument() {
		this.setState({ captureNewDocumentInfo: false });
	}

	handleEditorContentChange(content) {
		const editorState = _.clone(this.state.editorState);
		editorState.content = content;
		this.setState({ editorState });
	}

	handleEditorContentValidityChange(validity) {
		const editorState = _.clone(this.state.editorState);
		editorState.validity = validity;
		this.setState({ editorState });
	}

	handleSave() {
		const { cursor, editorState, editingInfo } = this.state;
		const { hierarchy } = this.props;
		const refContent = this.currentEditor && this.currentEditor.current && _.isFunction(this.currentEditor.current.getContent)
			? this.currentEditor.current.getContent()
			: null;
		const content = !_.isNil(refContent) ? refContent : editorState.content;
		const { name, type, newDoc } = editingInfo;

		if (newDoc) {
			if (hierarchy.type !== "folder") {
				showError("Create File", "Unable to create file, expected a drive folder to be selected.");
				return;
			}
			if (!type || !type.extension) {
				showError("Create File", "The selected document type doesn't contain information about the file extension, unable to create document.");
				return;
			}
			if (!content || _.isEmpty(content)) {
				showError("Create File", "There is not content, make sure to author some content prior to attempting to save.");
				return;
			}

			const { extension, contentType } = type;
			const path = `${hierarchy.path.join("/")}/${name.replace(`.${extension}`, "")}.${extension}`;
			uploadContent(path, content, contentType, { type: type.type }).then(() => {
				this.handleCancelEditDocument();
			});
		} else {
			if (cursor.type !== "file") {
				showError("Save File", "Unable to save file, expected a file to be selected.");
				return;
			}
			const metaData = cursor.metaData && typeof cursor.metaData === "object" ? cursor.metaData : null;
			const contentType = (type && type.contentType) || cursor.contentType || (metaData && metaData.contentType);
			const { path } = cursor;
			const fallbackContent = normalizeEditorContentForSave(this.state.editingContent);
			const contentToSave = (!_.isNil(content) && !(_.isString(content) && content === "")) ? content : fallbackContent;
			if (_.isNil(contentToSave) || (_.isString(contentToSave) && contentToSave === "")) {
				showError("Save File", "Unable to save an empty document. Please retry after the editor finishes loading.");
				return;
			}
			uploadContent(path, contentToSave, contentType, metaData).then(() => {
				this.handleCancelEditDocument();
			});
		}
	}

	handleShowImageEditorModal() {
		const { cursor } = this.state;
		if (!isImageToolsEnabledForUrlParams(this.props.urlParams)) {
			return;
		}

		const imageEditorTarget = getDriveImageEditorSource(cursor);
		if (!imageEditorTarget) {
			showError("Edit Image", "Select an image file before opening the image editor.");
			return;
		}

		this.setState({
			showImageEditorModal: true,
			imageEditorTarget
		});
	}

	handleCloseImageEditorModal() {
		this.setState({
			showImageEditorModal: false,
			imageEditorTarget: null
		});
	}

	handleCreateEditedImage({ blob, imageName, overwriteImage = false, overwriteTargetPath = "", mimeType = "" }) {
		const { cursor } = this.state;
		if (!blob || !cursor || cursor.type !== "file") {
			const error = new Error("Unable to save edited image.");
			showError("Edit Image", error.message);
			return Promise.reject(error);
		}

		const resolvedMimeType = `${mimeType || blob.type || "image/png"}`.trim() || "image/png";
		const fallbackFileName = resolvedMimeType === "image/jpeg" ? "image-edited.jpg" : "image-edited.png";
		const safeFileName = `${imageName || fallbackFileName}`.trim() || fallbackFileName;
		const file = new File([blob], safeFileName, { type: resolvedMimeType });
		const replaceExistingTarget = overwriteImage ? (overwriteTargetPath || cursor.path || "") : "";
		const targetPath = replaceExistingTarget || (cursor.path ? cursor.path.split("/").slice(0, -1).join("/") : "");

		if (!targetPath) {
			const error = new Error("Unable to determine the destination path for the edited image.");
			showError("Edit Image", error.message);
			return Promise.reject(error);
		}

		return uploadFile(targetPath, file, "image", !!replaceExistingTarget, {
			fileName: safeFileName,
			notOptimized: true
		}).then((uploadResponse) => {
			this.setState({
				showImageEditorModal: false,
				imageEditorTarget: null
			});

			if (uploadResponse && uploadResponse.guid) {
				setActiveTreeCursorForDriveGuid(uploadResponse.guid);
			}
			return uploadResponse;
		}).catch((err) => {
			showError("Edit Image", `An error occurred while attempting to save the edited image. Error: ${err}`);
			throw err;
		});
	}

	handleShowVideoEditorModal() {
		const { cursor } = this.state;
		if (!isMediaToolsEnabledForUrlParams(this.props.urlParams)) {
			return;
		}

		const videoEditorTarget = getDriveVideoEditorSource(cursor);
		if (!videoEditorTarget) {
			showError("Edit Video", "Select a Drive video before opening the video editor.");
			return;
		}

		this.setState({
			showVideoEditorModal: true,
			videoEditorTarget
		});
	}

	handleCloseVideoEditorModal() {
		this.setState({
			showVideoEditorModal: false,
			videoEditorTarget: null
		});
	}

	async handleCreateEditedVideo(options = {}) {
		const videoEditorTarget = this.state.videoEditorTarget;
		if (!videoEditorTarget || !videoEditorTarget.resource) {
			showError("Edit Video", "Unable to save edited video.");
			return;
		}

		const overwriteVideo = options.overwriteVideo === true;
		const overwriteTargetPath = overwriteVideo ? (options.overwriteTargetPath || videoEditorTarget.overwriteTargetPath || "") : "";
		const outputFileName = `${options.outputFileName || videoEditorTarget.defaultOutputFileName || buildEditedVideoOutputFileName(videoEditorTarget.videoFileName)}`.trim();
		const videoProcessingOptions = _.omit(options, ["outputFileName", "overwriteVideo", "overwriteTargetPath"]);

		try {
			showInfoToast("Submitting video edit for processing...", {
				autoClose: 5000
			});
			setStoredVideoProcessingOptions(videoProcessingOptions);
			const uploadResponse = await processExistingDriveVideoFile(videoEditorTarget.resource, {
				outputFileName,
				overwriteTargetPath,
				videoProcessingOptions,
				sourceFileName: videoEditorTarget.videoFileName || videoEditorTarget.label || "video.mp4",
				sourceContentType: _.get(videoEditorTarget.resource, "metaData.masterVideoContentType", "") || "video/mp4"
			});

			this.registerPendingVideoProcessingUpload(uploadResponse, {
				name: uploadResponse.fileName || outputFileName,
				type: "video/mp4"
			}, videoProcessingOptions);
			this.setState({
				showVideoEditorModal: false,
				videoEditorTarget: null,
				isSearchMode: false,
				filter: ""
			});
			const editedVideoFolderPath = uploadResponse && uploadResponse.path
				? `${uploadResponse.path.split("/").slice(0, -1).join("/")}/`
				: "";
			try {
				if (editedVideoFolderPath) {
					await selectFolderAndListDrive(editedVideoFolderPath);
				} else {
					await listDriveForSelectedFolderSilently();
				}
			} catch (err) {
				console.warn("Unable to silently refresh selected Drive folder after editing video", err);
			}
			if (uploadResponse && uploadResponse.guid) {
				setActiveTreeCursorForDriveGuid(uploadResponse.guid);
			}
			showSuccessToast(overwriteVideo ? "Queued video processing to overwrite the selected Drive video." : "Queued edited video processing.");
		} catch (err) {
			showError("Edit Video", `An error occurred while attempting to save the edited video. Error: ${err?.message || err}`);
		}
	}

	handleSelectFolderAndListDrive(path) {
		clearSelectionAndActiveTreeCursor();
		clearDriveSelectedItems();
		selectFolderAndListDrive(path);
		this.setState((prevState) => ({
			cursor: null,
			filter: "",
			galleryIndex: 0,
			isSearchMode: false,
			searchImageFiles: [],
			searchVisibleItems: [],
			searchResetToken: prevState.searchResetToken + 1
		}));
	}

	async handleOpenFileLocation() {
		const { cursor } = this.state;
		if (!cursor || cursor.type !== "file") {
			showError("Open Location", "Select a file before opening its folder.");
			return;
		}

		let fullObjectPath = "";
		let parentFolderPath = "";
		try {
			fullObjectPath = this.getCursorFullObjectPath(cursor);
			parentFolderPath = this.getCursorParentFolderPath(cursor);
		} catch (err) {
			showError("Open Location", `Unable to resolve the file location. Error: ${err?.message || err}`);
			return;
		}

		if (!fullObjectPath || !parentFolderPath) {
			showError("Open Location", "Unable to resolve the file location.");
			return;
		}

		try {
			clearSelectionAndActiveTreeCursor();
			clearDriveSelectedItems();
			await selectFolderAndListDrive(parentFolderPath);

			const selectedFileNode = getDriveTreeNodeByPath(fullObjectPath);
			const selectedFileGuid = selectedFileNode?.guid || cursor.guid;
			if (selectedFileNode && selectedFileNode.guid) {
				setNodeActive(selectedFileNode.guid, true, selectedFileNode);
			} else if (cursor.guid) {
				setActiveTreeCursorForDriveGuid(cursor.guid);
			}

			this.setState((prevState) => ({
				cursor: selectedFileNode || cursor,
				selectedNode: selectedFileNode || cursor,
				filter: "",
				galleryIndex: 0,
				isSearchMode: false,
				searchImageFiles: [],
				searchVisibleItems: [],
				searchResetToken: prevState.searchResetToken + 1
			}), () => this.scrollDriveNodeIntoView(selectedFileGuid));
		} catch (err) {
			showError("Open Location", `Unable to open the containing folder. Error: ${err?.message || err}`);
		}
	}

	handleSelectActivityDriveRootFolder() {
		let path = getDriveRootPath(true);
		if (path) {
			let fullPath = getFullObjectPath("private/activities/" + path + "/");
			if (fullPath !== this.props.selectedFolder) {
				clearDriveSelectedItems();
				selectFolderAndListDrive(fullPath);
			}
		}
	}

	renderBreadcrumbs() {
		let { selectedFolder } = this.props;
		let breadcrumbItems = [];

		if (selectedFolder) {
			let folderSlugs = selectedFolder.split("/");
			let currentPath = "";
			let breadcrumbData = [];

			folderSlugs.map((folderSlug, i) => {
				let name;
				let folderPath;
				if (i > 0 && folderSlug) {
					if (i === 1) {
						folderPath = folderSlugs[0] + "/" + folderSlugs[1] + "/";
						name = folderSlugs[0];
					} else {
						folderPath = folderSlugs[i] + "/";
						name = folderSlugs[i];
					}
					let active = false;
					if (i === folderSlugs.length - 2) {
						active = true;
					}
					currentPath += folderPath;
					breadcrumbData.push({ name, folderPath: currentPath, active });
				}
			});

			breadcrumbData.map((data) => {
				breadcrumbItems.push(
					<Breadcrumb.Item key={data.folderPath} active={data.active} onClick={data.active ? null : () => this.handleSelectFolderAndListDrive(data.folderPath)}>
						{data.name}
					</Breadcrumb.Item>
				);
			});
		}

		return (
			<div className={styles["breadcrumb-container"]}>
				<Breadcrumb>
					<Breadcrumb.Item active={!selectedFolder ? true : false} onClick={() => this.handleSelectFolderAndListDrive("")}>
						Drive
					</Breadcrumb.Item>
					{breadcrumbItems}
				</Breadcrumb>
			</div>
		);
	}

	render() {
		const { cursor, moving, copying, editing, editingInfo, editingContent, copyInfo, moveInfo } = this.state;
		const { validity } = this.state.editorState;
		const {
			inline,
			edit,
			showSpinner: showSpinnerFlag,
			hideSearchInput,
			hideActionBar,
			okCancel,
			folderOnly,
			actionBarTop,
			hierarchy,
			settings,
			handleQuickUpload,
			acceptType
		} = this.props;

		if (!hierarchy) {
			return (
				<div style={{ width: "100%" }}>
					<div>Loading files...please be patient.</div>
					<AmbifiLoader show={showSpinnerFlag} fullPage={!inline} panel={inline} />
				</div>
			);
		}

		const buttons = [];
		let deleteButton = null;
		let actionBar = null;
		let okCancelBar = null;

		const { editors } = this.props;
			let editor = null;
			if (editors && cursor) {
				const { metaData } = cursor;
				if (metaData) {
					const { type } = metaData;
				if (type && editors[type]) {
					editor = editors[type];
				}
			}
			const extesnionKey = `extension/${cursor?.ext}`;
			if (!editor && cursor?.ext && editors[extesnionKey]) {
				editor = editors[extesnionKey];
			}
		}

		let editType, editName;
		if (editingInfo) {
			const { name, type } = editingInfo;
			editType = type;
			editName = name;
			if (type && type.component) {
				editor = type;
			}
		}
		const editTypeKey = editType && editors
			? (_.findKey(editors, (editorDef) => editorDef === editType) || "")
			: "";
		const createableEditorKeys = editors
			? _.keys(editors).filter((editorKey) => _.get(editors[editorKey], "showInNewDocumentMenu", true) !== false)
			: [];

		const createMenuComponent = (title, icon, key, onClick, extraProps = {}) => {
			if (inline) {
				return (
					<MenuItem key={key} onClick={onClick} {...extraProps}>
						<FontAwesomeIcon icon={icon} /> {title}
					</MenuItem>
				);
			} else {
				return (
					<Button key={key} onClick={onClick} title={title} aria-label={title} {...extraProps}>
						<FontAwesomeIcon icon={icon} /> <span className="drive-action-label">{title}</span>
					</Button>
				);
			}
		};

		const visibleMedia = this.getVisibleMediaFiles();
		const metadataEditorTarget = this.getMetadataEditorTarget();
		const metadataGalleryItems = this.state.showTagsModal ? this.getMetadataGalleryItems() : [];
		const metadataGalleryIndex = this.getMetadataGalleryIndex(metadataGalleryItems);
		const metadataReportRows = this.state.showMetadataReportModal ? (this.state.metadataReportRows || []) : [];
		const driveMultiselectAvailable = !!edit && !hideActionBar && !okCancel && !folderOnly;
		const selectionEnabled = driveMultiselectAvailable && this.state.showDriveMultiselect;
		const selectedDriveItems = selectionEnabled ? this.getSelectedDriveItems() : [];
		const selectedDriveKeys = this.getSelectedDriveKeyMap(selectedDriveItems);
		const visibleDriveSelectionItems = selectionEnabled ? this.getVisibleDriveSelectionItems() : [];

			const handleQuickUploadButton = createMenuComponent("Upload File", "upload", "drive-upload-file-button", () => {
				handleQuickUpload(false);
			});
			const canEditImage = isImageToolsEnabledForUrlParams(this.props.urlParams) && !!getDriveImageEditorSource(cursor);
			const canEditVideo = isMediaToolsEnabledForUrlParams(this.props.urlParams) && !!getDriveVideoEditorSource(cursor);
			const showDriveVideoAdvancedToggle = isMediaToolsEnabledForUrlParams(this.props.urlParams) && !!edit && !hideActionBar && !this.props.hideVideoAdvancedToggle;
			const canShowDriveReindexAction = !inline && isAdminToolsEnabled(this.props.urlParams);
			const driveSettingsMenuItems = [];

			if (showDriveVideoAdvancedToggle) {
				driveSettingsMenuItems.push(
					<MenuItem key="drive-advanced-video-options" eventKey="advanced-video-options" onClick={this.handleToggleAdvancedVideoUploadOptions}>
						<FontAwesomeIcon icon={this.state.showAdvancedVideoOptions ? "check-square" : ["far", "square"]} /> Advanced Video Options
					</MenuItem>
				);
			}

			if (canShowDriveReindexAction) {
				if (driveSettingsMenuItems.length > 0) {
					driveSettingsMenuItems.push(<MenuItem key="drive-settings-admin-divider" divider />);
				}

				driveSettingsMenuItems.push(
					<MenuItem key="drive-reindex-search-button" eventKey="reindex-drive" onClick={this.handleReindexDriveSearch} disabled={this.state.driveReindexing}>
						<FontAwesomeIcon icon="sync" /> Reindex Drive
					</MenuItem>
				);
			}

			const showDriveSettingsMenu = driveSettingsMenuItems.length > 0;

		if (edit && !hideActionBar) {
			if (moving || copying) {
				let selectedFolderSameOrigin = false;
				if (moving) {
					if (moveInfo.originParentFolderPath === hierarchy.fullPath) { selectedFolderSameOrigin = true; }
				} else {
					if (copyInfo.originParentFolderPath === hierarchy.fullPath) { selectedFolderSameOrigin = true; }
				}

				buttons.push(
					createMenuComponent(
						moving ? "Move Here" : "Paste Here",
						moving ? "check" : "paste",
						"drive-move-file-drop",
						moving ? this.handleMove : this.handleCopy,
						{
							disabled: hierarchy.type !== "folder" || (hierarchy.hasOwnProperty("allowCreate") && !hierarchy.allowCreate) || selectedFolderSameOrigin,
							bsStyle: "success"
						}
					)
				);
				buttons.push(createMenuComponent("Cancel", "ban", "drive-cancel-move-file", moving ? this.handleCancelMove : this.handleCancelCopy));
			} else {
				const folderAllowCreate = hierarchy.type === "folder" && (!hierarchy.hasOwnProperty("allowCreate") || hierarchy.allowCreate);

				if (folderAllowCreate) {
					buttons.push(createMenuComponent("Create Folder", "folder", "drive-create-folder", this.handleShowCreateFolderModal));

					if (!_.isEmpty(editors)) {
						buttons.push(createMenuComponent("New", "plus-circle", "drive-new-file-button", this.handleStartCreateNewDocument));
					}

					buttons.push(createMenuComponent("Paste", "paste", "drive-paste-clipboard-button", this.handleShowPasteClipboardModal));
					buttons.push(createMenuComponent("Upload File", "upload", "drive-upload-file-button", this.handleShowUploadFile));
					buttons.push(createMenuComponent("Upload Folder", "folder-open", "drive-upload-folder-button", this.handleShowUploadFolder));
				}

					if (cursor) {
						if (cursor.type === "file") {
							buttons.push(createMenuComponent("Download", "download", "drive-download-file-button", this.handleDownloadFile, { bsStyle: "primary" }));
							if (this.canShareSelectedFile(cursor)) {
								buttons.push(createMenuComponent("Share", "share-alt", "drive-share-file-button", this.handleShareFile));
							}
							buttons.push(createMenuComponent("Metadata", "tags", "drive-tags-button", this.handleShowTagsEditor));
							buttons.push(createMenuComponent("Open Location", "folder-open", "drive-open-file-location-button", this.handleOpenFileLocation));
						}

					if (editor && cursor.type === "file") {
						buttons.push(createMenuComponent("Edit", "file-edit", "drive-edit-file-button", this.handleEditDocument));
					}

					if (canEditImage) {
						buttons.push(createMenuComponent("Edit Image", "image", "drive-edit-image-button", this.handleShowImageEditorModal));
					}

					if (canEditVideo) {
						buttons.push(createMenuComponent("Edit Video", "video", "drive-edit-video-button", this.handleShowVideoEditorModal));
					}

					if (!cursor.hasOwnProperty("allowMoveCopyRename") || cursor.allowMoveCopyRename) {
						const renameButton = createMenuComponent("Rename", "pencil", "drive-rename-button", this.handleStartRename);
						buttons.push(
							createMenuComponent("Copy", ["far", "copy"], "drive-copy-button", this.handleStartCopy),
							createMenuComponent("Move", "arrows", "drive-move-button", this.handleStartMove)
						);
						buttons.push(renameButton);
					}

					if (!cursor.hasOwnProperty("allowDelete") || cursor.allowDelete) {
						deleteButton = createMenuComponent("Delete", "times", "drive-delete-button", this.handleDelete, { bsStyle: "danger" });
					}
				}

			}
		} else if (settings.mode === "list" && handleQuickUpload) {
			buttons.push(handleQuickUploadButton);
		}

		if (deleteButton) {
			buttons.push(deleteButton);
		}

		if (inline && this.props.editActivity) {
			const viewActivityDriveRootButton = createMenuComponent("View Activity Root", "hdd", "drive-view-root-button", this.handleSelectActivityDriveRootFolder);
			buttons.push(viewActivityDriveRootButton);
		}

		actionBar =
			buttons && buttons.length > 0
				? !inline
					? (
						<div key="drive-copy-move-operations-group" className="drive-action-bar">
							{buttons}
						</div>
					)
					: (
						<DropdownButton componentClass={InputGroup.Button} noCaret bsStyle="primary" pullRight title={<FontAwesomeIcon icon="ellipsis-v" />}>
							{buttons}
						</DropdownButton>
					)
				: null;

		if (selectionEnabled && selectedDriveItems.length > 0) {
			const selectedItemLabel = selectedDriveItems.length === 1 ? "item" : "items";
			actionBar = (
				<div key="drive-selected-operations-group" className="drive-action-bar drive-selection-action-bar">
					<div className="drive-selection-count">
						{selectedDriveItems.length} selected {selectedItemLabel}
					</div>
					<Button onClick={this.handleClearDriveSelection}>
						<FontAwesomeIcon icon="times" /> <span className="drive-action-label">Clear</span>
					</Button>
					<Button onClick={this.handleSelectVisibleDriveItems} disabled={visibleDriveSelectionItems.length === 0}>
						<FontAwesomeIcon icon="check-square" /> <span className="drive-action-label">Select Visible</span>
					</Button>
					<Button bsStyle="danger" onClick={this.handleDeleteSelectedDriveItems}>
						<FontAwesomeIcon icon="trash" /> <span className="drive-action-label">Delete</span>
					</Button>
				</div>
			);
		}

		const hasBottomActionBar = !inline && !actionBarTop && !!actionBar;

		if (okCancel) {
			okCancelBar = (
				<div className="button-bar">
					<Button bsStyle="danger" onClick={this.handleCancel}>
						<FontAwesomeIcon icon="ban" /> Cancel
					</Button>
					{cursor && (cursor.type === "file" || (folderOnly && cursor.type === "folder")) && (
						<Button bsStyle="success" disabled={!cursor} onClick={this.handleOk}>
							<FontAwesomeIcon icon="check" /> OK
						</Button>
					)}
				</div>
			);
		}

		// ----- Gallery-safe computations -----
		const { galleryImages, galleryIndex } = this.state;
		const inRange = Array.isArray(galleryImages) && galleryIndex >= 0 && galleryIndex < galleryImages.length;
		const currentImage = inRange ? galleryImages[galleryIndex] : null;

		const mediaType = currentImage ? (() => { try { return getMediaType(currentImage.ext); } catch { return null; } })() : null;
		const url = currentImage ? getUrlForExternalResource(currentImage) : null;

			let mediaPreview = null;
		if (!currentImage || !url) {
			mediaPreview = <div>No media selected</div>;
		} else {
			switch (mediaType) {
				case "image":
					mediaPreview = (
						<img
							key={currentImage.guid || currentImage.path || currentImage.name}
							src={url}
							alt={currentImage.name}
							onClick={() => window.open(url, "_blank")}
							className="gallery-image"
						/>
					);
					break;
				case "video":
					mediaPreview = (
						<ReactPlayer
							key={currentImage.guid || currentImage.path || currentImage.name}
							url={url}
							controls
							playing={false}
							muted={false}
							playsInline
							loop={false}
							width="100%"
							height="95%"
							className="gallery-video"
						/>
					);
					break;
				case "audio":
					mediaPreview = (
						<ReactAudioPlayer key={currentImage.guid || currentImage.path || currentImage.name} src={url} controls className="gallery-audio" />
					);
					break;
				case "pdf":
					mediaPreview = (
						<object data={url} type="application/pdf" width="100%" height="90vh" style={{ border: "none" }}>
							<p>
								Your browser doesn't support embedded PDFs.{" "}
								<a href={url} target="_blank" rel="noopener noreferrer">
									Click here to download the file.
								</a>
							</p>
						</object>
					);
					break;
				default:
					mediaPreview = <div>Unsupported media type</div>;
			}
			}

			let videoEditorModal;
			if (this.state.showVideoEditorModal && this.state.videoEditorTarget) {
				const videoEditorTarget = this.state.videoEditorTarget;
				const serverPreviewSource = videoEditorTarget.overwriteTargetPath ? {
					bucket: _.get(env, "s3.assetsBucket", ""),
					key: videoEditorTarget.overwriteTargetPath,
					frameSeconds: 0,
					revision: Number(_.get(videoEditorTarget, "resource.revision")) || 0
				} : null;
				videoEditorModal = (
					<VideoProcessingOptionsModal
						open={this.state.showVideoEditorModal}
						onClose={this.handleCloseVideoEditorModal}
						onContinue={this.handleCreateEditedVideo}
						initialOptions={getStoredVideoProcessingOptions()}
						fileName={videoEditorTarget.videoFileName || videoEditorTarget.label || "video.mp4"}
						previewUrl={videoEditorTarget.url}
						serverPreviewSource={serverPreviewSource}
						videoCount={1}
						allowFileRename
						defaultOutputFileName={videoEditorTarget.defaultOutputFileName}
						allowOverwriteOption={!!videoEditorTarget.overwriteTargetPath}
						overwriteTargetPath={videoEditorTarget.overwriteTargetPath || ""}
						orientationSummary={getDefaultVideoOrientationSummary(1)}
						showEditVideoButton={false}
						deferInitialServerPreview
						closeOnContinue
						title="Edit Video"
						description={<span>Adjust processing options for <b>{videoEditorTarget.videoFileName || videoEditorTarget.label || "video.mp4"}</b>, then save a new Drive video or overwrite the current one.</span>}
						continueLabel="Save Video"
					/>
				);
			}

			let videoProcessingOptionsModal;
			if (this.state.showVideoProcessingOptionsModal) {
					videoProcessingOptionsModal = (
						<VideoProcessingOptionsModal
							open={this.state.showVideoProcessingOptionsModal}
							onClose={this.handleCloseVideoProcessingOptionsModal}
							onContinue={this.handleContinueVideoProcessingOptionsModal}
							initialOptions={getStoredVideoProcessingOptions()}
							fileName={_.get(this.state.pendingUploadFiles, "[0].name", "")}
							previewFile={_.get(this.state.pendingUploadFiles, "[0]", null)}
							videoCount={(Array.isArray(this.state.pendingUploadFiles) ? this.state.pendingUploadFiles.filter((file) => isVideoFileCandidate(file)).length : 0) || 1}
							allowFileRename={(Array.isArray(this.state.pendingUploadFiles) ? this.state.pendingUploadFiles.length : 0) === 1}
							orientationSummary={this.state.pendingUploadOrientationSummary}
						/>
					);
				}

			const deleteDialogSelectionPlan = this.state.deleteDialogSelectionPlan;
			const isDeleteSelectionDialog = !!deleteDialogSelectionPlan;
			const deleteDialogPrimaryItems = isDeleteSelectionDialog
				? (deleteDialogSelectionPlan.selectedItems || [])
				: [this.state.deleteDialogTarget].filter(Boolean);
			const deleteDialogPrimaryCount = isDeleteSelectionDialog
				? deleteDialogSelectionPlan.primaryCount
				: deleteDialogPrimaryItems.length;
			const deleteDialogPrimaryPreviewItems = deleteDialogPrimaryItems.slice(0, 8);
			const deleteDialogPrimaryOverflowCount = Math.max(0, deleteDialogPrimaryItems.length - deleteDialogPrimaryPreviewItems.length);

			return (
				<div className={`ambifi-drive ${inline ? "inline" : "full"} ${hasBottomActionBar ? "has-bottom-action-bar" : ""}`}>
					<input multiple key={"drive-file-upload"} id="drive-upload" type="file" onChange={this.handleSelectUploadFile} style={{ display: "none" }} />
					<input multiple key={"drive-folder-upload"} id="drive-folder-upload" type="file" webkitdirectory="true" directory="true" onChange={this.handleSelectUploadFolder} style={{ display: "none" }} />
					{(!inline && actionBarTop) && actionBar}
					{videoEditorModal}

					<div className="drive-header">
					{!hideSearchInput && (
						<div className="drive-controls">
							<div className="drive-search-control search-input">
								{(getOrgId() === "a25f9e42-23cd-11ec-9068-066917b38554" || getOrgId() === "75a99644-d769-11ec-8330-069463faa5ff" || getOrgId() === "332a9d47-6e36-11e8-a392-061714f61e3e" || getOrgId() === "3c2c0579-2bdc-11e9-a392-061714f61e3e") ? (
									<SearchInput
										resetToken={this.state.searchResetToken}
										onModeChange={(isSearching) =>
											this.setState({
												isSearchMode: isSearching,
												galleryIndex: 0,
												searchImageFiles: [],
												searchVisibleItems: []
											})
										}
									/>
								) : (
									<>
										<span className="drive-search-icon">
											<FontAwesomeIcon icon="search" />
										</span>
										<input
											className="form-control"
											onChange={this.onFilterChange.bind(this)}
											placeholder="Search Drive"
											type="text"
											value={this.state.filter}
										/>
									</>
								)}
							</div>

							<div className="drive-control-actions">
								{driveMultiselectAvailable && (
									<Button
										className={this.state.showDriveMultiselect ? "drive-multiselect-toggle-button selected" : "drive-multiselect-toggle-button"}
										onClick={this.handleToggleDriveMultiselect}
										disabled={this.state.refreshDisabled}
										title={this.state.showDriveMultiselect ? "Hide multiselect" : "Show multiselect"}
									>
										<FontAwesomeIcon icon={this.state.showDriveMultiselect ? "check-square" : ["far", "square"]} /> <span className="drive-action-label">Select</span>
									</Button>
								)}

								<Button
									className="drive-label-toggle-button"
									onClick={this.toggleShowAllLabels}
								>
									{this.state.showAllLabels ? "Hide Labels" : "Show Labels"}
								</Button>

								<Button
									onClick={this.handleShowMetadataReportModal}
									disabled={this.state.refreshDisabled}
									title="Metadata report"
								>
									<FontAwesomeIcon icon="table" />
								</Button>

								{visibleMedia.length > 0 && (
									<Button
										onClick={() => {
											const visibleFiles = this.getVisibleMediaFiles();
											const { selectedNode } = this.state;
											let startIndex = 0;
											if (selectedNode) {
												const matchIndex = visibleFiles.findIndex((node) => node.guid === selectedNode.guid);
												if (matchIndex >= 0) { startIndex = matchIndex; }
											}
											this.openGallery(startIndex);
										}}
										disabled={this.state.refreshDisabled}
										title="Open media gallery"
									>
										<FontAwesomeIcon icon={"images"} />
									</Button>
								)}

								<Button
									onClick={() => this.handleSwitchMode(settings.mode === "tree" ? "list" : "tree")}
									disabled={this.state.refreshDisabled}
									title={settings.mode === "tree" ? "Show tile view" : "Show tree view"}
								>
									<FontAwesomeIcon icon={settings.mode === "tree" ? "th-large" : "folder-tree"} />
								</Button>

								<ButtonGroup className="drive-refresh-group">
									<Button
										onClick={this.handleRefresh}
										disabled={this.state.refreshDisabled}
										title="Refresh current folder"
									>
										<FontAwesomeIcon icon="sync" />
									</Button>
									<Button
										onClick={this.handleRefreshAll}
										disabled={this.state.refreshDisabled}
										title="Refresh entire drive"
									>
										Full
									</Button>
								</ButtonGroup>

								{showDriveSettingsMenu && (
									<DropdownButton
										id={`drive-settings-menu-${this.driveComponentId}`}
										noCaret
										pullRight
										title={<FontAwesomeIcon icon="ellipsis-v" />}
										aria-label="Drive settings"
										disabled={this.state.refreshDisabled}
									>
										{driveSettingsMenuItems}
									</DropdownButton>
								)}

								{inline && actionBar}
							</div>
						</div>
					)}
				</div>

				{this.state.isSearchMode ? (
					<SearchResultsView
						showAllLabels={this.state.showAllLabels}
						onSelect={this.onSelect}
						onDblClick={this.onDblClick}
						acceptType={acceptType}
						driveComponentId={this.driveComponentId}
						scrollParentRef={this.scrollParentRef}
						mode={settings.mode}
						onSearchImageResultsUpdate={(imageFiles) => this.setState({ searchImageFiles: imageFiles ?? [], galleryIndex: 0 })}
						onVisibleItemsUpdate={(items) => this.setState({ searchVisibleItems: items ?? [] })}
						selectionEnabled={selectionEnabled}
						selectedDriveKeys={selectedDriveKeys}
						onToggleSelected={this.handleToggleDriveItemSelected}
						isSelectionAvailable={this.isDriveItemSelectionAvailable}
					/>
				) : (
					<>
						<div className="drive-breadcrumbs">{this.renderBreadcrumbs()}</div>
						<div className="drive-tree-wrapper">
							<div className="drive-tree" style={{ height: "100%" }} ref={(ref) => (this.scrollParentRef = ref)}>
								<DriveContext.Provider value={{ driveComponentId: this.driveComponentId }}>
									<ListView
										showAllLabels={this.state.showAllLabels}
										data={hierarchy}
										onSelect={this.onSelect}
										onDblClick={this.onDblClick}
										mode={settings.mode}
										accept={acceptType}
										scrollParentRef={this.scrollParentRef}
										driveComponentId={this.driveComponentId}
										selectionEnabled={selectionEnabled}
										selectedDriveKeys={selectedDriveKeys}
										onToggleSelected={this.handleToggleDriveItemSelected}
										isSelectionAvailable={this.isDriveItemSelectionAvailable}
									/>
								</DriveContext.Provider>
							</div>
							{settings.mode === "tree" && cursor && cursor.type === "file" && <div className="sticky-preview">{this.renderPreview(cursor)}</div>}
						</div>
					</>
				)}

				<Modal
					open={this.state.showGallery}
					onClose={() => this.setState({ showGallery: false })}
					center
					classNames={{ modal: "photo-gallery-modal" }}
				>
					{this.state.galleryImages.length > 0 && (
						<div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "90vh" }}>
							<div style={{ width: "95vw", textAlign: "center", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
								<Button onClick={this.handlePrevImage}>←</Button>
								{mediaPreview}
								<Button onClick={this.handleNextImage}>→</Button>
							</div>
							<p
								onClick={() => {
									if (url) {
										copyToClipboard(url);
									}
								}}
								title={currentImage?.path || ""}
								style={{ marginTop: "10px", cursor: url ? "pointer" : "default" }}
							>
								{currentImage?.name || ""}
							</p>
						</div>
					)}
				</Modal>

				<Modal open={this.state.showCreateFolderModal} onClose={this.handleCancelAddFolder} classNames={{ modal: "custom-modal" }} closeButton>
					<div>
						<h4>Create Folder</h4>
						<hr />
						<div className="map-modal-body-container">
							<FormGroup controlId="folder-name" validationState={this.state.createFolder && this.state.createFolder.validationState ? this.state.createFolder.validationState : null}>
								<Col componentClass={ControlLabel} sm={12} style={{ textAlign: "left" }}>
									Folder Name
								</Col>
								<Col sm={12}>
									<FormControl onChange={this.handleChangeCreateFolderName} type="text" />
									{this.state.createFolder && this.state.createFolder.validationState !== "success" && (
										<Panel bsStyle="danger">
											<Panel.Heading>{this.state.createFolder.validationError}</Panel.Heading>
										</Panel>
									)}
								</Col>
							</FormGroup>
						</div>
						<div className="modal-footer-container">
							<Button onClick={this.handleCancelAddFolder} style={{ marginRight: "10px" }}>
								Cancel
							</Button>
							<Button disabled={!this.state.createFolder || _.isEmpty(this.state.createFolder.name)} bsStyle="primary" onClick={this.handleAddFolder}>
								OK
							</Button>
						</div>
					</div>
					</Modal>
					<Modal open={this.state.showPasteClipboardModal} onClose={this.handleHidePasteClipboardModal} classNames={{ modal: "custom-modal" }} closeButton>
						<div>
							<h4>Paste Clipboard</h4>
							<hr />
							<div className="map-modal-body-container">
								{this.state.pasteClipboardWaitingForPaste ? (
									<FormGroup controlId="drive-paste-clipboard-target">
										<Col componentClass={ControlLabel} sm={12} style={{ textAlign: "left" }}>
											Clipboard
										</Col>
										<Col sm={12}>
											<div
												ref={this.pasteClipboardTarget}
												contentEditable
												suppressContentEditableWarning
												tabIndex={0}
												style={{
													border: "1px solid #ccc",
													borderRadius: "4px",
													minHeight: "120px",
													padding: "12px",
													outline: "none"
												}}
											>
												Tap here and paste, or press Cmd/Ctrl+V.
											</div>
											<HelpBlock>
												{this.state.pasteClipboardPasteError || "Paste an image, JSON, or text item from the clipboard."}
											</HelpBlock>
										</Col>
									</FormGroup>
								) : (
									<div>
										<FormGroup
											controlId="drive-paste-clipboard-file-name"
											validationState={this.validatePastedClipboardFileName(this.state.pasteClipboardFileName) ? "error" : null}
										>
											<Col componentClass={ControlLabel} sm={12} style={{ textAlign: "left" }}>
												File Name
											</Col>
											<Col sm={12}>
												<FormControl
													autoFocus
													disabled={this.state.pasteClipboardSaving}
													onChange={this.handleChangePasteClipboardFileName}
													type="text"
													value={this.state.pasteClipboardFileName}
												/>
												<HelpBlock>
													{this.validatePastedClipboardFileName(this.state.pasteClipboardFileName) || `Clipboard content will be saved as ${this.state.pasteClipboardContentType === "application/json" ? "JSON" : this.isPasteClipboardImageContentType(this.state.pasteClipboardContentType) ? "image" : "text"}.`}
												</HelpBlock>
											</Col>
										</FormGroup>
										<FormGroup controlId="drive-paste-clipboard-preview">
											<Col componentClass={ControlLabel} sm={12} style={{ textAlign: "left" }}>
												Preview
											</Col>
											<Col sm={12}>
												{this.state.pasteClipboardFile ? (
													<div style={{ border: "1px solid #ddd", borderRadius: "4px", padding: "10px", textAlign: "center" }}>
														{this.state.pasteClipboardPreviewUrl ? (
															<img
																alt="Clipboard preview"
																src={this.state.pasteClipboardPreviewUrl}
																style={{ maxHeight: "320px", maxWidth: "100%", objectFit: "contain" }}
															/>
														) : (
															<div>{this.state.pasteClipboardContentType}</div>
														)}
													</div>
												) : (
													<FormControl
														componentClass="textarea"
														readOnly
														rows={8}
														value={this.state.pasteClipboardText}
													/>
												)}
											</Col>
										</FormGroup>
									</div>
								)}
							</div>
							<div className="modal-footer-container">
								<Button disabled={this.state.pasteClipboardSaving} onClick={this.handleHidePasteClipboardModal} style={{ marginRight: "10px" }}>
									Cancel
								</Button>
								<Button
									disabled={this.state.pasteClipboardSaving || !this.hasPastedClipboardPayload() || !!this.validatePastedClipboardFileName(this.state.pasteClipboardFileName)}
									bsStyle="primary"
									onClick={this.handleCreatePastedClipboardFile}
								>
									{this.state.pasteClipboardSaving ? "Creating..." : "Create File"}
								</Button>
							</div>
						</div>
					</Modal>
					<Modal open={this.state.showUploadFolderOptionsModal} onClose={this.handleCloseUploadFolderOptionsModal} classNames={{ modal: "custom-modal" }} closeButton>
						<div>
							<h4>Upload Folder</h4>
							<hr />
							<div className="map-modal-body-container">
								<div style={{ marginBottom: "12px" }}>
									Select a local folder to upload into the currently selected Drive folder.
								</div>
								<Checkbox checked={this.state.uploadFolderRecursive} onChange={this.handleToggleUploadFolderRecursive}>
									Include subfolders recursively
								</Checkbox>
								<div style={{ color: "#666", marginTop: "8px" }}>
									When unchecked, only files directly inside the selected folder will be uploaded.
								</div>
							</div>
							<div className="modal-footer-container">
								<Button onClick={this.handleCloseUploadFolderOptionsModal} style={{ marginRight: "10px" }}>
									Cancel
								</Button>
								<Button bsStyle="primary" onClick={this.handleBrowseUploadFolder}>
									<FontAwesomeIcon icon="folder-open" /> Select Folder
								</Button>
							</div>
						</div>
					</Modal>
					{videoProcessingOptionsModal}

					<Modal open={this.state.showShareFallbackModal} onClose={this.handleCloseShareFallbackModal} classNames={{ modal: "custom-modal" }} closeButton>
						<div>
							<h4>Share File</h4>
							<hr />
							<div className="map-modal-body-container">
								<div style={{ marginBottom: "12px" }}>
									<b>{this.state.shareFallbackFileName || "Drive file"}</b>
								</div>
								<FormGroup controlId="drive-share-link">
									<ControlLabel>Temporary private link</ControlLabel>
									<FormControl
										type="text"
										readOnly
										value={this.state.shareFallbackUrl}
										onFocus={(event) => event.target.select()}
									/>
									<HelpBlock>This link is signed for the selected Drive file and may expire.</HelpBlock>
								</FormGroup>
							</div>
							<div className="modal-footer-container" style={{ display: "flex", flexWrap: "wrap", gap: "8px", justifyContent: "flex-end" }}>
								<Button onClick={this.handleCopyShareFallbackLink}>
									<FontAwesomeIcon icon="clipboard" /> Copy Link
								</Button>
								<Button onClick={this.handleEmailShareFallbackLink}>
									<FontAwesomeIcon icon="envelope" /> Email Link
								</Button>
								<Button onClick={this.handleOpenShareFallbackLink}>
									<FontAwesomeIcon icon="external-link" /> Open Link
								</Button>
								<Button onClick={this.handleDownloadShareFallbackFile}>
									<FontAwesomeIcon icon="download" /> Download
								</Button>
								<Button onClick={this.handleCloseShareFallbackModal}>
									Close
								</Button>
							</div>
						</div>
					</Modal>

					<Modal open={this.state.showDeleteOptionsModal} onClose={this.handleCloseDeleteOptionsModal} classNames={{ modal: "custom-modal" }} closeButton>
						<div>
							<h4>{isDeleteSelectionDialog ? "Delete Selected Items" : "Delete File"}</h4>
							<hr />
							<div className="map-modal-body-container">
								<div style={{ marginBottom: "12px" }}>
									{isDeleteSelectionDialog
										? <>Are you sure you want to delete <b>{deleteDialogPrimaryCount}</b> selected Drive item{deleteDialogPrimaryCount === 1 ? "" : "s"}?</>
										: <>Are you sure you want to delete <b>{_.get(this.state.deleteDialogTarget, "name", "this file")}</b>?</>
									}
								</div>
								{isDeleteSelectionDialog && deleteDialogPrimaryPreviewItems.length > 0 && (
									<div style={{ maxHeight: "160px", overflowY: "auto", marginBottom: "12px", border: "1px solid #e5e7eb", borderRadius: "8px", padding: "10px", background: "#ffffff" }}>
										{deleteDialogPrimaryPreviewItems.map((item) => (
											<div key={item.key || item.guid || item.fullPath || item.path} style={{ marginBottom: "6px" }}>
												<b>{item.name || item.fileName || item.fullPath || item.path}</b>
												<div style={{ color: "#6b7280", fontSize: "12px" }}>{item.type === "folder" ? "Folder" : "File"}</div>
											</div>
										))}
										{deleteDialogPrimaryOverflowCount > 0 && (
											<div style={{ color: "#6b7280", fontSize: "12px" }}>
												+{deleteDialogPrimaryOverflowCount} more
											</div>
										)}
									</div>
								)}
								{this.state.deleteDialogRelatedItems.length > 0 && (
									<div style={{ border: "1px solid #e5e7eb", borderRadius: "8px", padding: "12px", background: "#fafafa" }}>
										<label style={{ display: "flex", alignItems: "flex-start", gap: "8px", cursor: "pointer", marginBottom: "10px" }}>
											<input
												type="checkbox"
												checked={this.state.deleteDialogDeleteRelated === true}
												onChange={this.handleToggleDeleteRelated}
												style={{ marginTop: "2px" }}
											/>
											<span>
												<b>Also delete generated child files</b>
												<div style={{ color: "#6b7280", fontSize: "12px", marginTop: "4px" }}>
													{isDeleteSelectionDialog ? "The selected files have" : "This file has"} {this.state.deleteDialogRelatedItems.length} related generated file{this.state.deleteDialogRelatedItems.length === 1 ? "" : "s"} that can be removed with {isDeleteSelectionDialog ? "them" : "it"}.
												</div>
											</span>
										</label>
										<div style={{ maxHeight: "220px", overflowY: "auto", paddingLeft: "24px" }}>
											{this.state.deleteDialogRelatedItems.map((item) => (
												<div key={item.guid} style={{ marginBottom: "8px" }}>
													<div><b>{item.name}</b></div>
													<div style={{ color: "#6b7280", fontSize: "12px" }}>{this.getDeleteRelatedItemLabel(item)}</div>
												</div>
											))}
										</div>
									</div>
								)}
							</div>
							<div className="modal-footer-container">
								<Button onClick={this.handleCloseDeleteOptionsModal} style={{ marginRight: "10px" }}>
									Cancel
								</Button>
								<Button bsStyle="danger" onClick={this.handleConfirmDeleteOptions}>
									{isDeleteSelectionDialog
										? this.state.deleteDialogDeleteRelated && this.state.deleteDialogRelatedItems.length > 0 ? "Delete Selected + Children" : "Delete Selected"
										: this.state.deleteDialogDeleteRelated && this.state.deleteDialogRelatedItems.length > 0 ? "Delete File + Children" : "Delete File"}
								</Button>
							</div>
						</div>
					</Modal>

					<Modal open={!!this.state.renaming} onClose={this.handleCancelRename} classNames={{ modal: "custom-modal" }} closeButton>
						<div>
							<h4>Rename</h4>
						<hr />
						<div className="map-modal-body-container">
							<FormGroup controlId="folder-name" validationState={this.state.createFolder && this.state.createFolder.validationState ? this.state.createFolder.validationState : null}>
								<Col componentClass={ControlLabel} sm={12} style={{ textAlign: "left" }}>
									<i>{this.state.rename.name}</i> to:
								</Col>
								<Col sm={12}>
									<div style={{ display: "flex", alignItems: "center" }}>
										<FormControl
											autoFocus
											onFocus={(e) => {
												const value = e.target.value;
												if (!value) { return; }
												const indexPeriod = value.lastIndexOf(".");
												if (indexPeriod > -1) {
													e.target.setSelectionRange(0, indexPeriod);
												} else {
													e.target.select();
												}
											}}
											style={{ flex: 1, marginRight: "10px" }}
											value={this.state.rename.fileName}
											onChange={this.handleChangeNameRename}
											type="text"
										/>
										<div></div>
									</div>
								</Col>
							</FormGroup>
						</div>
						<div className="modal-footer-container">
							<Button onClick={this.handleCancelRename} style={{ marginRight: "10px" }}>
								Cancel
							</Button>
							<Button disabled={!this.state.rename || _.isEmpty(this.state.rename.fileName)} bsStyle="primary" onClick={this.handleRename}>
								Rename
							</Button>
							</div>
						</div>
					</Modal>

					<DriveMetadataReportModal
						open={!!this.state.showMetadataReportModal}
						onClose={this.handleHideMetadataReportModal}
						items={metadataReportRows}
						onEditMetadata={this.handleEditMetadataReportResource}
						onRefreshAll={this.handleRefreshMetadataReport}
						scope={this.state.metadataReportScope}
						scopeLabel={this.getMetadataReportScopeLabel()}
						includeSubfolders={this.state.metadataReportIncludeSubfolders}
						includeFilesWithoutMetadata={this.state.metadataReportIncludeFilesWithoutMetadata}
						onScopeChange={this.handleMetadataReportScopeChange}
						onIncludeSubfoldersChange={this.handleMetadataReportIncludeSubfoldersChange}
						onIncludeFilesWithoutMetadataChange={this.handleMetadataReportIncludeFilesWithoutMetadataChange}
						refreshDisabled={this.state.refreshDisabled || this.state.metadataReportLoading}
						loading={this.state.metadataReportLoading}
					/>

					<DriveMetadataEditorModal
						open={!!this.state.showTagsModal}
						onClose={this.handleHideTagsEditor}
						targetName={metadataEditorTarget?.name || "selected file"}
						previewUrl={metadataEditorTarget ? getUrlForExternalResource(metadataEditorTarget) : ""}
						previewType={getDriveResourceMediaType(metadataEditorTarget) || this.getCursorMediaType(metadataEditorTarget)}
						galleryItems={metadataGalleryItems}
						galleryIndex={metadataGalleryIndex}
						saving={this.state.tagsEditorSaving}
						metadataGeneratingField={this.state.metadataGeneratingField}
						title={this.state.metadataEditorTitle}
						description={this.state.metadataEditorDescription}
						transcript={this.state.metadataEditorTranscript}
						transcriptVtt={this.state.metadataEditorTranscriptVtt}
						primaryTags={this.state.tagsEditorPrimary}
						secondaryTags={this.state.tagsEditorSecondary}
						tagsInput={this.state.tagsEditorInput}
						transcriptProvider={this.state.metadataTranscriptProvider}
						tagsProvider={this.state.metadataTagsProvider}
						onTitleChange={this.handleMetadataTitleChange}
						onDescriptionChange={this.handleMetadataDescriptionChange}
						onTranscriptChange={this.handleMetadataTranscriptChange}
						onTranscriptVttChange={this.handleMetadataTranscriptVttChange}
						onTagsInputChange={this.handleTagsInputChange}
						onAddTags={this.handleAddInputTags}
						onRemovePrimaryTag={this.handleRemovePrimaryTag}
						onPromoteSecondaryTag={this.handlePromoteSecondaryTag}
						onPromoteAllSecondaryTags={this.handlePromoteAllSecondaryTags}
						onTranscriptProviderChange={this.handleMetadataTranscriptProviderChange}
						onTagsProviderChange={this.handleMetadataTagsProviderChange}
						onGallerySelect={this.handleMetadataGallerySelect}
						onGenerateTitle={this.handleGenerateMetadataTitle}
						onGenerateDescription={this.handleGenerateMetadataDescription}
						onGenerateTranscript={this.handleGenerateMetadataTranscript}
						onGenerateTranscriptVtt={this.handleGenerateMetadataTranscriptVtt}
						onGenerateTags={this.handleGenerateMetadataTags}
						onSaveAndPrevious={() => this.handleSaveTagsAndNavigate(-1)}
						onSaveAndNext={() => this.handleSaveTagsAndNavigate(1)}
						onSave={this.handleSaveTags}
					/>

				{editing && (
						<Modal open={editing} onClose={this.handleCancelEditDocument} classNames={{ modal: _.compact(["custom-modal", "templates", this.state.captureNewDocumentInfo ? "new-document-modal" : "", _.get(editor, "modalClassName", "")]).join(" ") }} closeButton>
						{this.state.captureNewDocumentInfo ? (
							<div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
								<div style={{ flex: 0 }}>
									<h3>New Document</h3>
									<hr />
								</div>

								<div className="map-modal-body-container" style={{ flex: 1, overflowY: "auto" }}>
									<FieldGroup id="formControlsDocumentName" type="text" label="Document Name" placeholder={editName} onChange={this.handleSetStartCreateNewDocumentName} />
									<FormGroup>
										<ControlLabel>Select Document Type</ControlLabel>
										<FormControl
											componentClass="select"
											value={editTypeKey}
											onChange={(event) => {
												const nextEditorKey = _.get(event, "target.value", "");
												const nextEditor = nextEditorKey && editors ? editors[nextEditorKey] : null;
												this.handleSetStartCreateNewDocumentType(nextEditor);
											}}
										>
											<option value="">Select a document type...</option>
											{editors && _.map(createableEditorKeys, (editorKey) => {
												const editorDef = editors[editorKey];
												return (
													<option key={editorKey} value={editorKey}>
														{editorDef.title}
													</option>
												);
											})}
										</FormControl>
									</FormGroup>
								</div>

								<div className="modal-footer-container space-between" style={{ flex: 0 }}>
									<Button onClick={this.handleCancelEditDocument} style={{ marginRight: "10px" }}>
										<FontAwesomeIcon icon="ban" /> Cancel
									</Button>
									<Button bsStyle="primary" onClick={this.handleEditNewDocument}>
										<FontAwesomeIcon icon="check" /> Ok
									</Button>
								</div>
							</div>
						) : (
							<div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
								<div style={{ flex: 0 }}>
									<h3>Edit</h3>
									<hr />
								</div>
								<div className="map-modal-body-container" style={{ flex: 1, overflowY: "auto" }}>
									{editor?.component && <editor.component ref={this.currentEditor} onChange={this.handleEditorContentChange} onValidityChange={this.handleEditorContentValidityChange} content={editingContent} />}
								</div>
								<div className="modal-footer-container space-between" style={{ flex: 0 }}>
									<Button onClick={this.handleCancelEditDocument}>
										<FontAwesomeIcon icon="ban" /> Cancel
									</Button>
									<Button bsStyle="primary" onClick={this.handleSave} disabled={validity && !validity.valid}>
										<FontAwesomeIcon icon="save" /> Save
									</Button>
								</div>
							</div>
						)}
					</Modal>
				)}

				{this.state.showImageEditorModal && this.state.imageEditorTarget && (
					<ImageEditorModal
						open={this.state.showImageEditorModal}
						onClose={this.handleCloseImageEditorModal}
						onCreate={this.handleCreateEditedImage}
						imageUrl={this.state.imageEditorTarget.url}
						driveObjectGuid={this.state.imageEditorTarget.driveObjectGuid}
						imageLabel={this.state.imageEditorTarget.label}
						defaultBaseName={this.state.imageEditorTarget.defaultBaseName}
						originalImageName={this.state.imageEditorTarget.originalImageName}
						overwriteTargetPath={this.state.imageEditorTarget.overwriteTargetPath}
						urlParams={this.props.urlParams}
					/>
				)}

				<div className={`drive-footer ${hasBottomActionBar ? "drive-footer-has-action-bar" : ""}`}>
					{!inline && !actionBarTop && actionBar}
					{okCancelBar}
				</div>

				<AmbifiLoader show={showSpinnerFlag} fullPage={!inline} panel={inline} />
			</div>
		);
	}

	async UNSAFE_componentWillMount() {
		showSpinner();
	}

	async componentDidMount() {
		const { lastActiveGuid, hierarchyActiveTreeCursor } = this.props;

		if (!this.props.hierarchy) {
			await listDrive();
		} else if (this.props.hierarchy && this.props.hierarchy.fullPath !== this.props.selectedFolder) {
			await listDriveForSelectedFolder();
		}

		if (lastActiveGuid && !hierarchyActiveTreeCursor) {
			setActiveTreeCursorForDriveGuid(lastActiveGuid);
		}

		hideSpinner();

		setTimeout(() => {
			this.setState({ driveInitialized: true });
		});
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (nextProps.activeCursor) {
			const currentCursor = this.state.cursor;
			const nextCursor = nextProps.activeCursor;
			const shouldSyncCursor =
				!currentCursor ||
				nextCursor.guid !== currentCursor.guid ||
				(Number(nextCursor.revision) || 0) !== (Number(currentCursor.revision) || 0) ||
				`${nextCursor.path || ""}` !== `${currentCursor.path || ""}` ||
				!_.isEqual(nextCursor.metaData || {}, currentCursor.metaData || {});

			if (shouldSyncCursor) {
				this.setState({ cursor: nextCursor });
			}
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.driveInitialized === true && prevState.driveInitialized === false) {
			this.scrollSelectedItemIntoView();
		}

		if (this.props.settings?.mode !== prevProps.settings?.mode) {
			this.scrollSelectedItemIntoView();
		}

		if (this.state.showMetadataReportModal && this.props.selectedFolder !== prevProps.selectedFolder) {
			this.updateMetadataReportRows();
		}

		// keep gallery index in range if images set changes
		if (this.state.galleryImages !== prevState.galleryImages) {
			const len = this.state.galleryImages?.length || 0;
			if (len === 0 && prevState.galleryImages?.length > 0) {
				this.setState({ galleryIndex: 0 });
			} else if (this.state.galleryIndex >= len) {
				this.setState({ galleryIndex: 0 });
			}
		}

		if (this.state.processingUploads !== prevState.processingUploads && _.isEmpty(this.state.processingUploads)) {
			this.stopVideoProcessingPoll();
		}

		if (this.state.showPasteClipboardModal && !prevState.showPasteClipboardModal) {
			this.addPasteClipboardDocumentListener();
			if (this.state.pasteClipboardWaitingForPaste) {
				this.focusPasteClipboardTarget();
			}
		} else if (!this.state.showPasteClipboardModal && prevState.showPasteClipboardModal) {
			this.removePasteClipboardDocumentListener();
		}
	}

	componentWillUnmount() {
		this.stopVideoProcessingPoll();
		this.removePasteClipboardDocumentListener();
		this.revokePasteClipboardPreviewUrl();
	}

	scrollDriveNodeIntoView(guid, attemptsRemaining = 10) {
		if (!guid || typeof window === "undefined" || !window.document) {
			return;
		}

		const el = window.document.getElementById(`drive-node-${this.driveComponentId}-${guid}`);
		if (el) {
			el.scrollIntoView({ block: "center", inline: "nearest" });
			return;
		}

		if (attemptsRemaining <= 0) {
			return;
		}

		const schedule = window.requestAnimationFrame
			? (callback) => window.requestAnimationFrame(callback)
			: (callback) => window.setTimeout(callback, 16);
		schedule(() => this.scrollDriveNodeIntoView(guid, attemptsRemaining - 1));
	}

	scrollSelectedItemIntoView(guid = this.props.lastActiveGuid) {
		this.scrollDriveNodeIntoView(guid);
	}
}

export default branch(
	{
		hierarchy: ["drive", "hierarchy"],
		settings: ["drive", "settings"],
		showSpinner: ["drive", "showSpinner"],
		activeCursor: ["drive", "hierarchyActiveCursor"],
		editors: ["driveEditors", "editors"],
		filter: ["drive", "filter"],
		selectedFolder: ["drive", "selectedFolder"],
		driveSelection: ["drive", "selection"],
		lastActiveGuid: ["drive", "lastActiveGuid"],
		hierarchyActiveTreeCursor: ["drive", "hierarchyActiveCursor"],
		editActivity: ["tree", "root", "entity"],
		urlParams: ["appState", "urlParams"]
	},
	Drive
);
